/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum AcrCategory {
  ASSUMPTION = "ASSUMPTION",
  CONSTRAINT = "CONSTRAINT",
  RISK = "RISK",
}

export enum AcrProbability {
  HIGH = "HIGH",
  LOW = "LOW",
  MEDIUM = "MEDIUM",
  VERY_HIGH = "VERY_HIGH",
  VERY_LOW = "VERY_LOW",
}

export enum AcrSeverity {
  CRITICAL = "CRITICAL",
  HIGH = "HIGH",
  LOW = "LOW",
  MEDIUM = "MEDIUM",
}

export enum AcrStatus {
  ACCEPTED = "ACCEPTED",
  CLOSED = "CLOSED",
  MITIGATED = "MITIGATED",
  OPEN = "OPEN",
}

export interface AdminBlockUserDto {
  /** Optional reason for blocking the user */
  reasonBlocked?: string;
}

export interface AdminCategoriesSelectDto {
  categories: AdminCategorySelectListDto[];
  pagination: BasePaginationDto;
}

export enum AdminCategoriesSortField {
  HIERARCHY = "HIERARCHY",
  NAME = "NAME",
  PARENT = "PARENT",
  STATUS = "STATUS",
}

export enum AdminCategoriesSortOrder {
  ASC = "ASC",
  DESC = "DESC",
}

export enum AdminCategoriesTypeFilter {
  ALL = "ALL",
  MAIN = "MAIN",
  SUB = "SUB",
}

export interface AdminCategoryCreateDto {
  /** @maxLength 500 */
  description?: string;
  /**
   * @minLength 2
   * @maxLength 60
   */
  name: string;
  /** Optional parent category identifier. Set to null to clear. */
  parentCategoryId?: string | null;
  /** List of category IDs that should become subcategories. */
  subcategories?: string[];
}

export interface AdminCategoryDependencyCountsDto {
  expertProfilesCount: number;
  missionAssessmentIntersCount: number;
  missionAssessmentsCount: number;
  subsystemsCount: number;
  technologiesCount: number;
  userProfilesCount: number;
}

export interface AdminCategorySelectDto {
  archived: boolean;
  /** @format date-time */
  archivedAt?: string;
  dependencyCounts: AdminCategoryDependencyCountsDto;
  description?: string;
  /** @format uuid */
  id: string;
  name: string;
  parentCategory?: CategoryNestedSelectDto;
  subcategories?: AdminCategorySubcategoryDto[];
  totalDependencies: number;
  /** @format date-time */
  updatedAt: string;
}

export interface AdminCategorySelectListDto {
  archived: boolean;
  description?: string;
  /** @format uuid */
  id: string;
  name: string;
  parentCategory?: CategoryNestedSelectDto;
}

export interface AdminCategoryStatusUpdateDto {
  archived: boolean;
}

export interface AdminCategorySubcategoryDto {
  archived: boolean;
  /** @format date-time */
  archivedAt?: string;
  description?: string;
  /** @format uuid */
  id: string;
  name: string;
  totalDependencies: number;
  /** @format date-time */
  updatedAt: string;
}

export interface AdminCategoryUpdateDto {
  /** @maxLength 500 */
  description?: string;
  /**
   * @minLength 2
   * @maxLength 60
   */
  name: string;
  /** Optional parent category identifier. Set to null to clear. */
  parentCategoryId?: string | null;
  /** List of category IDs that should become subcategories. */
  subcategories?: string[];
}

export interface AdminCompaniesResponseDto {
  companies: AdminCompanySelectDto[];
  pagination: BasePaginationDto;
}

export interface AdminCompanyDetailDto {
  childOrganizations: AdminParentOrganizationSelectDto[];
  city?: string;
  companyTags: TagSelectDto[];
  country?: string;
  /** @format date-time */
  createdAt: string;
  deleted?: boolean;
  /** @format date-time */
  deletedAt?: string;
  description?: string;
  featureFlags: CompanyFeatureFlag[];
  /** @format uuid */
  id: string;
  implicitTags: ImplicitTagDto[];
  /** @format boolean */
  isParentOrganization: boolean;
  logoUrl?: string;
  name: string;
  parentOrganization?: AdminParentOrganizationSelectDto;
  /** @format uuid */
  parentOrganizationId?: object;
  slug?: string | null;
  state?: string;
  type: CompanyType;
  userCount: number;
  users: AdminCompanyUserDto[];
  yearFounded?: number;
}

export interface AdminCompanyHierarchyOptionsDto {
  childOrganizations: AdminParentOrganizationSelectDto[];
  parentOrganizations: AdminParentOrganizationSelectDto[];
}

export interface AdminCompanySelectDto {
  companyTags: TagSelectDto[];
  /** @format date-time */
  createdAt: string;
  deleted?: boolean;
  /** @format date-time */
  deletedAt?: string;
  featureFlags: CompanyFeatureFlag[];
  /** @format uuid */
  id: string;
  implicitTags: ImplicitTagDto[];
  /** @format boolean */
  isParentOrganization: boolean;
  logoUrl?: string;
  name: string;
  /** @format uuid */
  parentOrganizationId?: object;
  slug?: string | null;
  type: CompanyType;
  userCount: number;
}

export interface AdminCompanyUserDto {
  avatarUrl?: string;
  email: string;
  fullName?: string;
  id: string;
  persona?: IntelligencePersona | null;
  role: UserCompanyRole;
  /** @format uuid */
  userCompanyId: string;
}

export interface AdminCreateOrganizationDto {
  /** @format string */
  city?: string;
  /** @format string */
  country?: string;
  /**
   * @format string
   * @maxLength 2000
   */
  description?: string;
  featureFlags?: CompanyFeatureFlag[];
  name: string;
  /** @format string */
  state?: string;
  type: CompanyType;
  urls?: CompanyUrlsDto;
}

export interface AdminDomainCreateDto {
  /**
   * @minLength 2
   * @maxLength 60
   */
  name: string;
  /** Optional parent domain identifier. Set to null to clear. */
  parentDomainId?: string | null;
}

export interface AdminDomainDependencyCountsDto {
  assessmentsCount: number;
  missionAssessmentTechnologyUseDomainsCount: number;
  surveyUseDomainsCount: number;
  technologyUseDomainsCount: number;
}

export interface AdminDomainParentSelectDto {
  archived: boolean;
  /** @format uuid */
  id: string;
  name: string;
}

export interface AdminDomainSelectDto {
  archived: boolean;
  /** @format date-time */
  archivedAt?: string;
  dependencyCounts: AdminDomainDependencyCountsDto;
  /** @format uuid */
  id: string;
  name: string;
  parentDomain?: AdminDomainParentSelectDto;
  subdomains?: AdminDomainSubdomainDto[];
  totalDependencies: number;
  /** @format date-time */
  updatedAt: string;
}

export interface AdminDomainSelectListDto {
  archived: boolean;
  /** @format uuid */
  id: string;
  name: string;
  parentDomain?: AdminDomainParentSelectDto;
  /** @format date-time */
  updatedAt: string;
}

export interface AdminDomainStatusUpdateDto {
  archived: boolean;
}

export interface AdminDomainSubdomainDto {
  archived: boolean;
  /** @format date-time */
  archivedAt?: string;
  /** @format uuid */
  id: string;
  name: string;
  totalDependencies: number;
  /** @format date-time */
  updatedAt: string;
}

export interface AdminDomainUpdateDto {
  /**
   * @minLength 2
   * @maxLength 60
   */
  name: string;
  /** Optional parent domain identifier. Set to null to clear. */
  parentDomainId?: string | null;
  /** List of domain IDs that should become subdomains. */
  subdomains?: string[];
}

export interface AdminDomainsSelectDto {
  domains: AdminDomainSelectListDto[];
  pagination: BasePaginationDto;
}

export enum AdminDomainsSortField {
  HIERARCHY = "HIERARCHY",
  NAME = "NAME",
  PARENT = "PARENT",
  STATUS = "STATUS",
}

export enum AdminDomainsSortOrder {
  ASC = "ASC",
  DESC = "DESC",
}

export enum AdminDomainsTypeFilter {
  ALL = "ALL",
  MAIN = "MAIN",
  SUB = "SUB",
}

export interface AdminLlmLogsResponseDto {
  logs: LlmLogSelectDto[];
  pagination: BasePaginationDto;
}

export interface AdminLlmPromptTemplateDetailDto {
  activeVersion: number;
  category: string;
  codeDefaultModel: LlmModel;
  defaultModel: LlmModel;
  defaultTemplate: string;
  description: string;
  generationType: LlmGenerationType;
  isOverridden: boolean;
  isStructuredOutput: boolean;
  key: string;
  resolvedModel: LlmModel;
  supportsDefaultModelOverride: boolean;
  template: string;
  title: string;
  /** @format date-time */
  updatedAt?: string;
  updatedByUser?: UserNestedSelectDto;
  updatedByUserId?: string;
  variables: LlmPromptTemplateVariableSelectDto[];
  version: number;
  versions: AdminLlmPromptTemplateVersionSelectDto[];
}

export interface AdminLlmPromptTemplateSelectDto {
  activeVersion: number;
  category: string;
  codeDefaultModel: LlmModel;
  defaultModel: LlmModel;
  defaultTemplate: string;
  description: string;
  generationType: LlmGenerationType;
  isOverridden: boolean;
  isStructuredOutput: boolean;
  key: string;
  resolvedModel: LlmModel;
  supportsDefaultModelOverride: boolean;
  template: string;
  title: string;
  /** @format date-time */
  updatedAt?: string;
  updatedByUser?: UserNestedSelectDto;
  updatedByUserId?: string;
  variables: LlmPromptTemplateVariableSelectDto[];
  version: number;
}

export interface AdminLlmPromptTemplateVersionActivateDto {
  version: number;
}

export interface AdminLlmPromptTemplateVersionCreateDto {
  baseVersion: number;
  defaultModel?: LlmModel;
  template: string;
}

export interface AdminLlmPromptTemplateVersionSelectDto {
  isActive: boolean;
  /** @format date-time */
  updatedAt?: string;
  updatedByUser?: UserNestedSelectDto;
  updatedByUserId?: string;
  version: number;
}

export interface AdminLlmPromptTemplatesSelectDto {
  templates: AdminLlmPromptTemplateSelectDto[];
}

export interface AdminParentOrganizationSelectDto {
  deleted?: boolean;
  /** @format uuid */
  id: string;
  /** @format boolean */
  isParentOrganization: boolean;
  logoUrl?: string;
  name: string;
  /** @format uuid */
  parentOrganizationId?: object;
  type: CompanyType;
}

export interface AdminParentOrganizationsSelectDto {
  organizations: AdminParentOrganizationSelectDto[];
}

export interface AdminSetAccessWindowDto {
  /**
   * ISO 8601 date string or null to remove expiration
   * @format date-time
   */
  accessExpiredAt?: string | null;
}

export interface AdminSetMemberRoleDto {
  role: UserCompanyRole;
}

export interface AdminUpdateCompanyFeatureFlagsDto {
  featureFlags: CompanyFeatureFlag[];
}

export interface AdminUpdateCompanyHierarchyDto {
  childOrganizationIds: any[][];
  /** @format boolean */
  isParentOrganization: boolean;
  /** @format uuid */
  parentOrganizationId?: object;
}

export interface AdminUpdateCompanySlugDto {
  /** Unique slug for company identification. Only alphanumeric, hyphens, underscores. */
  slug?: string | null;
}

export interface AdminUpdateCompanyTagsDto {
  /** Array of tag names to assign to the company */
  tags: string[];
}

export interface AdminUpdateUserAccessControlsDto {
  /**
   * Organization IDs explicitly blocked by access controls
   * @maxItems 20
   */
  organizationBlacklist?: string[];
  /**
   * Organization IDs explicitly allowed by access controls
   * @maxItems 20
   */
  organizationWhitelist?: string[];
  /** Array of tag names to assign to the user (INTEL and EXPERT users only) */
  tags: string[];
}

export interface AdminUpdateUserFeatureFlagsDto {
  /** Array of feature flags to assign to the user */
  featureFlags: UserFeatureFlag[];
}

export interface AdminUseCreateDto {
  /** @maxLength 500 */
  description?: string;
  /**
   * @minLength 2
   * @maxLength 60
   */
  name: string;
}

export interface AdminUseDependencyCountsDto {
  assessmentsCount: number;
  missionAssessmentEffectsCount: number;
  missionAssessmentRequestsCount: number;
  missionAssessmentTechnologyUsesCount: number;
  questionFiltersCount: number;
  surveyUseDomainsCount: number;
  technologyUsesCount: number;
}

export interface AdminUseSelectDto {
  archived: boolean;
  /** @format date-time */
  archivedAt?: string;
  /** @format date-time */
  createdAt: string;
  dependencyCounts: AdminUseDependencyCountsDto;
  /** @format string */
  description?: string;
  /** @format uuid */
  id: string;
  /** @format string */
  name: string;
  totalDependencies: number;
  /** @format date-time */
  updatedAt: string;
}

export interface AdminUseSelectListDto {
  archived: boolean;
  /** @format string */
  description?: string;
  /** @format uuid */
  id: string;
  /** @format string */
  name: string;
  /** @format date-time */
  updatedAt: string;
}

export interface AdminUseStatusUpdateDto {
  archived: boolean;
}

export interface AdminUseUpdateDto {
  /** @maxLength 500 */
  description?: string;
  /**
   * @minLength 2
   * @maxLength 60
   */
  name: string;
}

export interface AdminUserCompanyDto {
  company?: AdminUserCompanyNestedDto;
  persona?: IntelligencePersona | null;
  role?: string;
}

export interface AdminUserCompanyNestedDto {
  companyTags?: AdminUserCompanyTagDto[];
  id?: string;
  implicitTags?: ImplicitTagDto[];
  name?: string;
  type?: CompanyType;
}

export interface AdminUserCompanyTagDto {
  id: string;
  name: string;
}

export interface AdminUserDetailDto {
  /** @format date-time */
  accessExpiredAt?: string | null;
  approved: boolean;
  /** @format string */
  avatarUrl?: string;
  company?: CompanySelectDto;
  /** @format date-time */
  createdAt: string;
  /** Effective feature flags (user personal flags + company flags) */
  effectiveFeatureFlags: UserFeatureFlag[];
  /** @format email */
  email: string;
  emailVerified: boolean;
  expertProfile?: AdminUserDetailExpertProfileDto;
  /** User personal feature flags (ORG_SWITCHER, etc.) */
  featureFlags: UserFeatureFlag[];
  hasAccessExpired: boolean;
  hasValidAccess: boolean;
  /** @format uuid */
  id: string;
  identities?: AdminUserIdentityDto[];
  /** Organization IDs explicitly blocked by access controls */
  organizationBlacklist?: string[];
  /** Organization IDs explicitly allowed by access controls */
  organizationWhitelist?: string[];
  profile?: UserProfileSelectDto;
  reasonBlocked?: string;
  status: UserStatus;
  userCompanies?: AdminUserCompanyDto[];
  /** User tags (only for INTEL and EXPERT users) */
  userTags?: AdminUserCompanyTagDto[];
}

export interface AdminUserDetailExpertProfileDto {
  categories?: CategoryNestedSelectDto[];
  countryOfService?: string;
  service?: ServiceSubSelectDto;
}

export interface AdminUserIdentityDto {
  /** @format date-time */
  createdAt: string;
  id: string;
  identifier: string;
  type: string;
}

export interface AdminUserSelectDto {
  /** @format date-time */
  accessExpiredAt?: string | null;
  approved: boolean;
  /** @format string */
  avatarUrl?: string;
  companies?: UserCompanySelectDto[];
  /** @format date-time */
  createdAt: string;
  /** @format email */
  email: string;
  emailVerified: boolean;
  expertProfile?: ExpertProfileSelectDto;
  hasAccessExpired: boolean;
  hasValidAccess: boolean;
  /** @format uuid */
  id: string;
  profile?: UserProfileSelectDto;
  status: UserStatus;
}

export interface AdminUsersResponseDto {
  pagination: BasePaginationDto;
  users: AdminUserSelectDto[];
}

export interface AdminUsesSelectDto {
  pagination: BasePaginationDto;
  uses: AdminUseSelectListDto[];
}

export enum AdminUsesSortField {
  NAME = "NAME",
  STATUS = "STATUS",
}

export enum AdminUsesSortOrder {
  ASC = "ASC",
  DESC = "DESC",
}

export enum AiProvenanceState {
  AI_ASSISTED = "AI_ASSISTED",
}

export interface AnswerAdditionalDataDto {
  costEstimate?: number;
  timeSpent?: number;
  timeUnit?: AnswerAdditionalDataDtoTimeUnitEnum;
}

export enum AnswerAdditionalDataDtoTimeUnitEnum {
  DAY = "DAY",
  HOUR = "HOUR",
  MONTH = "MONTH",
  WEEK = "WEEK",
  YEAR = "YEAR",
}

export interface AnswerNestedSelectDto {
  additionalData?: AnswerAdditionalDataDto;
  details?: string;
  /** @format uuid */
  id: string;
  /** @format uuid */
  questionId: string;
  response?: string;
  /** @format uuid */
  sectionId: string;
  /** @format uuid */
  surveyId: string;
}

export interface AnswerPatchDto {
  additionalData?: AnswerAdditionalDataDto;
  details?: string;
  /** @format uuid */
  questionId: string;
  response?: string;
  /** @format uuid */
  sectionId: string;
  /** @format uuid */
  surveyId: string;
}

export enum AnswerResponseProgress {
  IN_PROGRESS = "IN_PROGRESS",
  NO = "NO",
  NOT_APPLICABLE = "NOT_APPLICABLE",
  YES = "YES",
}

export interface AnswerSelectDto {
  additionalData?: AnswerAdditionalDataDto;
  details?: string;
  /** @format uuid */
  id: string;
  /** @format uuid */
  questionId: string;
  response?: string;
  /** @format uuid */
  sectionId: string;
  /** @format uuid */
  skipToQuestionId?: string;
  /** @format uuid */
  surveyId: string;
}

export interface AssessmentHistorySelectDto {
  mrlTimeline: MRLAssessmentHistoryItem[];
  trlTimeline: TRLAssessmentHistoryItem[];
  trlTimelineByUseDomain: TrlTimelineByUseDomainItem[];
}

export interface AssessmentNestedSelectDto {
  /** @format date */
  assessmentDate?: string;
  /** @format date-time */
  createdAt: string;
  featured: boolean;
  /** @format uuid */
  id: string;
  score: number;
  subtype: AssessmentSubtype;
  type: AssessmentType;
}

export interface AssessmentSelectDto {
  /** @format date */
  assessmentDate?: string;
  /** @format date-time */
  createdAt: string;
  domain: DomainSelectDto;
  featured: boolean;
  /** @format uuid */
  id: string;
  latestTrlAnalysis?: TechnologyTrlAnalysisNestedSelectDto;
  score: number;
  subtype: AssessmentSubtype;
  /** @format uuid */
  surveyId?: string;
  surveyStatus?: SurveyStatus;
  /** @format uuid */
  technologyId: string;
  type: AssessmentType;
  use: UseSelectDto;
}

export enum AssessmentSubtype {
  MILITARY = "MILITARY",
  SELF_REPORTED = "SELF_REPORTED",
}

export enum AssessmentType {
  CYBER = "CYBER",
  MRL = "MRL",
  TRL = "TRL",
}

export interface AssessmentsSelectDto {
  assessments: AssessmentSelectDto[];
}

export enum AttachmentCategory {
  GENERAL = "GENERAL",
  LOGO = "LOGO",
  RESEARCH_ARTEFACT = "RESEARCH_ARTEFACT",
  TECHNOLOGY_IMAGE = "TECHNOLOGY_IMAGE",
}

export interface AttachmentCreateFileDto {
  category: AttachmentCategory;
  contentType?: string;
  description?: string;
  /**
   * Maximum file size: 100MB.
   * @max 104857600
   */
  size: number;
  title: string;
}

export interface AttachmentCreateUrlDto {
  category: AttachmentCategory;
  description?: string;
  title: string;
  /** @format url */
  url: string;
}

export interface AttachmentSelectDto {
  /** @format uuid */
  answerId?: string;
  category: AttachmentCategory;
  contentType?: string;
  createdAt: string;
  description?: string;
  /** @format url */
  downloadUrl?: string;
  /**
   * Only meaningful for TECHNOLOGY_IMAGE attachments. True when this attachment is the featured image for its technology.
   * @format boolean
   */
  featured?: boolean;
  /** @format uuid */
  id: string;
  /**
   * Only populated for TECHNOLOGY_IMAGE file attachments that are READY. Use this URL to render the image inline.
   * @format url
   */
  inlineUrl?: string;
  position: number;
  /** @format uuid */
  productId?: string;
  size?: number;
  status: AttachmentStatus;
  /** @format uuid */
  technologyId?: string;
  title: string;
  type: AttachmentType;
  updatedAt: string;
  /** @format url */
  url?: string;
}

export enum AttachmentStatus {
  READY = "READY",
  UPLOADING = "UPLOADING",
}

export enum AttachmentType {
  FILE = "FILE",
  URL = "URL",
}

export interface AttachmentUpdateDto {
  description?: string;
  title?: string;
  /** @format url */
  url?: string;
}

export interface AttachmentUploadSelectDto {
  /** @format uuid */
  answerId?: string;
  category: AttachmentCategory;
  contentType?: string;
  createdAt: string;
  description?: string;
  /** @format url */
  downloadUrl?: string;
  /**
   * Only meaningful for TECHNOLOGY_IMAGE attachments. True when this attachment is the featured image for its technology.
   * @format boolean
   */
  featured?: boolean;
  /** @format uuid */
  id: string;
  /**
   * Only populated for TECHNOLOGY_IMAGE file attachments that are READY. Use this URL to render the image inline.
   * @format url
   */
  inlineUrl?: string;
  position: number;
  /** @format uuid */
  productId?: string;
  size?: number;
  status: AttachmentStatus;
  /** @format uuid */
  technologyId?: string;
  title: string;
  type: AttachmentType;
  updatedAt: string;
  /** @format url */
  uploadUrl: string;
  /** @format url */
  url?: string;
}

export interface AttachmentsSelectDto {
  attachments: AttachmentSelectDto[];
}

export interface BasePaginationDto {
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  limit: number;
  page: number;
  totalItems: number;
  totalPages: number;
}

export interface CampaignConsumedStudySelectDto {
  /** @format uuid */
  campaignId: string;
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  id: string;
  studyClassificationLevel?: ClassificationLevel | null;
  studyCurrentGate?: StudyGate | null;
  /** @format uuid */
  studyId: string;
  studyName?: string | null;
  studyStatus?: StudyStatus | null;
  /** @format date-time */
  updatedAt: string;
}

export interface CampaignCreateDto {
  classificationLevel: ClassificationLevel;
  coalitionPartners: CoalitionPartner[];
  description?: string | null;
  killChainCategory?: KillChainCategory | null;
  leadCommands: LeadCommand[];
  name: string;
  status: CampaignStatus;
  timeWindow?: string | null;
}

export interface CampaignCreateWithChildrenDto {
  classificationLevel: ClassificationLevel;
  coalitionPartners: CoalitionPartner[];
  consumedStudyIds: string[];
  decisivePoints: CampaignDecisivePointCreateDto[];
  description?: string | null;
  killChainCategory?: KillChainCategory | null;
  leadCommands: LeadCommand[];
  name: string;
  scenarios: CampaignScenarioCreateWithVignettesDto[];
  status: CampaignStatus;
  timeWindow?: string | null;
}

export interface CampaignDecisivePointCreateDto {
  description: string;
  evidence: string[];
  location?: string | null;
  position: number;
}

export interface CampaignDecisivePointSelectDto {
  /** @format uuid */
  campaignId: string;
  /** @format date-time */
  createdAt: string;
  description: string;
  evidence: string[];
  /** @format uuid */
  id: string;
  location?: string | null;
  position: number;
  /** @format date-time */
  updatedAt: string;
}

export interface CampaignDecisivePointUpdateDto {
  description?: string;
  evidence?: string[];
  location?: string | null;
  position?: number;
}

export interface CampaignDecisivePointUpdateWithChildrenDto {
  description?: string;
  evidence?: string[];
  /** @format uuid */
  id?: string;
  location?: string | null;
  position?: number;
}

export enum CampaignLevelOfWarfare {
  OPERATIONAL = "OPERATIONAL",
  STRATEGIC = "STRATEGIC",
  TACTICAL = "TACTICAL",
}

export interface CampaignScenarioCreateDto {
  classificationLevel: ClassificationLevel;
  description?: string | null;
  levelOfWarfare: CampaignLevelOfWarfare;
  levelOfWarfareOverrideRationale?: string | null;
  name: string;
  operationalRegions: OperationalRegion[];
}

export interface CampaignScenarioCreateWithVignettesDto {
  classificationLevel: ClassificationLevel;
  description?: string | null;
  levelOfWarfare: CampaignLevelOfWarfare;
  levelOfWarfareOverrideRationale?: string | null;
  name: string;
  operationalRegions: OperationalRegion[];
  vignettes: CampaignVignetteCreateDto[];
}

export interface CampaignScenarioSelectDto {
  /** @format uuid */
  campaignId: string;
  classificationLevel: ClassificationLevel;
  /** @format date-time */
  createdAt: string;
  description?: string | null;
  /** @format uuid */
  id: string;
  levelOfWarfare: CampaignLevelOfWarfare;
  levelOfWarfareOverrideRationale?: string | null;
  name: string;
  operationalRegions: OperationalRegion[];
  position: number;
  /** @format date-time */
  updatedAt: string;
  vignettes: CampaignVignetteSelectDto[];
}

export interface CampaignScenarioUpdateDto {
  classificationLevel?: ClassificationLevel;
  description?: string | null;
  levelOfWarfare?: CampaignLevelOfWarfare;
  levelOfWarfareOverrideRationale?: string | null;
  name?: string;
  operationalRegions?: OperationalRegion[];
  position?: number;
}

export interface CampaignScenarioUpdateWithVignettesDto {
  classificationLevel?: ClassificationLevel;
  description?: string | null;
  /** @format uuid */
  id?: string;
  levelOfWarfare?: CampaignLevelOfWarfare;
  levelOfWarfareOverrideRationale?: string | null;
  name?: string;
  operationalRegions?: OperationalRegion[];
  vignettes: CampaignVignetteUpdateDto[];
}

export interface CampaignSelectDto {
  canEditCampaign: boolean;
  classificationLevel: ClassificationLevel;
  coalitionPartners: CoalitionPartner[];
  consumedStudies: CampaignConsumedStudySelectDto[];
  /** @format date-time */
  createdAt: string;
  decisivePoints: CampaignDecisivePointSelectDto[];
  description?: string | null;
  /** @format uuid */
  id: string;
  killChainCategory?: KillChainCategory | null;
  leadCommands: LeadCommand[];
  name: string;
  /** @format uuid */
  ownerId: string;
  ownerName: string;
  scenarios: CampaignScenarioSelectDto[];
  status: CampaignStatus;
  timeWindow?: string | null;
  /** @format date-time */
  updatedAt: string;
  warnings: CampaignWarningDto[];
}

export enum CampaignStatus {
  ACTIVE = "ACTIVE",
  ARCHIVED = "ARCHIVED",
  DRAFT = "DRAFT",
  HISTORICAL = "HISTORICAL",
}

export interface CampaignUpdateDto {
  classificationLevel?: ClassificationLevel;
  coalitionPartners?: CoalitionPartner[];
  consumedStudyIds?: string[];
  decisivePoints?: CampaignDecisivePointUpdateWithChildrenDto[];
  description?: string | null;
  killChainCategory?: KillChainCategory | null;
  leadCommands?: LeadCommand[];
  name?: string;
  scenarios?: CampaignScenarioUpdateWithVignettesDto[];
  status?: CampaignStatus;
  timeWindow?: string | null;
}

export interface CampaignVignetteCreateDto {
  description?: string | null;
  missionIds: string[];
  name: string;
  operationalRegionsOverride: OperationalRegion[];
  operationalRegionsOverrideRationale?: string | null;
}

export interface CampaignVignetteMissionRefDto {
  /** @format uuid */
  id: string;
  name: string;
  /** @format uuid */
  studyId: string;
  studyName?: string | null;
}

export interface CampaignVignetteSelectDto {
  /** @format date-time */
  createdAt: string;
  description?: string | null;
  /** @format uuid */
  id: string;
  missions: CampaignVignetteMissionRefDto[];
  name: string;
  operationalRegionsOverride: OperationalRegion[];
  operationalRegionsOverrideRationale?: string | null;
  position: number;
  /** @format uuid */
  scenarioId: string;
  /** @format date-time */
  updatedAt: string;
}

export interface CampaignVignetteUpdateDto {
  description?: string | null;
  /** @format uuid */
  id?: string;
  missionIds?: string[];
  name?: string;
  operationalRegionsOverride?: OperationalRegion[];
  operationalRegionsOverrideRationale?: string | null;
}

export interface CampaignWarningDto {
  code: string;
  message: string;
}

export interface CampaignsSelectDto {
  campaigns: CampaignSelectDto[];
}

export interface CapabilitiesSelectDto {
  capabilities: CapabilitySelectDto[];
}

export interface CapabilitySelectDto {
  description?: string;
  /** @format uuid */
  id: string;
  name: string;
  subCapabilities: CapabilitySubSelectDto[];
}

export interface CapabilitySubSelectDto {
  description?: string;
  /** @format uuid */
  id: string;
  name: string;
}

export interface CategoriesSelectDto {
  categories: CategorySelectDto[];
}

export interface CategoryNestedSelectDto {
  description?: string;
  /** @format uuid */
  id: string;
  name: string;
}

export interface CategorySecondarySelectDto {
  archived: boolean;
  /** @format date-time */
  archivedAt?: string;
  description?: string;
  /** @format uuid */
  id: string;
  name: string;
  /** @format date-time */
  updatedAt: string;
}

export interface CategorySelectDto {
  archived: boolean;
  /** @format date-time */
  archivedAt?: string;
  description?: string;
  /** @format uuid */
  id: string;
  name: string;
  subcategories: CategorySecondarySelectDto[];
  /** @format date-time */
  updatedAt: string;
}

export interface ChallengePhaseDto {
  criteria?: CriterionDto[];
  /**
   * @minLength 2
   * @maxLength 60
   */
  name: string;
  position: number;
}

export interface ChallengePhaseSelectDto {
  /** @format date-time */
  createdAt: string;
  criteria: CriterionSelectDto[];
  id: string;
  /**
   * @minLength 2
   * @maxLength 60
   */
  name: string;
  position: number;
}

export interface ChallengePhaseWithCountDto {
  /** @format date-time */
  createdAt: string;
  criteria: CriterionSelectDto[];
  id: string;
  matchCount: number;
  /**
   * @minLength 2
   * @maxLength 60
   */
  name: string;
  position: number;
}

export interface ChallengeSelectDto {
  /** @format date-time */
  createdAt: string;
  description?: string;
  id: string;
  name: string;
  phases: ChallengePhaseSelectDto[];
  /** @format date-time */
  updatedAt: string;
  userId: string;
}

export interface ChallengeWithCountsDto {
  /** @format date-time */
  createdAt: string;
  description?: string;
  id: string;
  name: string;
  phases: ChallengePhaseWithCountDto[];
  totalTechnologyCount: number;
  /** @format date-time */
  updatedAt: string;
  userId: string;
}

export interface ChallengesListDto {
  challenges: ChallengeSelectDto[];
}

export interface ChatMessageDto {
  parts: ChatMessagePartDto[];
  role: LlmRole;
}

export interface ChatMessagePartDto {
  text?: string;
  type: string;
}

export interface ChatPostRequestDto {
  /** @format uuid */
  id: string;
  messages: ChatMessageDto[];
  model: LlmModel;
}

export enum ClassificationLevel {
  CUI = "CUI",
  SECRET = "SECRET",
  TOP_SECRET = "TOP_SECRET",
  UNCLASSIFIED = "UNCLASSIFIED",
}

export enum CmmcLevel {
  LEVEL_ONE = "LEVEL_ONE",
  LEVEL_TWO = "LEVEL_TWO",
  LEVEL_THREE = "LEVEL_THREE",
  NOT_SURE = "NOT_SURE",
}

export enum CoalitionPartner {
  AU = "AU",
  CA = "CA",
  DE = "DE",
  FR = "FR",
  IT = "IT",
  JP = "JP",
  KR = "KR",
  NATO = "NATO",
  NL = "NL",
  NO = "NO",
  NZ = "NZ",
  UK = "UK",
  US = "US",
}

export interface CommunitiesSelectDto {
  communities: CommunitySelectDto[];
}

export interface CommunitySelectDto {
  /** @format uuid */
  id: string;
  name: string;
}

export interface CompanyCreateDto {
  /** @format string */
  city?: string;
  cmmcLevel?: CmmcLevel;
  /** @format string */
  country?: string;
  /**
   * @format string
   * @maxLength 2000
   */
  description?: string;
  /**
   * @format string
   * @minLength 2
   * @maxLength 60
   */
  name: string;
  previousGovernmentWorkCountries?: string[];
  /** IDs of previous government work services */
  previousGovernmentWorkServiceIds?: string[];
  researchOrganizationData?: ResearchOrganizationDataDto;
  revenue?: CompanyRevenueDto;
  /** @format string */
  samsUeiNumber?: string;
  slug?: string | null;
  /** @format string */
  state?: string;
  type: CompanyType;
  urls?: CompanyUrlsDto;
  /** @format integer */
  yearFounded?: number;
}

export enum CompanyFeatureFlag {
  CYBER_ASSESSMENTS_TOOL = "CYBER_ASSESSMENTS_TOOL",
  INSIGHTS_TOOL = "INSIGHTS_TOOL",
  MEIA_STUDIO_V1 = "MEIA_STUDIO_V1",
  MEIA_STUDIO_V2 = "MEIA_STUDIO_V2",
  RESEARCH_TOOL = "RESEARCH_TOOL",
  THREADS_TOOL = "THREADS_TOOL",
}

export enum CompanyLogoContentType {
  ImageJpeg = "image/jpeg",
  ImagePng = "image/png",
  ImageSvgXml = "image/svg+xml",
  ImageWebp = "image/webp",
}

export interface CompanyLogoCreateFileDto {
  contentType: CompanyLogoContentType;
  /**
   * Maximum logo file size: 5MB.
   * @max 5242880
   */
  size: number;
  title: string;
}

export interface CompanyLogoSelectDto {
  /** @format url */
  logoUrl?: string;
}

export interface CompanyLogoUploadSelectDto {
  /** @format uuid */
  attachmentId: string;
  /** @format url */
  uploadUrl: string;
}

export interface CompanyNestedSelectDto {
  /** @format uuid */
  id: string;
  /** @format string */
  logoUrl?: string;
  /**
   * @format string
   * @minLength 2
   * @maxLength 60
   */
  name: string;
}

export interface CompanyPatchDto {
  /** @format string */
  city?: string;
  cmmcLevel?: CmmcLevel;
  /** @format string */
  country?: string;
  /**
   * @format string
   * @maxLength 2000
   */
  description?: string;
  /**
   * @format string
   * @minLength 2
   * @maxLength 60
   */
  name?: string;
  previousGovernmentWorkCountries?: string[];
  /** IDs of previous government work services */
  previousGovernmentWorkServiceIds?: string[];
  researchOrganizationData?: ResearchOrganizationDataDto;
  revenue?: CompanyRevenueDto;
  /** @format string */
  samsUeiNumber?: string;
  slug?: string | null;
  /** @format string */
  state?: string;
  type?: CompanyType;
  urls?: CompanyUrlsDto;
  /** @format integer */
  yearFounded?: number;
}

export interface CompanyRevenueDto {
  /** @format number */
  amount?: number;
  period?: CompanyRevenueDtoPeriodEnum;
  /** @format number */
  valuation?: number;
}

export enum CompanyRevenueDtoPeriodEnum {
  PerMonth = "Per Month",
  PerYear = "Per Year",
}

export interface CompanySelectDto {
  /** @format string */
  city?: string;
  cmmcLevel?: CmmcLevel;
  /** @format string */
  country?: string;
  /**
   * @format string
   * @maxLength 2000
   */
  description?: string;
  /** @format uuid */
  id: string;
  invites: InviteNestedSelectDto[];
  /** @format boolean */
  isParentOrganization: boolean;
  /** @format string */
  logoUrl?: string;
  /**
   * @format string
   * @minLength 2
   * @maxLength 60
   */
  name: string;
  /** @format uuid */
  parentOrganizationId?: object;
  previousGovernmentWorkCountries?: string[];
  previousGovernmentWorkServices?: ServiceSubSelectDto[];
  researchOrganizationData?: ResearchOrganizationDataDto;
  revenue?: CompanyRevenueDto;
  /** @format string */
  samsUeiNumber?: string;
  slug?: string | null;
  /** @format string */
  state?: string;
  type: CompanyType;
  urls?: CompanyUrlsDto;
  /** @format integer */
  yearFounded?: number;
}

export interface CompanyTechnologyNestedSelectDto {
  /** @format string */
  city?: string;
  cmmcLevel?: CmmcLevel;
  /** @format string */
  country?: string;
  /**
   * @format string
   * @maxLength 2000
   */
  description?: string;
  /** @format uuid */
  id: string;
  /** @format boolean */
  isParentOrganization: boolean;
  /** @format string */
  logoUrl?: string;
  /**
   * @format string
   * @minLength 2
   * @maxLength 60
   */
  name: string;
  previousGovernmentWorkCountries?: string[];
  researchOrganizationData?: ResearchOrganizationDataDto;
  revenue?: CompanyRevenueDto;
  /** @format string */
  samsUeiNumber?: string;
  slug?: string | null;
  /** @format string */
  state?: string;
  type: CompanyType;
  urls?: CompanyUrlsDto;
  /** @format integer */
  yearFounded?: number;
}

export enum CompanyType {
  COMMERCIAL = "COMMERCIAL",
  INTELLIGENCE = "INTELLIGENCE",
  RESEARCH = "RESEARCH",
  RESEARCH_PROJECT = "RESEARCH_PROJECT",
}

export interface CompanyUrlsDto {
  /** @format string */
  crunchbase?: string;
  /** @format string */
  linkedin?: string;
  /** @format string */
  twitter?: string;
  /** @format string */
  website?: string;
}

export interface ComponentCreateDto {
  /**
   * @minLength 2
   * @maxLength 60
   */
  name: string;
  origin?: string;
  price?: number;
}

export interface ComponentSelectDto {
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  id: string;
  /**
   * @minLength 2
   * @maxLength 60
   */
  name: string;
  origin?: string;
  price?: number;
}

export interface ComponentUpdateDto {
  /** @format uuid */
  id?: string;
  /**
   * @minLength 2
   * @maxLength 60
   */
  name?: string;
  origin?: string;
  price?: number;
}

export enum ConfidenceTier {
  A = "A",
  B = "B",
  C = "C",
  D = "D",
  F = "F",
}

export interface CreateChallengeDto {
  challengePhases?: ChallengePhaseDto[];
  /** @maxLength 2000 */
  description?: string;
  /**
   * @minLength 2
   * @maxLength 60
   */
  name: string;
}

export enum CriteriaOperator {
  EQUALS = "EQUALS",
  EXCLUDES = "EXCLUDES",
  INCLUDES = "INCLUDES",
  INCLUDES_ALL_OF = "INCLUDES_ALL_OF",
  INCLUDES_ANY_OF = "INCLUDES_ANY_OF",
  IS = "IS",
  IS_ANY_OF = "IS_ANY_OF",
  IS_NONE_OF = "IS_NONE_OF",
  IS_NOT = "IS_NOT",
  BETWEEN = "BETWEEN",
  GREATER_THAN = "GREATER_THAN",
  LESS_THAN = "LESS_THAN",
  RANGE = "RANGE",
}

export enum CriteriaType {
  CMMC_LEVEL = "CMMC_LEVEL",
  COUNTRY = "COUNTRY",
  ORGANIZATION_TYPE = "ORGANIZATION_TYPE",
  REVENUE_RANGE = "REVENUE_RANGE",
  CATEGORY = "CATEGORY",
  DOMAINS = "DOMAINS",
  MRL_SCORE = "MRL_SCORE",
  RESEARCH_VALIDATED = "RESEARCH_VALIDATED",
  SUBCATEGORY = "SUBCATEGORY",
  SUBSYSTEMS = "SUBSYSTEMS",
  TRL_QUESTION = "TRL_QUESTION",
  TRL_SCORE = "TRL_SCORE",
  TYPE = "TYPE",
  USES = "USES",
}

export interface CriterionDto {
  operator: CriteriaOperator;
  position: number;
  type: CriteriaType;
  values: object;
}

export interface CriterionSelectDto {
  /** @format date-time */
  createdAt: string;
  id: string;
  operator: CriteriaOperator;
  position: number;
  type: CriteriaType;
  values: object;
}

export interface CyberAssessmentActionPlanItemSelectDto {
  blockingType: CyberAssessmentBlockingType;
  evidenceToAttach: string[];
  gateTags: string[];
  isDeploymentBlocker: boolean;
  jurisdictions: string[];
  missionImpactIfNo: string;
  phaseTitle: string;
  priority: CyberAssessmentPriority;
  prompt: string;
  questionId: string;
  recommendedAction: string;
  section: string;
  stageLabel: string;
  standardsReferences: CyberAssessmentStandardReferenceSelectDto[];
  whatGoodLooksLike: string;
}

export interface CyberAssessmentActionPlanSelectDto {
  items: CyberAssessmentActionPlanItemSelectDto[];
}

export interface CyberAssessmentAnswerPatchDto {
  /** @format uuid */
  cyberAssessmentId: string;
  details?: string;
  questionId: string;
  response?: AnswerResponseProgress;
}

export interface CyberAssessmentAnswerSelectDto {
  /** @format uuid */
  cyberAssessmentId: string;
  details?: string;
  /** @format uuid */
  id: string;
  questionId: string;
  response?: AnswerResponseProgress;
}

export interface CyberAssessmentApplicabilityQuestionSelectDto {
  applicabilityQuestionIds?: string[];
  description: string;
  id: string;
  prompt: string;
  sectionId?: string;
}

export interface CyberAssessmentAukusBlockerSelectDto {
  explanation: string;
  gateTags: string[];
  questionId: string;
  questionSummary: string;
}

export enum CyberAssessmentAukusClassificationGate {
  SECRET_REL_AUKUS = "SECRET_REL_AUKUS",
  TOP_SECRET_REL_AUKUS = "TOP_SECRET_REL_AUKUS",
}

export interface CyberAssessmentAukusGateResultSelectDto {
  blockerQuestionIds: string[];
  classificationGate: CyberAssessmentAukusClassificationGate;
  isEligible: boolean;
  minimumCpiBand: number;
}

export interface CyberAssessmentAukusPillar2SelectDto {
  gateResults: CyberAssessmentAukusGateResultSelectDto[];
  interoperabilityBlockerItems: CyberAssessmentAukusBlockerSelectDto[];
  interoperabilityBlockers: string[];
  lowestCommonClassificationCeiling: CyberAssessmentClassificationCeiling;
  readinessBand: CyberAssessmentAukusReadinessBand;
  recommendedNextSteps: string[];
}

export enum CyberAssessmentAukusReadinessBand {
  Conditional = "Conditional",
  NotReady = "Not Ready",
  Partial = "Partial",
  Ready = "Ready",
}

export interface CyberAssessmentBlockingDeficienciesSelectDto {
  items: CyberAssessmentBlockingDeficiencyItemSelectDto[];
}

export interface CyberAssessmentBlockingDeficiencyItemSelectDto {
  blockingType: CyberAssessmentBlockingType;
  dependencyQuestionId?: string;
  dependencyRationale?: string;
  explanation: string;
  gateTags: string[];
  isDeploymentBlocker: boolean;
  jurisdictions: string[];
  missionImpactIfNo: string;
  prompt: string;
  questionId: string;
  ragStatus: CyberAssessmentRagStatus;
  recommendedAction: string;
  response: AnswerResponseProgress;
  section: string;
  standardsReferences: CyberAssessmentStandardReferenceSelectDto[];
  stigSeverity?: CyberAssessmentStigSeverity;
}

export enum CyberAssessmentBlockingType {
  ANSWER_IN_PROGRESS = "ANSWER_IN_PROGRESS",
  ANSWER_NO = "ANSWER_NO",
  PHASE_DEPENDENCY = "PHASE_DEPENDENCY",
}

export enum CyberAssessmentClassificationCeiling {
  CUI = "CUI",
  OFFICIAL = "OFFICIAL",
  OFFICIALSENSITIVE = "OFFICIAL-SENSITIVE",
  PROTECTED = "PROTECTED",
  SECRET = "SECRET",
  TOPSECRET = "TOP SECRET",
  TSSCI = "TS/SCI",
  UNCLASSIFIED = "UNCLASSIFIED",
  UNOFFICIAL = "UNOFFICIAL",
}

export interface CyberAssessmentCmmcDomainSummarySelectDto {
  domainName: string;
  practicesGapMapped: number;
  practicesMet: number;
  practicesNotAssessed: number;
  practicesNotMet: number;
  practicesPartial: number;
  practicesPartiallyMapped: number;
  practicesTotal: number;
}

export interface CyberAssessmentCmmcGapPriorityGroupSelectDto {
  domainName: string;
  items: CyberAssessmentCmmcGapPrioritySelectDto[];
}

export interface CyberAssessmentCmmcGapPrioritySelectDto {
  domainName: string;
  practiceId: string;
  practiceName: string;
  questionIds: string[];
  status: CyberAssessmentCmmcPracticeStatus;
}

export enum CyberAssessmentCmmcPracticeStatus {
  GAP_MAPPED = "GAP_MAPPED",
  MET = "MET",
  NOT_ASSESSED = "NOT_ASSESSED",
  NOT_MET = "NOT_MET",
  PARTIAL = "PARTIAL",
  PARTIAL_MAPPING = "PARTIAL_MAPPING",
}

export interface CyberAssessmentCmmcSelectDto {
  level2AssessablePracticeCount: number;
  level2CoveragePercentage: number;
  level2Ready: boolean;
  level3AssessablePracticeCount: number;
  level3CoveragePercentage: number;
  level3Ready: boolean;
  domainSummaries: CyberAssessmentCmmcDomainSummarySelectDto[];
  estimatedSprsScore: number;
  gapRemediationPriorities: CyberAssessmentCmmcGapPrioritySelectDto[];
  gapRemediationPriorityGroups: CyberAssessmentCmmcGapPriorityGroupSelectDto[];
  indicativeLevel: string;
  practicesAssessed: number;
  practicesGapMapped: number;
  practicesMet: number;
  practicesNotAssessed: number;
  practicesNotMet: number;
  practicesPartial: number;
  practicesPartiallyMapped: number;
  targetLevel: number;
}

export enum CyberAssessmentCpiBandLabel {
  Assured = "Assured",
  Developing = "Developing",
  Foundational = "Foundational",
  Mature = "Mature",
  Nascent = "Nascent",
}

export interface CyberAssessmentCreateDto {
  /** @format uuid */
  sourceAssessmentId: string;
  technologyTypes: TechnologyType[];
}

export enum CyberAssessmentDeploymentReadinessBand {
  Cleared = "Cleared",
  Conditional = "Conditional",
  Early = "Early",
  Provisional = "Provisional",
}

export interface CyberAssessmentDraftMigrationSelectDto {
  failedIds: string[];
  migratedCount: number;
  totalCount: number;
}

export interface CyberAssessmentEvidencePackChecklistItemPatchDto {
  checked: boolean;
  itemId: string;
  jurisdiction: CyberAssessmentEvidencePackChecklistJurisdiction;
}

export interface CyberAssessmentEvidencePackChecklistItemSelectDto {
  checked: boolean;
  id: string;
  label: string;
}

export enum CyberAssessmentEvidencePackChecklistJurisdiction {
  AU = "AU",
  US = "US",
  UK = "UK",
}

export interface CyberAssessmentEvidencePackChecklistJurisdictionSelectDto {
  items: CyberAssessmentEvidencePackChecklistItemSelectDto[];
  jurisdiction: CyberAssessmentEvidencePackChecklistJurisdiction;
}

export interface CyberAssessmentEvidencePackChecklistSelectDto {
  jurisdictions: CyberAssessmentEvidencePackChecklistJurisdictionSelectDto[];
}

export interface CyberAssessmentJurisdictionQuestionSelectDto {
  questionId: string;
  questionSummary: string;
  ragStatus: CyberAssessmentRagStatus;
  remediationPriority: CyberAssessmentPriority;
  response: AnswerResponseProgress;
}

export interface CyberAssessmentJurisdictionReadinessSelectDto {
  amberQuestions: CyberAssessmentJurisdictionQuestionSelectDto[];
  atoPathway: string;
  blockingQuestions: CyberAssessmentJurisdictionQuestionSelectDto[];
  classificationCeiling: CyberAssessmentClassificationCeiling;
  classificationCeilingRationale: string;
  deploymentReadinessBand: CyberAssessmentDeploymentReadinessBand;
  estimatedRemediationEffort: CyberAssessmentRemediationEffort;
  evidenceChecklist: string[];
  evidenceChecklistCount: number;
  jurisdiction: string;
  keyControls: string[];
  keyMissingEvidence: string[];
  notes: string[];
}

export interface CyberAssessmentOverviewSnapshotSelectDto {
  answeredQuestions: number;
  assessmentCompletionPercentage: number;
  cpiBand: number;
  cpiBandLabel: CyberAssessmentCpiBandLabel;
  cpiRatio: number;
  deploymentReadinessBand: CyberAssessmentDeploymentReadinessBand;
  inProgressCount: number;
  noCount: number;
  notApplicableCount: number;
  /** @deprecated */
  technologyType: TechnologyType;
  technologyTypes: TechnologyType[];
  totalQuestions: number;
  trlBand: CyberAssessmentTrlBand;
  trlScore: number;
  yesCount: number;
}

export enum CyberAssessmentPriority {
  CRITICAL = "CRITICAL",
  HIGH = "HIGH",
  MEDIUM = "MEDIUM",
}

export interface CyberAssessmentPurpleTeamExerciseSelectDto {
  complianceReferences: CyberAssessmentStandardReferenceSelectDto[];
  details?: string;
  evidenceRequired: string[];
  id: string;
  minimumFrequency: string;
  mitreAttackTactics: string[];
  mitreAttackTechniques: CyberQuestionMitreAttackTechniqueSelectDto[];
  objective: string;
  prerequisiteControls: string[];
  prompt: string;
  ragStatus: CyberAssessmentRagStatus;
  response: AnswerResponseProgress;
  responseDescription: string;
  responseOverride?: string;
  title: string;
}

export interface CyberAssessmentPurpleTeamExercisesSelectDto {
  items: CyberAssessmentPurpleTeamExerciseSelectDto[];
}

export interface CyberAssessmentQuestionGroupSelectDto {
  id: string;
  questionCount: number;
  questions: CyberAssessmentQuestionSelectDto[];
  title: string;
}

export enum CyberAssessmentQuestionKind {
  Control = "control",
  PurpleTeamExercise = "purple_team_exercise",
}

export interface CyberAssessmentQuestionSelectDto {
  applicabilityQuestionIds?: string[];
  explanation: string;
  id: string;
  isDomainElevated: boolean;
  kind: CyberAssessmentQuestionKind;
  missionImpactIfNo: string;
  prompt: string;
  purpleTeamExercise?: Record<string, any>;
  section: string;
  sectionId?: string;
  sourceScrdfDomainId?: string;
}

export interface CyberAssessmentQuestionnaireSnapshotSelectDto {
  applicabilityQuestions: CyberAssessmentApplicabilityQuestionSelectDto[];
  frameworkVersion: string;
  questionGroups: CyberAssessmentQuestionGroupSelectDto[];
}

export enum CyberAssessmentRagStatus {
  GREEN = "GREEN",
  RED = "RED",
  YELLOW = "YELLOW",
}

export interface CyberAssessmentReadinessComparisonSelectDto {
  jurisdictions: CyberAssessmentJurisdictionReadinessSelectDto[];
}

export enum CyberAssessmentRemediationEffort {
  HIGH = "HIGH",
  LOW = "LOW",
  MEDIUM = "MEDIUM",
  VERY_HIGH = "VERY_HIGH",
}

export interface CyberAssessmentReportSnapshotSelectDto {
  aukusPillar2: CyberAssessmentAukusPillar2SelectDto;
  actionPlan: CyberAssessmentActionPlanSelectDto;
  blockingDeficiencies: CyberAssessmentBlockingDeficienciesSelectDto;
  cmmc: CyberAssessmentCmmcSelectDto;
  overview: CyberAssessmentOverviewSnapshotSelectDto;
  purpleTeamExercises: CyberAssessmentPurpleTeamExercisesSelectDto;
  readinessComparison: CyberAssessmentReadinessComparisonSelectDto;
}

export interface CyberAssessmentSelectDto {
  answers?: CyberAssessmentAnswerSelectDto[];
  /** @format date-time */
  createdAt: string;
  evidencePackChecklist?: CyberAssessmentEvidencePackChecklistSelectDto;
  /** @format uuid */
  id: string;
  questionnaireSnapshot: CyberAssessmentQuestionnaireSnapshotSelectDto;
  reportSnapshot?: CyberAssessmentReportSnapshotSelectDto;
  sourceMilitaryTrlAssessment: AssessmentNestedSelectDto;
  /** @format uuid */
  sourceMilitaryTrlAssessmentId: string;
  /** @format uuid */
  sourceMilitaryTrlSurveyId?: object;
  /** @format uuid */
  sourceMissionAssessmentId?: object;
  status: CyberAssessmentStatus;
  /** @format uuid */
  technologyId: string;
  /** @deprecated */
  technologyType: TechnologyType;
  technologyTypes: TechnologyType[];
  trlBand: CyberAssessmentTrlBand;
  trlScore: number;
  /** @format date-time */
  updatedAt: string;
}

export interface CyberAssessmentStandardReferenceSelectDto {
  jurisdiction?: string;
  section: string;
  standard: string;
  url: string;
}

export enum CyberAssessmentStatus {
  COMPLETE = "COMPLETE",
  DRAFT = "DRAFT",
}

export enum CyberAssessmentStigSeverity {
  CATI = "CAT I",
  CATII = "CAT II",
  CATIII = "CAT III",
}

export enum CyberAssessmentTrlBand {
  TRL_1_3 = "TRL_1_3",
  TRL_4_6 = "TRL_4_6",
  TRL_7_9 = "TRL_7_9",
}

export interface CyberAssessmentsSelectDto {
  cyberAssessments: CyberAssessmentSelectDto[];
}

export interface CyberQuestionMitreAttackTechniqueSelectDto {
  id: string;
  name: string;
  url: string;
}

export interface DigitalIntegrationSelectDto {
  /** @format uuid */
  id: string;
  name: string;
}

export interface DigitalIntegrationsSelectDto {
  digitalIntegrations: DigitalIntegrationSelectDto[];
}

export interface DomainCreateDto {
  archived: boolean;
  /** @format date-time */
  archivedAt?: string;
  /** @format uuid */
  id: string;
  isPrimaryDomain: boolean;
  subdomainIds?: string[];
}

export interface DomainNestedSelectDto {
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  id: string;
  name: string;
  position: number;
  subdomainIds?: string[];
}

export interface DomainSecondarySelectDto {
  archived: boolean;
  /** @format date-time */
  archivedAt?: string;
  /** @format uuid */
  id: string;
  name: string;
}

export interface DomainSelectDto {
  archived: boolean;
  /** @format date-time */
  archivedAt?: string;
  /** @format uuid */
  id: string;
  name: string;
  subdomains: DomainSecondarySelectDto[];
}

export interface DomainWithAssessmentDto {
  /** @format date-time */
  createdAt: string;
  featuredAssessment?: AssessmentSelectDto;
  /** @format uuid */
  id: string;
  name: string;
  subdomains: DomainSecondarySelectDto[];
}

export interface DomainsSelectDto {
  domains: DomainSelectDto[];
}

export enum DotmlpfDimension {
  DOCTRINE = "DOCTRINE",
  FACILITIES = "FACILITIES",
  LEADERSHIP = "LEADERSHIP",
  MATERIEL = "MATERIEL",
  ORGANIZATION = "ORGANIZATION",
  PERSONNEL = "PERSONNEL",
  POLICY = "POLICY",
  TRAINING = "TRAINING",
}

export enum EffectOnTargetStatus {
  CONTESTED = "CONTESTED",
  DEGRADED = "DEGRADED",
  SUPPRESSED = "SUPPRESSED",
  UNENGAGED = "UNENGAGED",
}

export interface EffectSecondarySelectDto {
  description?: string;
  /** @format uuid */
  id: string;
  name: string;
}

export interface EffectSelectDto {
  description?: string;
  /** @format uuid */
  id: string;
  name: string;
  secondaryEffects: EffectSecondarySelectDto[];
}

export interface EffectsSelectDto {
  effects: EffectSelectDto[];
}

export enum EngagementStatus {
  APPROVED = "APPROVED",
  DRAFT = "DRAFT",
  PROPOSED = "PROPOSED",
  REJECTED = "REJECTED",
  RETIRED = "RETIRED",
}

export enum EngagementType {
  Cyber = "cyber",
  Deception = "deception",
  Guidance = "guidance",
  Jam = "jam",
  Kinetic = "kinetic",
  None = "none",
  Softkill = "softkill",
  Terminal = "terminal",
}

export enum Epoch {
  BEYOND = "BEYOND",
  FYDP = "FYDP",
  NEAR_TERM = "NEAR_TERM",
}

export enum ExpertNoteIdentifier {
  THREATS = "THREATS",
  STRATEGIC = "STRATEGIC",
  RISKS = "RISKS",
  SUSTAINMENT = "SUSTAINMENT",
}

export interface ExpertProfileCreateDto {
  capabilities?: string[];
  categories?: string[];
  cityOfResidence?: string;
  communities?: string[];
  countryOfResidence?: string;
  countryOfService?: string;
  domains?: string[];
  /** List of educations to create for this profile. */
  educations?: ExpertProfileEducationDto[];
  effects?: string[];
  linkedinUrl?: string;
  mrlAssessmentRange?: number[];
  phases?: number[];
  /**
   * ID of the service for this profile.
   * @format uuid
   */
  serviceId?: string;
  stateOfResidence?: string;
  trlAssessmentRange?: number[];
  type: ExpertProfileType;
  /** @format uuid */
  userId: string;
  websiteUrl?: string;
  yearsOfExperience?: number;
}

export interface ExpertProfileEducationDto {
  /** End year of education */
  endYear?: number;
  /** Name of the institution */
  institute: string;
  /** Start year of education */
  startYear?: number;
  /**
   * Title of the Education Degree or Certification
   * @minLength 2
   * @maxLength 60
   */
  title: string;
}

export interface ExpertProfilePatchDto {
  capabilities?: string[];
  categories?: string[];
  cityOfResidence?: string;
  communities?: string[];
  countryOfResidence?: string;
  countryOfService?: string;
  domains?: string[];
  /** List of educations to create for this profile. */
  educations?: ExpertProfileEducationDto[];
  effects?: string[];
  linkedinUrl?: string;
  mrlAssessmentRange?: number[];
  phases?: number[];
  /**
   * ID of the service for this profile.
   * @format uuid
   */
  serviceId?: string;
  stateOfResidence?: string;
  trlAssessmentRange?: number[];
  type?: ExpertProfileType;
  /** @format uuid */
  userId?: string;
  websiteUrl?: string;
  yearsOfExperience?: number;
}

export interface ExpertProfileSelectDto {
  capabilities?: CapabilitySelectDto[];
  categories?: CategorySelectDto[];
  cityOfResidence?: string;
  communities?: CommunitySelectDto[];
  countryOfResidence?: string;
  countryOfService?: string;
  domains?: DomainSelectDto[];
  educations?: ExpertProfileEducationDto[];
  effects?: EffectSecondarySelectDto[];
  /** @format uuid */
  id: string;
  linkedinUrl?: string;
  mrlAssessmentRange?: number[];
  phases?: number[];
  service?: ServiceSubSelectDto;
  stateOfResidence?: string;
  trlAssessmentRange?: number[];
  type: ExpertProfileType;
  /** @format uuid */
  userId: string;
  websiteUrl?: string;
  yearsOfExperience?: number;
}

export enum ExpertProfileType {
  TECHNOLOGY_SPECIALIST = "TECHNOLOGY_SPECIALIST",
  VETERAN = "VETERAN",
}

export interface FieldProvenanceDto {
  /** @format date-time */
  generatedAt?: string | null;
  /** @format uuid */
  llmLogId?: string | null;
  state: AiProvenanceState;
}

export interface FieldProvenanceInputDto {
  /** @format uuid */
  llmLogId?: string | null;
}

export enum FieldedStatus {
  MILITARY_FIELDED = "MILITARY_FIELDED",
  COMMERCIAL_ONLY = "COMMERCIAL_ONLY",
  EMERGING_DUAL_USE = "EMERGING_DUAL_USE",
}

export enum FullAssessmentSectionId {
  CAPABILITIES = "CAPABILITIES",
  COMMUNITIES = "COMMUNITIES",
  EFFECTS = "EFFECTS",
  GENERAL_NOTES = "GENERAL_NOTES",
  HURDLES = "HURDLES",
  INTERCHANGEABLE = "INTERCHANGEABLE",
  INTEROPERABLE = "INTEROPERABLE",
  KILL_CHAINS = "KILL_CHAINS",
  PHASES = "PHASES",
  RECOMMENDED_SERVICES = "RECOMMENDED_SERVICES",
  RECOMMENDED_TECHNOLOGY_USES = "RECOMMENDED_TECHNOLOGY_USES",
  RISKS = "RISKS",
  STRATEGIC = "STRATEGIC",
  SUSTAINMENT = "SUSTAINMENT",
  TASK_RECOMMENDATIONS = "TASK_RECOMMENDATIONS",
  THREATS = "THREATS",
}

export interface ImpersonationSelectDto {
  /** @format uuid */
  actorUserId: string;
  /** @format date-time */
  expiresAt: string;
  /** @format uuid */
  subjectUserId: string;
}

export interface ImplicitTagDto {
  name: string;
  source: ImplicitTagSource;
}

export enum ImplicitTagSource {
  COUNTRY = "COUNTRY",
  SPECIAL = "SPECIAL",
  TYPE = "TYPE",
}

export interface InlineAttachmentCreateDto {
  category: AttachmentCategory;
  contentType?: string;
  description?: string;
  /**
   * Only valid for TECHNOLOGY_IMAGE attachments. Use this flag to select the featured image when creating multiple technology images inline.
   * @format boolean
   */
  featured?: boolean;
  /**
   * Maximum file size: 100MB.
   * @max 104857600
   */
  size?: number;
  title: string;
  /** Technology images only support FILE uploads. Allowed image formats: image/jpeg, image/png, image/svg+xml, image/webp. */
  type: AttachmentType;
  /** @format url */
  url?: string;
}

export interface InnovatorCompaniesPortfolioSelectDto {
  pagination: BasePaginationDto;
  technologies: InnovatorCompanyPortfolioItemDto[];
}

export interface InnovatorCompaniesProjectsSelectDto {
  projects: InnovatorCompanyProjectDto[];
}

export interface InnovatorCompanyPortfolioItemDto {
  /** @format string */
  categoryName: string;
  /** @format string */
  companyName: string;
  /** @format uuid */
  id: string;
  /** @format number */
  mrlScore?: number;
  /** @format string */
  name: string;
  /** @format number */
  trlScore?: number;
}

export interface InnovatorCompanyProjectDto {
  /** @format string */
  city?: string;
  /** @format string */
  country?: string;
  /** @format uuid */
  id: string;
  /** @format string */
  logoUrl?: string;
  /** @format string */
  name: string;
  /** @format string */
  state?: string;
  type: CompanyType;
}

export interface IntelCompaniesSelectDto {
  companies: IntelCompanyListItemDto[];
  pagination: BasePaginationDto;
}

export enum IntelCompaniesSortBy {
  Location = "location",
  Name = "name",
  ProductsCount = "productsCount",
  TechnologiesCount = "technologiesCount",
  Type = "type",
}

export interface IntelCompanyDetailDto {
  /** @format string */
  city?: string;
  cmmcLevel?: CmmcLevel;
  /** @format string */
  country?: string;
  /**
   * @format string
   * @maxLength 2000
   */
  description?: string;
  /** @format uuid */
  id: string;
  /** @format boolean */
  isParentOrganization: boolean;
  /** @format string */
  logoUrl?: string;
  /**
   * @format string
   * @minLength 2
   * @maxLength 60
   */
  name: string;
  /** @format uuid */
  parentOrganizationId?: object;
  previousGovernmentWorkCountries?: string[];
  previousGovernmentWorkServices?: ServiceSubSelectDto[];
  products: ProductSelectDto[];
  researchOrganizationData?: ResearchOrganizationDataDto;
  revenue?: CompanyRevenueDto;
  /** @format string */
  samsUeiNumber?: string;
  slug?: string | null;
  /** @format string */
  state?: string;
  technologies: IntelTechnologyListItemDto[];
  type: CompanyType;
  urls?: CompanyUrlsDto;
  /** @format integer */
  yearFounded?: number;
}

export interface IntelCompanyListItemDto {
  city?: string;
  country?: string;
  /** @format uuid */
  id: string;
  logoUrl?: string;
  name: string;
  productsCount: number;
  state?: string;
  technologiesCount: number;
  type: CompanyType;
}

export interface IntelOrgAddMemberByEmailDto {
  email: string;
  persona: IntelligencePersona;
}

export interface IntelOrgAddMemberDto {
  persona: IntelligencePersona;
  /** @format uuid */
  userId: string;
}

export interface IntelOrgMemberCandidateDto {
  avatarUrl?: string;
  eligible: boolean;
  email: string;
  fullName: string;
  /** @format uuid */
  id: string;
}

export interface IntelOrgMemberCandidatesResponseDto {
  items: IntelOrgMemberCandidateDto[];
  pagination: BasePaginationDto;
}

export interface IntelOrgMemberDetailDto {
  avatarUrl?: string;
  email: string;
  fullName: string;
  /** @format uuid */
  id: string;
  persona?: IntelligencePersona | null;
  /** @format uuid */
  userId: string;
}

export interface IntelOrgMemberSelectDto {
  /** @format uuid */
  id: string;
  persona?: IntelligencePersona | null;
  /** @format uuid */
  userId: string;
}

export interface IntelOrgSetPersonaDto {
  persona: IntelligencePersona;
}

export interface IntelTechnologiesSelectDto {
  pagination: BasePaginationDto;
  technologies: IntelTechnologyListItemDto[];
}

export enum IntelTechnologiesSortBy {
  Category = "category",
  Company = "company",
  Mrl = "mrl",
  Name = "name",
  Trl = "trl",
}

export interface IntelTechnologyCompaniesSelectDto {
  companies: IntelTechnologyCompanyListItemDto[];
}

export interface IntelTechnologyCompanyListItemDto {
  /** @format uuid */
  id: string;
  name: string;
}

export interface IntelTechnologyListItemDto {
  /** @format string */
  categoryName: string;
  /** @format string */
  companyName: string;
  /** @format uuid */
  id: string;
  /** @format number */
  mrlScore?: number;
  /** @format string */
  name: string;
  /** @format number */
  trlScore?: number;
}

export enum IntelligencePersona {
  DECISION_MAKER = "DECISION_MAKER",
  LIBRARIAN = "LIBRARIAN",
  MISSION_ENGINEER = "MISSION_ENGINEER",
  PROGRAM_ADMIN = "PROGRAM_ADMIN",
}

export interface InviteCreateDto {
  /** @format uuid */
  companyId: string;
  /** @format string */
  email: string;
  persona?: IntelligencePersona | null;
  role: InviteCreateDtoRoleEnum;
}

export enum InviteCreateDtoRoleEnum {
  Admin = "Admin",
  Collaborator = "Collaborator",
}

export interface InviteNestedSelectDto {
  /** @format uuid */
  companyId: string;
  /** @format string */
  email: string;
  /** @format date-time */
  expiredAt: string;
  /** @format uuid */
  id: string;
  persona?: IntelligencePersona | null;
  role: InviteNestedSelectDtoRoleEnum;
  status: InviteNestedSelectDtoStatusEnum;
}

export enum InviteNestedSelectDtoRoleEnum {
  Admin = "Admin",
  Collaborator = "Collaborator",
}

export enum InviteNestedSelectDtoStatusEnum {
  ACCEPTED = "ACCEPTED",
  CANCELLED = "CANCELLED",
  EXPIRED = "EXPIRED",
  PENDING = "PENDING",
  REJECTED = "REJECTED",
}

export interface InviteRoleUpdateDto {
  role?: InviteRoleUpdateDtoRoleEnum;
}

export enum InviteRoleUpdateDtoRoleEnum {
  Admin = "Admin",
  Collaborator = "Collaborator",
}

export interface InviteSelectDto {
  company: CompanyNestedSelectDto;
  /** @format uuid */
  companyId: string;
  /** @format string */
  email: string;
  /** @format date-time */
  expiredAt: string;
  /** @format uuid */
  id: string;
  /** @format date-time */
  invitedAt: string;
  persona?: IntelligencePersona | null;
  role: InviteSelectDtoRoleEnum;
  status: InviteSelectDtoStatusEnum;
}

export enum InviteSelectDtoRoleEnum {
  Admin = "Admin",
  Collaborator = "Collaborator",
}

export enum InviteSelectDtoStatusEnum {
  ACCEPTED = "ACCEPTED",
  CANCELLED = "CANCELLED",
  EXPIRED = "EXPIRED",
  PENDING = "PENDING",
  REJECTED = "REJECTED",
}

export interface InviteWithTokenDto {
  inviteToken?: string;
}

export interface InvitesCreateDto {
  invites: InviteCreateDto[];
}

export interface InvitesSelectDto {
  invites: InviteSelectDto[];
}

export interface JobRoleSelectDto {
  /** @format uuid */
  id: string;
  name: string;
}

export interface JobRolesSelectDto {
  jobRoles: JobRoleSelectDto[];
}

export enum KillChainCategory {
  C2 = "C2",
  COUNTER_UAS = "COUNTER_UAS",
  CUSTOM = "CUSTOM",
  CYBER = "CYBER",
  D3A = "D3A",
  F2T2EA = "F2T2EA",
  ISR = "ISR",
  LOGISTICS = "LOGISTICS",
}

export interface KillChainSelectDto {
  category: KillChainCategory;
  /** @format uuid */
  id: string;
  name: string;
}

export interface KillChainsSelectDto {
  killChains: KillChainSelectDto[];
}

export enum LeadCommand {
  ACC = "ACC",
  AFCYBER = "AFCYBER",
  AFGSC = "AFGSC",
  AFRICOM = "AFRICOM",
  AFRL = "AFRL",
  AU_HQJOC = "AU_HQJOC",
  CA_CJOC = "CA_CJOC",
  CENTCOM = "CENTCOM",
  CYBERCOM = "CYBERCOM",
  EUCOM = "EUCOM",
  INDOPACOM = "INDOPACOM",
  JP_JSO = "JP_JSO",
  KR_JCS = "KR_JCS",
  NATO_ACO = "NATO_ACO",
  NATO_SHAPE = "NATO_SHAPE",
  NORTHCOM = "NORTHCOM",
  NZ_HQJFNZ = "NZ_HQJFNZ",
  PACAF = "PACAF",
  SOCOM = "SOCOM",
  SOUTHCOM = "SOUTHCOM",
  SPACECOM = "SPACECOM",
  STRATCOM = "STRATCOM",
  TRANSCOM = "TRANSCOM",
  UK_PJHQ = "UK_PJHQ",
  USAFE = "USAFE",
}

export enum LlmGenerationSurface {
  FullAssessment = "full_assessment",
  FullscreenChat = "fullscreen_chat",
  PromptPopover = "prompt_popover",
}

export enum LlmGenerationType {
  Chat = "chat",
  MaCapabilityInput = "ma_capability_input",
  MaEffectInput = "ma_effect_input",
  MaFullAssessment = "ma_full_assessment",
  MaInput = "ma_input",
  MaInterInput = "ma_inter_input",
  SimilarTechnologies = "similar_technologies",
  TrlAnalysis = "trl_analysis",
  TrlProjection = "trl_projection",
}

export interface LlmLogMetadataDto {
  aborted?: boolean;
  actualModel?: string;
  cachedInputTokens?: number;
  /** @format date-time */
  completedAt?: string;
  durationMs?: number;
  errorCode?: string;
  errorMessage?: string;
  fieldName?: string;
  finishReason?: string;
  /** @format date-time */
  firstTokenAt?: string;
  inputTokens?: number;
  jsonRepaired?: boolean;
  maxOutputTokens?: number;
  objectKind?: string;
  outputTokens?: number;
  providerMetadata?: object;
  /** @format date-time */
  requestStartedAt?: string;
  requestedModel?: string;
  resolvedModel?: string;
  responseHeaders?: object;
  surface?: LlmGenerationSurface;
  templateKey?: string;
  templateVersion?: number;
  timeToFirstTokenMs?: number;
  totalTokens?: number;
}

export interface LlmLogSelectDto {
  accepted?: boolean;
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  id: string;
  messages: LlmMessageDto[];
  metadata?: LlmLogMetadataDto;
  prompt?: string;
  rawRequest?: object;
  rawResponse?: object;
  result?: object;
  status: LlmLogStatus;
  technology?: TechnologyNestedSelectDto;
  type?: LlmLogType;
  /** @format date-time */
  updatedAt: string;
  user?: UserSelectDto;
}

export enum LlmLogStatus {
  Aborted = "aborted",
  Completed = "completed",
  Failed = "failed",
  Pending = "pending",
}

export enum LlmLogType {
  Chat = "chat",
  MaCapabilityInput = "ma_capability_input",
  MaEffectInput = "ma_effect_input",
  MaFullAssessment = "ma_full_assessment",
  MaInput = "ma_input",
  MaInterInput = "ma_inter_input",
  SimilarTechnologies = "similar_technologies",
  TrlAnalysis = "trl_analysis",
  TrlProjection = "trl_projection",
}

export interface LlmMessageDto {
  content: string;
  role: LlmRole;
}

export enum LlmModel {
  OpenrouterAuto = "openrouter/auto",
  AnthropicClaudeHaiku45 = "anthropic/claude-haiku-4.5",
  AnthropicClaudeOpus46 = "anthropic/claude-opus-4.6",
  AnthropicClaudeSonnet45 = "anthropic/claude-sonnet-4.5",
  AnthropicClaudeSonnet46 = "anthropic/claude-sonnet-4.6",
  DeepseekDeepseekR1 = "deepseek/deepseek-r1",
  GoogleGemini25FlashLite = "google/gemini-2.5-flash-lite",
  GoogleGemini3FlashPreview = "google/gemini-3-flash-preview",
  GoogleGemini3ProPreview = "google/gemini-3-pro-preview",
  GoogleGemini31FlashLite = "google/gemini-3.1-flash-lite",
  GoogleGemini31FlashLitePreview = "google/gemini-3.1-flash-lite-preview",
  GoogleGemini31ProPreview = "google/gemini-3.1-pro-preview",
  OpenaiGpt5 = "openai/gpt-5",
  OpenaiGpt51 = "openai/gpt-5.1",
  OpenaiGpt52 = "openai/gpt-5.2",
  OpenaiGpt52Pro = "openai/gpt-5.2-pro",
  OpenaiGpt54 = "openai/gpt-5.4",
  OpenaiGpt5Mini = "openai/gpt-5-mini",
  OpenaiGpt5Nano = "openai/gpt-5-nano",
  OpenaiGptOss120B = "openai/gpt-oss-120b",
  XAiGrok3 = "x-ai/grok-3",
  XAiGrok3Mini = "x-ai/grok-3-mini",
  XAiGrok4 = "x-ai/grok-4",
  XAiGrok41Fast = "x-ai/grok-4.1-fast",
  XAiGrok43 = "x-ai/grok-4.3",
  XAiGrokCodeFast1 = "x-ai/grok-code-fast-1",
  MetaLlamaLlama3370BInstruct = "meta-llama/llama-3.3-70b-instruct",
  MinimaxMinimaxM25 = "minimax/minimax-m2.5",
  MistralaiCodestral2508 = "mistralai/codestral-2508",
  MistralaiMistralLarge = "mistralai/mistral-large",
  MistralaiMistralMedium31 = "mistralai/mistral-medium-3.1",
  MistralaiMistralSmall3224BInstruct2506 = "mistralai/mistral-small-3.2-24b-instruct-2506",
  MistralaiMistralLarge2512 = "mistralai/mistral-large-2512",
  MoonshotaiKimiK2Thinking = "moonshotai/kimi-k2-thinking",
  MoonshotaiKimiK25 = "moonshotai/kimi-k2.5",
  PerplexitySonar = "perplexity/sonar",
  PerplexitySonarDeepResearch = "perplexity/sonar-deep-research",
  PerplexitySonarProSearch = "perplexity/sonar-pro-search",
  QwenQwen3235BA22B = "qwen/qwen3-235b-a22b",
  QwenQwen3535BA3B = "qwen/qwen3.5-35b-a3b",
  ZAiGlm5 = "z-ai/glm-5",
}

export interface LlmModelSelectDto {
  archived: boolean;
  /** @format date-time */
  archivedAt?: string;
  /** Whether the model supports multimodal inputs (images, PDFs, documents) */
  hasMultimodal?: boolean;
  /** Whether the model supports advanced reasoning capabilities */
  hasReasoning?: boolean;
  /** Whether the model has JSON schema support */
  hasStructuredOutputs?: boolean;
  /** Whether the model supports tool/function calling */
  hasTools?: boolean;
  /** Whether the model has search capabilities */
  hasWebSearch?: boolean;
  label: string;
  value: LlmModel;
}

export interface LlmPromptTemplateVariableSelectDto {
  description: string;
  example: string;
  key: string;
}

export enum LlmRole {
  System = "system",
  User = "user",
  Assistant = "assistant",
}

export interface LlmStreamMetadataDto {
  /**
   * The actual AI model that was used for generation
   * @example "gpt-4o-mini"
   */
  actualModel?: string;
  /** The chat ID that was used for generation */
  chatId?: string;
  /** Reason why the generation finished */
  finishReason?: string;
  /**
   * The ID of the LLM log associated with this generation
   * @format uuid
   */
  logId?: string;
  /**
   * The model that was requested for generation
   * @example "gpt-4o-mini"
   */
  requestedModel: string;
  status: LlmStreamStatus;
  /** Total tokens used in the generation */
  totalTokens?: number;
}

export enum LlmStreamStatus {
  Loading = "loading",
  Completed = "completed",
}

export interface MRLAssessmentHistoryItem {
  /**
   * Assessment ID
   * @format uuid
   */
  assessmentId: string;
  /**
   * Assessment date and time in ISO format
   * @format date-time
   */
  date: string;
  /** MRL assessment score */
  score: number;
}

export interface MeiaCatalogInterfaceDegradationModelSelectDto {
  maxDegradationFactor?: object | null;
  modelType?: object | null;
  performanceThreshold?: object | null;
}

export interface MeiaCatalogInterfaceSelectDto {
  bandwidth: string;
  classification: MeiaCatalogInterfaceSelectDtoClassificationEnum;
  degradationModel?: MeiaCatalogInterfaceDegradationModelSelectDto;
  description?: string;
  id: string;
  latency: string;
  name: string;
  type: MeiaCatalogInterfaceSelectDtoTypeEnum;
}

export enum MeiaCatalogInterfaceSelectDtoClassificationEnum {
  CUI = "CUI",
  SECRET = "SECRET",
  TOP_SECRET = "TOP_SECRET",
  UNCLASSIFIED = "UNCLASSIFIED",
}

export enum MeiaCatalogInterfaceSelectDtoTypeEnum {
  BeyondLineOfSight = "BeyondLineOfSight",
  LineOfSight = "LineOfSight",
  MeshRF = "MeshRF",
  Optical = "Optical",
  Other = "Other",
  SATCOM = "SATCOM",
  TacticalDataLink = "TacticalDataLink",
}

export interface MeiaCatalogInterfacesSelectDto {
  interfaces: MeiaCatalogInterfaceSelectDto[];
}

export interface MeiaCatalogInvestigativeQuestionTemplateSelectDto {
  id: string;
  name: string;
  questionText: string;
  tags: string[];
}

export interface MeiaCatalogInvestigativeQuestionTemplatesSelectDto {
  investigativeQuestionTemplates: MeiaCatalogInvestigativeQuestionTemplateSelectDto[];
}

export interface MeiaCatalogKopTemplateSelectDto {
  description: string;
  id: string;
  name: string;
  tags: string[];
}

export interface MeiaCatalogKopTemplatesSelectDto {
  kopTemplates: MeiaCatalogKopTemplateSelectDto[];
}

export interface MeiaCatalogMissionPurposeTemplateContextSelectDto {
  areaOfOperations: string;
  assumptionsConstraints: string;
  authoritiesRoeEnvelope: string;
  blueForceComposition: string;
  commandersIntent: string;
  desiredMissionOutcome: string;
  timeWindow: string;
}

export interface MeiaCatalogMissionPurposeTemplateSelectDto {
  id: string;
  missionContext: MeiaCatalogMissionPurposeTemplateContextSelectDto;
  name: string;
  statementTemplate: string;
  tags: string[];
}

export interface MeiaCatalogMissionPurposeTemplatesSelectDto {
  missionPurposeTemplates: MeiaCatalogMissionPurposeTemplateSelectDto[];
}

export interface MeiaCatalogMoeTemplateSelectDto {
  aggregationMethod: MeiaCatalogMoeTemplateSelectDtoAggregationMethodEnum;
  blockingYellowBehavior: MeiaCatalogMoeTemplateSelectDtoBlockingYellowBehaviorEnum;
  description: string;
  id: string;
  name: string;
  pendingMopBehavior: MeiaCatalogMoeTemplateSelectDtoPendingMopBehaviorEnum;
  tags: string[];
}

export enum MeiaCatalogMoeTemplateSelectDtoAggregationMethodEnum {
  HYBRID = "HYBRID",
  WEIGHTED_CONTRIBUTING = "WEIGHTED_CONTRIBUTING",
  WORST_CASE_BLOCKING = "WORST_CASE_BLOCKING",
}

export enum MeiaCatalogMoeTemplateSelectDtoBlockingYellowBehaviorEnum {
  IGNORE = "IGNORE",
  PROPAGATE_YELLOW = "PROPAGATE_YELLOW",
}

export enum MeiaCatalogMoeTemplateSelectDtoPendingMopBehaviorEnum {
  BLOCK_SCORING = "BLOCK_SCORING",
  EXCLUDE_FROM_AVERAGE = "EXCLUDE_FROM_AVERAGE",
  TREAT_AS_RED = "TREAT_AS_RED",
  TREAT_AS_YELLOW = "TREAT_AS_YELLOW",
}

export interface MeiaCatalogMoeTemplatesSelectDto {
  moeTemplates: MeiaCatalogMoeTemplateSelectDto[];
}

export interface MeiaCatalogMopTemplateSelectDto {
  category: MeiaCatalogMopTemplateSelectDtoCategoryEnum;
  defaultUnit: string;
  description: string;
  direction: MeiaCatalogMopTemplateSelectDtoDirectionEnum;
  id: string;
  name: string;
  tags: string[];
}

export enum MeiaCatalogMopTemplateSelectDtoCategoryEnum {
  PROCESS_RELIABILITY = "PROCESS_RELIABILITY",
  TECHNICAL_PHYSICAL = "TECHNICAL_PHYSICAL",
  TIME_LATENCY = "TIME_LATENCY",
}

export enum MeiaCatalogMopTemplateSelectDtoDirectionEnum {
  HIGHER_IS_BETTER = "HIGHER_IS_BETTER",
  LOWER_IS_BETTER = "LOWER_IS_BETTER",
}

export interface MeiaCatalogMopTemplatesSelectDto {
  mopTemplates: MeiaCatalogMopTemplateSelectDto[];
}

export interface MeiaCatalogMosTemplateSelectDto {
  description: string;
  id: string;
  name: string;
  tags: string[];
}

export interface MeiaCatalogMosTemplatesSelectDto {
  mosTemplates: MeiaCatalogMosTemplateSelectDto[];
}

export interface MeiaCatalogRedForceActivitiesSelectDto {
  redForceActivities: MeiaCatalogRedForceActivitySelectDto[];
}

export interface MeiaCatalogRedForceActivityProvenanceSelectDto {
  confidenceTier: ConfidenceTier;
  source: RedForceActivityProvenanceSource;
}

export interface MeiaCatalogRedForceActivitySelectDto {
  adversaryProfileRefs: string[];
  associatedKillChainPhases: string[];
  description: string;
  id: string;
  name: string;
  provenance: MeiaCatalogRedForceActivityProvenanceSelectDto;
  shortName: string;
  supportedByTargetSystemCodes: string[];
  tier: number;
}

export interface MeiaCatalogStakeholderTemplateSelectDto {
  id: string;
  name: string;
  responsibilityTemplate: string;
  roleLabel: string;
  studyRole: StudyStakeholderRole;
  tags: string[];
}

export interface MeiaCatalogStakeholderTemplatesSelectDto {
  stakeholderTemplates: MeiaCatalogStakeholderTemplateSelectDto[];
}

export interface MeiaCatalogThreatTargetComponentSelectDto {
  componentType: MeiaCatalogThreatTargetComponentSelectDtoComponentTypeEnum;
  description?: string;
  id: string;
  name: string;
}

export enum MeiaCatalogThreatTargetComponentSelectDtoComponentTypeEnum {
  C2 = "C2",
  DATALINK = "DATALINK",
  EW = "EW",
  LAUNCHER = "LAUNCHER",
  NAVIGATION = "NAVIGATION",
  OTHER = "OTHER",
  POWER = "POWER",
  PROCESSOR = "PROCESSOR",
  SENSOR = "SENSOR",
}

export interface MeiaCatalogThreatTargetMopSelectDto {
  category: string;
  direction: MeiaCatalogThreatTargetMopSelectDtoDirectionEnum;
  id: string;
  metric: string;
  objective: number;
  threshold: number;
}

export enum MeiaCatalogThreatTargetMopSelectDtoDirectionEnum {
  HIGHER_IS_BETTER = "HIGHER_IS_BETTER",
  LOWER_IS_BETTER = "LOWER_IS_BETTER",
}

export interface MeiaCatalogThreatTargetSystemSelectDto {
  classification: MeiaCatalogThreatTargetSystemSelectDtoClassificationEnum;
  components?: MeiaCatalogThreatTargetComponentSelectDto[];
  description?: string;
  domain: MeiaCatalogThreatTargetSystemSelectDtoDomainEnum;
  id: string;
  name: string;
  nation: string;
  targetMops?: MeiaCatalogThreatTargetMopSelectDto[];
}

export enum MeiaCatalogThreatTargetSystemSelectDtoClassificationEnum {
  CUI = "CUI",
  SECRET = "SECRET",
  TOP_SECRET = "TOP_SECRET",
  UNCLASSIFIED = "UNCLASSIFIED",
}

export enum MeiaCatalogThreatTargetSystemSelectDtoDomainEnum {
  AIR = "AIR",
  CYBER = "CYBER",
  LAND = "LAND",
  MARITIME = "MARITIME",
  MULTI_DOMAIN = "MULTI_DOMAIN",
  SPACE = "SPACE",
}

export interface MeiaCatalogThreatTargetSystemsSelectDto {
  threatTargetSystems: MeiaCatalogThreatTargetSystemSelectDto[];
}

export interface MeiaSearchResultDto {
  id: string;
  label: string;
  /** @format uuid */
  missionId?: string | null;
  /** @format uuid */
  studyId: string;
  studyName: string;
  /** @format uuid */
  threadId?: string | null;
  type: MeiaSearchResultType;
}

export enum MeiaSearchResultType {
  STUDY = "STUDY",
  TASK = "TASK",
  THREAD = "THREAD",
}

export interface MeiaSearchResultsSelectDto {
  results: MeiaSearchResultDto[];
}

export interface MissionAssessmentAiQueryDto {
  effectContext?: MissionAssessmentEffectAiContextDto;
  fieldName: MissionAssessmentFieldName;
  interContext?: MissionAssessmentInterAiContextDto;
  model?: LlmModel;
  prompt?: string;
  /** @format uuid */
  technologyId: string;
}

export interface MissionAssessmentCapabilityAiGenerationDataDto {
  capabilities: string[];
}

export interface MissionAssessmentCapabilityAiGenerationMetadataDto {
  actualModel?: string;
  logId: string;
  requestedModel: string;
}

export interface MissionAssessmentCapabilityAiGenerationResponseDto {
  data: MissionAssessmentCapabilityAiGenerationDataDto;
  metadata: MissionAssessmentCapabilityAiGenerationMetadataDto;
}

export interface MissionAssessmentCapabilityAiQueryDto {
  currentCapabilities?: string[];
  model?: LlmModel;
  /** @maxLength 2000 */
  prompt?: string;
  /** @format uuid */
  technologyId: string;
}

export enum MissionAssessmentChatObjectKind {
  CAPABILITIES = "CAPABILITIES",
  EFFECT = "EFFECT",
  FULL_ASSESSMENT = "FULL_ASSESSMENT",
  INTER = "INTER",
}

export interface MissionAssessmentChatQueryDto {
  currentCapabilities?: string[];
  effectContext?: MissionAssessmentEffectAiContextDto;
  fieldName?: MissionAssessmentFieldName;
  formSnapshot?: MissionAssessmentFullSnapshotDto;
  interContext?: MissionAssessmentInterAiContextDto;
  interType?: MissionAssessmentInterType;
  messages: ChatMessageDto[];
  model?: LlmModel;
  objectKind?: MissionAssessmentChatObjectKind;
  targetSectionIds?: FullAssessmentSectionId[];
  /** @format uuid */
  technologyId: string;
}

export interface MissionAssessmentCoreSelectDto {
  /** @format date-time */
  createdAt: string;
  data: MissionAssessmentDataDto;
  expert?: UserSelectDto;
  id: string;
  /** AI provenance per field (ADR-0007), keyed by MissionAssessmentFieldName. Read-only. */
  provenance?: Record<string, FieldProvenanceDto>;
  request: MissionAssessmentRequestNestedSelectDto;
  technology: TechnologyNestedSelectDto;
  /** @format date-time */
  updatedAt: string;
  /** @format uuid */
  version?: string;
}

export interface MissionAssessmentCreateDto {
  capabilities: string[];
  communities: string[];
  data: MissionAssessmentDataDto;
  effects: MissionAssessmentEffectCreateDto[];
  inters: MissionAssessmentInterCreateDto[];
  killChains: string[];
  maxPhase?: number;
  minPhase?: number;
  provenance?: Record<string, FieldProvenanceDto>;
  provenanceInput?: Record<string, FieldProvenanceInputDto>;
  /** @deprecated */
  recommendedDomains?: string[];
  /** Array of recommended services with units */
  recommendedServices: MissionAssessmentServiceCreateDto[];
  recommendedTechnologyUses: MissionAssessmentTechnologyUseCreateDto[];
  /** @deprecated */
  recommendedUses?: string[];
  /** @format uuid */
  requestId: string;
  taskRecommendations: MissionAssessmentTaskRecommendationCreateDto[];
  /** @format uuid */
  technologyId: string;
  /** @format uuid */
  version?: string;
}

export interface MissionAssessmentDataDto {
  expertNotes?: MissionAssessmentExpertNoteDto[];
  generalNotes?: string;
  hurdles?: MissionAssessmentHurdlesDto;
  maxPhase?: number;
  minPhase?: number;
  phases?: number[];
}

export interface MissionAssessmentDraftCreateDto {
  capabilities?: string[];
  communities?: string[];
  data?: MissionAssessmentDataDto;
  effects?: MissionAssessmentDraftEffectDataDto[];
  inters?: MissionAssessmentDraftInterDataDto[];
  killChains?: string[];
  maxPhase?: number;
  minPhase?: number;
  /** Per-field AI provenance signals (ADR-0007), keyed by MissionAssessmentFieldName, for fields accepted from an LLM Suggestion in this save. */
  provenanceInput?: Record<string, FieldProvenanceInputDto>;
  /** @deprecated */
  recommendedDomains?: string[];
  recommendedServices?: MissionAssessmentDraftServiceDataDto[];
  recommendedTechnologyUses?: MissionAssessmentDraftTechnologyUseDataDto[];
  /** @deprecated */
  recommendedUses?: string[];
  /** @format uuid */
  requestId: string;
  status?: MissionAssessmentDraftStatus;
  taskRecommendations?: MissionAssessmentDraftTaskRecommendationDataDto[];
  /** @format uuid */
  technologyId: string;
  /** @format uuid */
  version?: string;
}

export interface MissionAssessmentDraftEffectDataDto {
  data?: MissionAssessmentEffectDataDto;
  /** @format uuid */
  domainId?: string;
  /** @format uuid */
  effectId?: string;
  secondaryEffects?: string[];
  targetSystems?: string[];
  /** @format uuid */
  useId?: string;
}

export interface MissionAssessmentDraftInterDataDto {
  /** @format uuid */
  categoryId?: string;
  country?: string;
  description?: string;
  digitalIntegrationIds?: string[];
  fieldedStatus?: FieldedStatus;
  mrl?: number;
  name?: string;
  notes?: string;
  operationalIntegrationIds?: string[];
  physicalIntegrationIds?: string[];
  priorityRationale?: string;
  priorityScore?: number;
  reference?: string;
  /** @format uuid */
  subcategoryId?: string;
  trl?: number;
  type?: MissionAssessmentInterType;
  verificationConfidence?: VerificationConfidence;
  verificationNotes?: string;
}

export interface MissionAssessmentDraftListItemDto {
  /** @format uuid */
  expertId: string;
  /** @format uuid */
  id: string;
  /** @format date-time */
  updatedAt: string;
  /** @format uuid */
  version?: string;
}

export interface MissionAssessmentDraftPatchDto {
  capabilities?: string[];
  communities?: string[];
  data?: MissionAssessmentDataDto;
  effects?: MissionAssessmentDraftEffectDataDto[];
  inters?: MissionAssessmentDraftInterDataDto[];
  killChains?: string[];
  maxPhase?: number;
  minPhase?: number;
  /** Per-field AI provenance signals (ADR-0007), keyed by MissionAssessmentFieldName, for fields accepted from an LLM Suggestion in this save. */
  provenanceInput?: Record<string, FieldProvenanceInputDto>;
  /** @deprecated */
  recommendedDomains?: string[];
  recommendedServices?: MissionAssessmentDraftServiceDataDto[];
  recommendedTechnologyUses?: MissionAssessmentDraftTechnologyUseDataDto[];
  /** @deprecated */
  recommendedUses?: string[];
  status?: MissionAssessmentDraftStatus;
  taskRecommendations?: MissionAssessmentDraftTaskRecommendationDataDto[];
  /** @format uuid */
  version?: string;
}

export interface MissionAssessmentDraftSelectDto {
  capabilities?: string[];
  communities?: string[];
  /** @format date-time */
  createdAt: string;
  data?: MissionAssessmentDataDto;
  effects?: MissionAssessmentDraftEffectDataDto[];
  expert?: UserNestedSelectDto;
  /** @format uuid */
  id: string;
  inters?: MissionAssessmentDraftInterDataDto[];
  killChains?: string[];
  maxPhase?: number;
  minPhase?: number;
  /** AI provenance per field (ADR-0007), keyed by MissionAssessmentFieldName. Read-only. */
  provenance?: Record<string, FieldProvenanceDto>;
  /** @deprecated */
  recommendedDomains?: string[];
  recommendedServices?: MissionAssessmentDraftServiceDataDto[];
  recommendedTechnologyUses?: MissionAssessmentDraftTechnologyUseDataDto[];
  /** @deprecated */
  recommendedUses?: string[];
  request: MissionAssessmentRequestNestedSelectDto;
  status?: MissionAssessmentDraftStatus;
  taskRecommendations?: MissionAssessmentDraftTaskRecommendationDataDto[];
  technology: TechnologyNestedSelectDto;
  /** @format date-time */
  updatedAt: string;
  /** @format uuid */
  version?: string;
}

export interface MissionAssessmentDraftServiceDataDto {
  /** @format uuid */
  serviceId?: string;
  unit?: string;
}

export enum MissionAssessmentDraftStatus {
  COMPLETE = "COMPLETE",
  DRAFT = "DRAFT",
}

export interface MissionAssessmentDraftTaskRecommendationDataDto {
  description?: string;
}

export interface MissionAssessmentDraftTechnologyUseDataDto {
  description?: string;
  domainIds: string[];
  /** @format uuid */
  useId: string;
}

export interface MissionAssessmentDraftsSelectDto {
  missionAssessmentDrafts: MissionAssessmentDraftSelectDto[];
}

export interface MissionAssessmentEffectAiContextDto {
  /** @format uuid */
  effectId?: string;
  secondaryEffectIds?: string[];
}

export interface MissionAssessmentEffectAiGenerationDataDto {
  data: MissionAssessmentEffectDataDto;
  /** @format uuid */
  domainId: string;
  /** @format uuid */
  effectId: string;
  secondaryEffects: string[];
  targetSystems: string[];
  /** @format uuid */
  useId: string;
}

export interface MissionAssessmentEffectAiGenerationMetadataDto {
  actualModel?: string;
  logId: string;
  requestedModel: string;
}

export interface MissionAssessmentEffectAiGenerationResponseDto {
  data: MissionAssessmentEffectAiGenerationDataDto;
  metadata: MissionAssessmentEffectAiGenerationMetadataDto;
}

export interface MissionAssessmentEffectAiQueryDto {
  model?: LlmModel;
  /** @maxLength 2000 */
  prompt?: string;
  /** @format uuid */
  technologyId: string;
}

export interface MissionAssessmentEffectCostDto {
  amount: number;
  currency: MissionAssessmentEffectCostDtoCurrencyEnum;
}

export enum MissionAssessmentEffectCostDtoCurrencyEnum {
  AUD = "AUD",
  EUR = "EUR",
  GBP = "GBP",
  USD = "USD",
}

export interface MissionAssessmentEffectCreateDto {
  data: MissionAssessmentEffectDataDto;
  /** @format uuid */
  domainId: string;
  /** @format uuid */
  effectId: string;
  secondaryEffects: string[];
  targetSystems: string[];
  /** @format uuid */
  useId: string;
}

export interface MissionAssessmentEffectDataDto {
  cost?: MissionAssessmentEffectCostDto;
  costToReplace?: MissionAssessmentEffectCostDto;
  /** @maxLength 500 */
  description?: string;
  maxPhase?: number;
  measureOfImpact?: string;
  measuresOfPerformance?: string;
  minPhase?: number;
  personnelRequired?: number;
  phases?: number[];
  timeToDeploy?: MissionAssessmentEffectTimeDto;
  timeToReplace?: MissionAssessmentEffectTimeDto;
  unit?: string;
}

export interface MissionAssessmentEffectSelectDto {
  data: MissionAssessmentEffectDataDto;
  domain: DomainNestedSelectDto;
  effect: EffectSelectDto;
  secondaryEffects: EffectSecondarySelectDto[];
  targetSystems: TargetSystemSelectDto[];
  use: UseSelectDto;
}

export interface MissionAssessmentEffectTimeDto {
  unit: MissionAssessmentEffectTimeUnit;
  value: number;
}

export enum MissionAssessmentEffectTimeUnit {
  DAYS = "DAYS",
  HOURS = "HOURS",
  WEEKS = "WEEKS",
}

export interface MissionAssessmentEffectsSelectDto {
  effects: MissionAssessmentEffectSelectDto[];
}

export interface MissionAssessmentExpertNoteDto {
  content: string;
  identifier: ExpertNoteIdentifier;
}

export enum MissionAssessmentFieldName {
  GENERAL_NOTES = "GENERAL_NOTES",
  NEXT_MRL = "NEXT_MRL",
  NEXT_TRL = "NEXT_TRL",
  SUPPLY_CHAIN = "SUPPLY_CHAIN",
  THREATS = "THREATS",
  STRATEGIC = "STRATEGIC",
  RISKS = "RISKS",
  SUSTAINMENT = "SUSTAINMENT",
  INTEROPERABLE_NAME = "INTEROPERABLE_NAME",
  INTEROPERABLE_DESCRIPTION = "INTEROPERABLE_DESCRIPTION",
  INTEROPERABLE_NOTES = "INTEROPERABLE_NOTES",
  INTERCHANGEABLE_NAME = "INTERCHANGEABLE_NAME",
  INTERCHANGEABLE_DESCRIPTION = "INTERCHANGEABLE_DESCRIPTION",
  INTERCHANGEABLE_NOTES = "INTERCHANGEABLE_NOTES",
  EFFECT_DESCRIPTION = "EFFECT_DESCRIPTION",
  EFFECT_MEASURE_OF_IMPACT = "EFFECT_MEASURE_OF_IMPACT",
  EFFECT_MEASURES_OF_PERFORMANCE = "EFFECT_MEASURES_OF_PERFORMANCE",
}

export interface MissionAssessmentFullSnapshotDto {
  capabilities?: string[];
  communities?: string[];
  effects?: MissionAssessmentFullSnapshotEffectDto[];
  expertNotes?: MissionAssessmentFullSnapshotExpertNoteDto[];
  /** @maxLength 4000 */
  generalNotes?: string;
  hurdles?: MissionAssessmentFullSnapshotHurdlesDto;
  inters?: MissionAssessmentFullSnapshotInterDto[];
  killChains?: string[];
  /**
   * @min 0
   * @max 5
   */
  maxPhase?: number;
  /**
   * @min 0
   * @max 5
   */
  minPhase?: number;
  recommendedServices?: MissionAssessmentFullSnapshotServiceDto[];
  recommendedTechnologyUses?: MissionAssessmentFullSnapshotTechnologyUseDto[];
  taskRecommendations?: string[];
}

export interface MissionAssessmentFullSnapshotEffectDto {
  /** @format uuid */
  domainId?: string;
  /** @format uuid */
  effectId?: string;
  /** @format uuid */
  useId?: string;
}

export interface MissionAssessmentFullSnapshotExpertNoteDto {
  /** @maxLength 4000 */
  content: string;
  identifier: ExpertNoteIdentifier;
}

export interface MissionAssessmentFullSnapshotHurdlesDto {
  /** @maxLength 4000 */
  nextMrl?: string;
  /**
   * @min 1
   * @max 10
   */
  nextMrlScore?: number;
  /** @maxLength 4000 */
  nextTrl?: string;
  /**
   * @min 1
   * @max 9
   */
  nextTrlScore?: number;
  /** @maxLength 4000 */
  supplyChain?: string;
}

export interface MissionAssessmentFullSnapshotInterDto {
  /** @maxLength 500 */
  name?: string;
  type?: MissionAssessmentInterType;
}

export interface MissionAssessmentFullSnapshotServiceDto {
  /** @format uuid */
  serviceId: string;
  /** @maxLength 200 */
  unit?: string;
}

export interface MissionAssessmentFullSnapshotTechnologyUseDto {
  domainIds?: string[];
  /** @format uuid */
  useId: string;
}

export interface MissionAssessmentHurdlesDto {
  nextMrl?: string;
  nextMrlScore?: number;
  nextTrl?: string;
  nextTrlScore?: number;
  supplyChain?: string;
}

export interface MissionAssessmentInterAiContextDto {
  /** @maxLength 500 */
  name?: string;
  /** @maxLength 1000 */
  reference?: string;
}

export interface MissionAssessmentInterAiGenerationDataDto {
  /** @format uuid */
  categoryId: string;
  description: string;
  digitalIntegrationIds?: string[];
  fieldedStatus?: FieldedStatus;
  mrl?: number;
  name: string;
  notes: string;
  operationalIntegrationIds?: string[];
  physicalIntegrationIds?: string[];
  priorityRationale?: string;
  priorityScore?: number;
  reference?: string;
  /** @format uuid */
  subcategoryId: string;
  trl?: number;
  type: MissionAssessmentInterType;
  verificationConfidence?: VerificationConfidence;
  verificationNotes?: string;
}

export interface MissionAssessmentInterAiGenerationMetadataDto {
  actualModel?: string;
  logId: string;
  requestedModel: string;
}

export interface MissionAssessmentInterAiGenerationResponseDto {
  data: MissionAssessmentInterAiGenerationDataDto;
  metadata: MissionAssessmentInterAiGenerationMetadataDto;
}

export interface MissionAssessmentInterAiQueryDto {
  model?: LlmModel;
  prompt?: string;
  /** @format uuid */
  technologyId: string;
  type: MissionAssessmentInterType;
}

export interface MissionAssessmentInterCreateDto {
  /** @format uuid */
  categoryId: string;
  country?: string;
  /** @maxLength 500 */
  description?: string;
  digitalIntegrationIds?: string[];
  fieldedStatus?: FieldedStatus;
  mrl?: number;
  /**
   * @minLength 2
   * @maxLength 60
   */
  name: string;
  notes: string;
  operationalIntegrationIds?: string[];
  physicalIntegrationIds?: string[];
  priorityRationale?: string;
  priorityScore?: number;
  reference?: string;
  /** @format uuid */
  subcategoryId: string;
  trl?: number;
  type: MissionAssessmentInterType;
  verificationConfidence?: VerificationConfidence;
  verificationNotes?: string;
}

export interface MissionAssessmentInterSelectDto {
  category: CategoryNestedSelectDto;
  country?: string;
  description?: string;
  digitalIntegrations?: DigitalIntegrationSelectDto[];
  fieldedStatus?: FieldedStatus;
  mrl?: number;
  name?: string;
  notes: string;
  operationalIntegrations?: OperationalIntegrationSelectDto[];
  physicalIntegrations?: PhysicalIntegrationSelectDto[];
  priorityRationale?: string;
  priorityScore?: number;
  reference?: string;
  subcategory?: CategoryNestedSelectDto;
  trl?: number;
  type: MissionAssessmentInterType;
  verificationConfidence?: VerificationConfidence;
  verificationNotes?: string;
}

export enum MissionAssessmentInterType {
  INTERCHANGEABLE = "INTERCHANGEABLE",
  INTEROPERABLE = "INTEROPERABLE",
}

export interface MissionAssessmentIntersSelectDto {
  inters: MissionAssessmentInterSelectDto[];
}

export interface MissionAssessmentListItemDto {
  accessRestricted?: boolean;
  accessRestrictedMessage?: string;
  expert?: MissionAssessmentListItemExpertDto;
  /** @format uuid */
  expertId: string;
  /** @format uuid */
  id: string;
  request?: MissionAssessmentListItemRequestDto;
  /** @format date-time */
  updatedAt: string;
  /** @format uuid */
  version?: string;
}

export interface MissionAssessmentListItemExpertDto {
  avatarUrl?: string;
  /** @format uuid */
  id: string;
  profile?: MissionAssessmentListItemExpertProfileDto;
}

export interface MissionAssessmentListItemExpertProfileDto {
  fullName: string;
  title: string;
}

export interface MissionAssessmentListItemRequestDto {
  domain?: DomainSecondarySelectDto;
  /** @format uuid */
  id: string;
  use?: UseSelectDto;
}

export interface MissionAssessmentMetadataSelectDto {
  capabilities: CapabilitySubSelectDto[];
  communities: CommunitySelectDto[];
  id: string;
  killChains: KillChainSelectDto[];
  /** @deprecated */
  recommendedDomains: DomainSelectDto[];
  recommendedTechnologyUses: MissionAssessmentTechnologyUseSelectDto[];
  /** @deprecated */
  recommendedUses: UseSelectDto[];
}

export interface MissionAssessmentRequestCreateDto {
  /**
   * ID of the Domain that will be used for the assessment
   * @format uuid
   */
  domainId: string;
  /**
   * Whether the expert matching criteria are strictly enforced
   * @default false
   */
  isStrictMatch: boolean;
  /** Additional information for the mission assessment request */
  message?: string;
  /**
   * ID of the technology for which to request an assessment
   * @format uuid
   */
  technologyId: string;
  /**
   * ID of the Use that will be used for the assessment
   * @format uuid
   */
  useId: string;
  /** Countries where experts served */
  veteranCountriesOfService?: string[];
  /** IDs of veteran services */
  veteranServiceIds?: string[];
}

export interface MissionAssessmentRequestNestedSelectDto {
  /** @format date-time */
  createdAt: string;
  domain: DomainSecondarySelectDto;
  /** @format uuid */
  id: string;
  /** Whether the expert matching criteria are strictly enforced */
  isStrictMatch: boolean;
  message?: string;
  /** User who requested the assessment */
  requester?: RequesterNestedSelectDto;
  status: MissionAssessmentRequestStatus;
  use: UseSelectDto;
  /** Countries where experts served */
  veteranCountriesOfService?: string[];
  /** Veteran services for expert matching */
  veteranServices?: ServiceSubSelectDto[];
}

export interface MissionAssessmentRequestPatchDto {
  /**
   * ID of the Domain that will be used for the assessment
   * @format uuid
   */
  domainId?: string;
  /**
   * Whether the expert matching criteria are strictly enforced
   * @default false
   */
  isStrictMatch?: boolean;
  /** Additional information for the mission assessment request */
  message?: string;
  /**
   * ID of the mission assessment once completed
   * @format uuid
   */
  missionAssessmentId?: string;
  status?: MissionAssessmentRequestPatchDtoStatusEnum;
  /**
   * ID of the Use that will be used for the assessment
   * @format uuid
   */
  useId?: string;
  /** Countries where experts served */
  veteranCountriesOfService?: string[];
  /** IDs of veteran services */
  veteranServiceIds?: string[];
}

export enum MissionAssessmentRequestPatchDtoStatusEnum {
  ASSESSED = "ASSESSED",
  CANCELLED = "CANCELLED",
  IN_PROGRESS = "IN_PROGRESS",
  REQUESTED = "REQUESTED",
}

export interface MissionAssessmentRequestSelectDto {
  /** @format date-time */
  createdAt: string;
  domain: DomainSecondarySelectDto;
  /** @format uuid */
  id: string;
  /** Whether the expert matching criteria are strictly enforced */
  isStrictMatch: boolean;
  message?: string;
  missionAssessments?: MissionAssessmentSelectDto[];
  /** User who requested the assessment */
  requester?: RequesterNestedSelectDto;
  status: MissionAssessmentRequestStatus;
  technology: TechnologyNestedSelectDto;
  use: UseSelectDto;
  /** Countries where experts served */
  veteranCountriesOfService?: string[];
  /** Veteran services for expert matching */
  veteranServices?: ServiceSubSelectDto[];
}

export enum MissionAssessmentRequestStatus {
  ASSESSED = "ASSESSED",
  CANCELLED = "CANCELLED",
  IN_PROGRESS = "IN_PROGRESS",
  REQUESTED = "REQUESTED",
}

export interface MissionAssessmentRequestsSelectDto {
  missionAssessmentRequests: MissionAssessmentRequestSelectDto[];
}

export interface MissionAssessmentSelectDto {
  accessRestricted?: boolean;
  accessRestrictedMessage?: string;
  capabilities: CapabilitySubSelectDto[];
  communities: CommunitySelectDto[];
  /** @format date-time */
  createdAt: string;
  data: MissionAssessmentDataDto;
  effects: MissionAssessmentEffectSelectDto[];
  expert?: UserSelectDto;
  id: string;
  inters: MissionAssessmentInterSelectDto[];
  killChains: KillChainSelectDto[];
  /** AI provenance per field (ADR-0007), keyed by MissionAssessmentFieldName. Read-only. */
  provenance?: Record<string, FieldProvenanceDto>;
  /** @deprecated */
  recommendedDomains: DomainSelectDto[];
  recommendedServices: MissionAssessmentServiceSelectDto[];
  recommendedTechnologyUses: MissionAssessmentTechnologyUseSelectDto[];
  /** @deprecated */
  recommendedUses: UseSelectDto[];
  request: MissionAssessmentRequestNestedSelectDto;
  taskRecommendations: MissionAssessmentTaskRecommendationSelectDto[];
  technology: TechnologyNestedSelectDto;
  /** @format date-time */
  updatedAt: string;
  /** @format uuid */
  version?: string;
}

export interface MissionAssessmentServiceCreateDto {
  /**
   * The ID of the service being recommended.
   * @format uuid
   */
  serviceId: string;
  /**
   * The unit associated with the service recommendation.
   * @example "Per Unit"
   */
  unit?: string;
}

export interface MissionAssessmentServiceSelectDto {
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  id: string;
  service: ServiceSubSelectDto;
  /**
   * The unit for the service.
   * @example "Per Unit"
   */
  unit?: string;
  /** @format date-time */
  updatedAt: string;
}

export interface MissionAssessmentServicesSelectDto {
  recommendedServices: MissionAssessmentServiceSelectDto[];
  taskRecommendations: MissionAssessmentTaskRecommendationSelectDto[];
}

export interface MissionAssessmentTaskRecommendationCreateDto {
  description: string;
}

export interface MissionAssessmentTaskRecommendationSelectDto {
  /** @format date-time */
  createdAt: string;
  description: string;
  /** @format uuid */
  id: string;
  /** @format uuid */
  missionAssessmentId: string;
  /** @format date-time */
  updatedAt: string;
}

export interface MissionAssessmentTechnologyUseCreateDto {
  /** @maxLength 500 */
  description?: string;
  domains: MissionAssessmentTechnologyUseDomainCreateDto[];
  /** @format uuid */
  useId: string;
}

export interface MissionAssessmentTechnologyUseDomainCreateDto {
  /** @format uuid */
  domainId: string;
}

export interface MissionAssessmentTechnologyUseSelectDto {
  description?: string;
  domains: DomainSecondarySelectDto[];
  /** @format uuid */
  id: string;
  use: UseSelectDto;
  /** @format uuid */
  useId: string;
}

export interface MissionAssessmentsSelectDto {
  missionAssessments: MissionAssessmentSelectDto[];
}

export interface MissionListSelectDto {
  /** @format uuid */
  id: string;
  name: string;
  studyClassificationLevel?: ClassificationLevel | null;
  /** @format uuid */
  studyId: string;
  studyName?: string | null;
}

export interface MissionsListSelectDto {
  missions: MissionListSelectDto[];
}

export enum MopAggregation {
  AVERAGE = "AVERAGE",
  BEST = "BEST",
  WORST = "WORST",
}

export enum MopValueSource {
  COMPUTED = "COMPUTED",
  MANUAL_ENTRY = "MANUAL_ENTRY",
}

export interface OperationalIntegrationSelectDto {
  /** @format uuid */
  id: string;
  name: string;
}

export interface OperationalIntegrationsSelectDto {
  operationalIntegrations: OperationalIntegrationSelectDto[];
}

export enum OperationalRegion {
  ARCTIC = "ARCTIC",
  BALTIC = "BALTIC",
  BLACK_SEA = "BLACK_SEA",
  CARIBBEAN = "CARIBBEAN",
  CENTRAL_EUROPE = "CENTRAL_EUROPE",
  CONUS = "CONUS",
  EAS = "EAS",
  GLOBAL = "GLOBAL",
  GULF_STATES = "GULF_STATES",
  HORN_AFRICA = "HORN_AFRICA",
  INDOPACOM_NORTH = "INDOPACOM_NORTH",
  INDOPACOM_SOUTH = "INDOPACOM_SOUTH",
  LEVANT = "LEVANT",
  NORTH_ATLANTIC = "NORTH_ATLANTIC",
  SCS = "SCS",
}

export interface PendingUploadDto {
  /** @format uuid */
  attachmentId: string;
  /** @format url */
  uploadUrl: string;
}

export interface PhysicalIntegrationSelectDto {
  /** @format uuid */
  id: string;
  name: string;
}

export interface PhysicalIntegrationsSelectDto {
  physicalIntegrations: PhysicalIntegrationSelectDto[];
}

export interface PrimaryReferenceDto {
  source: string;
  title: string;
  type: PrimaryReferenceDtoTypeEnum;
  url: string;
}

export enum PrimaryReferenceDtoTypeEnum {
  Patent = "patent",
  Article = "article",
}

export interface ProductCreateDto {
  /** @maxLength 2000 */
  description?: string;
  /**
   * @minLength 2
   * @maxLength 60
   */
  name: string;
  technologyIds?: string[];
}

export interface ProductSelectDto {
  createdAt: string;
  /** @maxLength 2000 */
  description?: string;
  /** @format uuid */
  id: string;
  /**
   * @minLength 2
   * @maxLength 60
   */
  name: string;
  technologies: TechnologyNestedSelectDto[];
  updatedAt: string;
}

export interface ProductUpdateDto {
  /** @maxLength 2000 */
  description?: string;
  /**
   * @minLength 2
   * @maxLength 60
   */
  name?: string;
  technologyIds?: string[];
}

export interface ProductsSelectDto {
  products: ProductSelectDto[];
}

export interface QuestionSelectDto {
  description?: string;
  /** @format uuid */
  id: string;
  label?: string;
  prompt: string;
  type: QuestionType;
}

export enum QuestionType {
  CYBER = "CYBER",
  FREEFORM = "FREEFORM",
  PROGRESS = "PROGRESS",
  PROGRESS_OPTIONAL = "PROGRESS_OPTIONAL",
  TRL_CHARACTERISTICS = "TRL_CHARACTERISTICS",
}

export enum RedForceActivityProvenanceSource {
  Admin = "admin",
  IntelPkg = "intel-pkg",
  JLLIS = "JLLIS",
  Sme = "sme",
  User = "user",
}

export interface ReferenceUrlDto {
  /** @format string */
  label: string;
  /** @format url */
  url: string;
}

export interface RequesterNestedSelectDto {
  /** @format email */
  email: string;
  /** @format uuid */
  id: string;
  profile?: RequesterProfileNestedSelectDto;
}

export interface RequesterProfileNestedSelectDto {
  /** @format string */
  firstName?: string;
  /** @format string */
  lastName?: string;
}

export interface ResearchKeywordCreateDto {
  name: string;
}

export interface ResearchKeywordSelectDto {
  /** @format uuid */
  id: string;
  name: string;
}

export interface ResearchKeywordsSelectDto {
  researchKeywords: ResearchKeywordSelectDto[];
}

export interface ResearchOrganizationContactDto {
  /** @format email */
  email?: string;
  /** @format string */
  name?: string;
}

export interface ResearchOrganizationDataDto {
  departmentHeadContact?: ResearchOrganizationContactDto;
  /** @format string */
  departmentName?: string;
  foreignAffiliates?: string[];
  funding?: ResearchOrganizationFundingDto;
  /** @format boolean */
  ipLicense?: boolean;
  techTransferContact?: ResearchOrganizationContactDto;
  type?: ResearchOrganizationType;
}

export interface ResearchOrganizationFundingDto {
  countries?: string[];
  type?: ResearchOrganizationFundingType;
}

export enum ResearchOrganizationFundingType {
  GOVERNMENT = "GOVERNMENT",
  PRIVATE = "PRIVATE",
  FOREIGN_NATION = "FOREIGN_NATION",
}

export enum ResearchOrganizationType {
  UNIVERSITY = "UNIVERSITY",
  RESEARCH_CENTER = "RESEARCH_CENTER",
  NATIONAL_LAB = "NATIONAL_LAB",
  FOUNDATION = "FOUNDATION",
  CO_OPERATIVE_NETWORK = "CO_OPERATIVE_NETWORK",
  CORPORATE = "CORPORATE",
  OTHER = "OTHER",
}

export enum ScoringBand {
  GREEN = "GREEN",
  PENDING = "PENDING",
  RED = "RED",
  YELLOW = "YELLOW",
}

export enum ScoringRole {
  BLOCKING = "BLOCKING",
  CONTRIBUTING = "CONTRIBUTING",
}

export enum ScoringRunStatus {
  COMPLETE = "COMPLETE",
  FAILED = "FAILED",
  PENDING = "PENDING",
  RUNNING = "RUNNING",
  STALE = "STALE",
}

export interface ServiceSelectDto {
  category?: string;
  /** @format uuid */
  id: string;
  name: string;
  subServices: ServiceSubSelectDto[];
}

export interface ServiceSubSelectDto {
  category?: string;
  /** @format uuid */
  id: string;
  name: string;
  parentService?: ServiceSubSelectDto;
  slug?: string | null;
}

export interface ServicesSelectDto {
  services: ServiceSelectDto[];
}

export interface SimilarTechnologyDto {
  category: string;
  confidence: number;
  evidence: SimilarTechnologyEvidenceDto[];
  explanation: string;
  id: string;
  inferred: boolean;
  name: string;
  patentOrPaper: boolean;
  products?: SimilarTechnologyProductCompanyDto[];
}

export interface SimilarTechnologyEvidenceDto {
  description: string;
  url: string;
}

export interface SimilarTechnologyProductCompanyDto {
  companyName: string;
  productName: string;
}

export interface SimilarTechnologySummaryDto {
  followUpSearches?: string[];
  matches: SimilarTechnologyDto[];
  primaryReferences?: PrimaryReferenceDto[];
  summary: string;
}

export enum SortDirection {
  ASC = "ASC",
  DESC = "DESC",
}

export enum StalenessReasonCode {
  AlgorithmVersionChanged = "algorithm_version_changed",
  AuthoringChanged = "authoring_changed",
  InputsChanged = "inputs_changed",
  SchemaVersionChanged = "schema_version_changed",
  SupersededByRerun = "superseded_by_rerun",
}

export enum StalenessStatus {
  CURRENT = "CURRENT",
  NEVER_COMPUTED = "NEVER_COMPUTED",
  STALE = "STALE",
}

export interface StudiesProgressSelectDto {
  studies: StudyProgressSelectDto[];
}

export interface StudiesSelectDto {
  studies: StudyListSelectDto[];
}

export interface StudyAcrEntriesSelectDto {
  acrEntries: StudyAcrEntrySelectDto[];
  total: number;
}

export interface StudyAcrEntryCreateDto {
  category: AcrCategory;
  impact?: AcrSeverity | null;
  likelihood?: AcrProbability | null;
  linkedEntityCode?: string | null;
  /** @format uuid */
  linkedEntityId?: string | null;
  linkedEntityType?: StudyAcrEntryCreateDtoLinkedEntityTypeEnum;
  mitigationApproach?: string | null;
  potentialImpact?: string | null;
  rationale: string;
  statement: string;
  status?: AcrStatus;
  title: string;
}

export enum StudyAcrEntryCreateDtoLinkedEntityTypeEnum {
  ARCHITECTURE_ALTERNATIVE = "ARCHITECTURE_ALTERNATIVE",
  MISSION = "MISSION",
  MOE = "MOE",
  MOP = "MOP",
  MOS = "MOS",
  RUN_CASE = "RUN_CASE",
  SWIMLANE = "SWIMLANE",
  TASK = "TASK",
  TECHNOLOGY = "TECHNOLOGY",
  THREAD = "THREAD",
  THREAT_TARGET = "THREAT_TARGET",
}

export interface StudyAcrEntryOwnerSelectDto {
  /** @format string */
  avatarUrl?: string;
  /** @format uuid */
  id: string;
  profile?: UserProfileSelectDto;
}

export interface StudyAcrEntrySelectDto {
  acrCode: string;
  category: AcrCategory;
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  id: string;
  impact?: AcrSeverity | null;
  likelihood?: AcrProbability | null;
  linkedEntityCode?: string | null;
  /** @format uuid */
  linkedEntityId?: string | null;
  linkedEntityType?: StudyAcrEntrySelectDtoLinkedEntityTypeEnum;
  mitigationApproach?: string | null;
  owner?: StudyAcrEntryOwnerSelectDto;
  /** @format uuid */
  ownerId: string;
  potentialImpact?: string | null;
  rationale: string;
  statement: string;
  status: AcrStatus;
  /** @format uuid */
  studyId: string;
  title: string;
  /** @format date-time */
  updatedAt: string;
}

export enum StudyAcrEntrySelectDtoLinkedEntityTypeEnum {
  ARCHITECTURE_ALTERNATIVE = "ARCHITECTURE_ALTERNATIVE",
  MISSION = "MISSION",
  MOE = "MOE",
  MOP = "MOP",
  MOS = "MOS",
  RUN_CASE = "RUN_CASE",
  SWIMLANE = "SWIMLANE",
  TASK = "TASK",
  TECHNOLOGY = "TECHNOLOGY",
  THREAD = "THREAD",
  THREAT_TARGET = "THREAT_TARGET",
}

export interface StudyAcrEntryUpdateDto {
  category?: AcrCategory;
  impact?: AcrSeverity | null;
  likelihood?: AcrProbability | null;
  linkedEntityCode?: string | null;
  /** @format uuid */
  linkedEntityId?: string | null;
  linkedEntityType?: StudyAcrEntryUpdateDtoLinkedEntityTypeEnum;
  mitigationApproach?: string | null;
  potentialImpact?: string | null;
  rationale?: string;
  statement?: string;
  status?: AcrStatus;
  title?: string;
}

export enum StudyAcrEntryUpdateDtoLinkedEntityTypeEnum {
  ARCHITECTURE_ALTERNATIVE = "ARCHITECTURE_ALTERNATIVE",
  MISSION = "MISSION",
  MOE = "MOE",
  MOP = "MOP",
  MOS = "MOS",
  RUN_CASE = "RUN_CASE",
  SWIMLANE = "SWIMLANE",
  TASK = "TASK",
  TECHNOLOGY = "TECHNOLOGY",
  THREAD = "THREAD",
  THREAT_TARGET = "THREAT_TARGET",
}

export enum StudyAdversaryProfile {
  CYBER_ACTOR = "CYBER_ACTOR",
  HYBRID_THREAT = "HYBRID_THREAT",
  NEAR_PEER_EUROPEAN = "NEAR_PEER_EUROPEAN",
  NEAR_PEER_PACIFIC = "NEAR_PEER_PACIFIC",
  NON_STATE_ACTOR = "NON_STATE_ACTOR",
  PROXY_FORCE = "PROXY_FORCE",
  REGIONAL_POWER = "REGIONAL_POWER",
  UNATTRIBUTED = "UNATTRIBUTED",
}

export interface StudyArchitectureAlternativeCreateDto {
  coalitionReleasability?: string | null;
  description: string;
  isNonMateriel: boolean;
  name: string;
  position: number;
}

export interface StudyArchitectureAlternativeSelectDto {
  coalitionReleasability?: string | null;
  /** @format date-time */
  createdAt: string;
  description: string;
  /** @format uuid */
  id: string;
  isNonMateriel: boolean;
  name: string;
  position: number;
  /** @format uuid */
  studyId: string;
  /** @format date-time */
  updatedAt: string;
}

export interface StudyArchitectureAlternativeUpdateDto {
  coalitionReleasability?: string | null;
  description?: string;
  isNonMateriel?: boolean;
  name?: string;
  position?: number;
}

export interface StudyArchitectureAlternativesSelectDto {
  architectureAlternatives: StudyArchitectureAlternativeSelectDto[];
}

export interface StudyArchitectureCostSelectDto {
  /** @format uuid */
  architectureAlternativeId?: string | null;
  consumableCost?: object | null;
  /** @format date-time */
  createdAt: string;
  currency: string;
  /** @format uuid */
  id: string;
  platformCost?: object | null;
  readiness?: object | null;
  replacementRate?: object | null;
  timeHorizon: string;
  /** @format date-time */
  updatedAt: string;
}

export interface StudyArchitectureCostUpsertDto {
  consumableCost?: object | null;
  currency: string;
  platformCost?: object | null;
  readiness?: object | null;
  replacementRate?: object | null;
  timeHorizon: string;
}

export interface StudyArchitectureDotmlpfCreateDto {
  assessment: string;
  dimension: DotmlpfDimension;
  severity: string;
}

export interface StudyArchitectureDotmlpfSelectDto {
  /** @format uuid */
  architectureAlternativeId: string;
  assessment: string;
  /** @format date-time */
  createdAt: string;
  dimension: DotmlpfDimension;
  /** @format uuid */
  id: string;
  severity: string;
  /** @format date-time */
  updatedAt: string;
}

export interface StudyArchitectureDotmlpfUpdateDto {
  assessment?: string;
  dimension?: DotmlpfDimension;
  severity?: string;
}

export interface StudyArchitectureDotmlpfsSelectDto {
  dotmlpfAssessments: StudyArchitectureDotmlpfSelectDto[];
}

export interface StudyBriefAnalysisCostRowDto {
  effectCount: number;
  effectTypes: string[];
  effectivenessScore?: number | null;
  missingCost: boolean;
  technologyId: string;
  technologyName: string;
  totalCost: number;
  valuePerMillion?: number | null;
}

export interface StudyBriefAnalysisCostSummaryDto {
  bestTechnologyId?: string | null;
  bestTechnologyName?: string | null;
  bestValuePerMillion?: number | null;
  grandTotal: number;
  missingCostTechnologyCount: number;
  pricedTechnologyCount: number;
  technologyCount: number;
}

export interface StudyBriefAnalysisSelectDto {
  costRows: StudyBriefAnalysisCostRowDto[];
  costSummary: StudyBriefAnalysisCostSummaryDto;
  sensitivitySummary: StudyBriefAnalysisSensitivitySummaryDto;
}

export interface StudyBriefAnalysisSensitivityBandFlipDto {
  atParameterValue: number;
  fromBand: ScoringBand;
  missionId: string;
  missionName: string;
  mopId: string;
  mopLabel: string;
  parameter: string;
  toBand: ScoringBand;
}

export interface StudyBriefAnalysisSensitivityParameterDto {
  baselineScore?: number | null;
  impactScore: number;
  maxScore?: number | null;
  minScore?: number | null;
  parameter: string;
  rank: number;
  samples: StudyBriefAnalysisSensitivitySampleDto[];
}

export interface StudyBriefAnalysisSensitivitySampleDto {
  parameterValue: number;
  responseScore: number;
}

export interface StudyBriefAnalysisSensitivitySummaryDto {
  bandFlips: StudyBriefAnalysisSensitivityBandFlipDto[];
  parameters: StudyBriefAnalysisSensitivityParameterDto[];
  transitions: StudyBriefAnalysisSensitivityTransitionDto[];
}

export interface StudyBriefAnalysisSensitivityTransitionDto {
  atValue: number;
  fromBand: ScoringBand;
  missionId: string;
  missionName: string;
  parameter: string;
  toBand: ScoringBand;
}

export interface StudyCampaignReferenceSelectDto {
  /** @format uuid */
  campaignId: string;
  campaignName: string;
  campaignStatus: CampaignStatus;
  /** @format uuid */
  id: string;
}

export interface StudyCommentCreateDto {
  body: string;
  /** @format uuid */
  entityId: string;
  entityType: StudyCommentEntityType;
}

export enum StudyCommentEntityType {
  ALTERNATIVE = "ALTERNATIVE",
  ENGAGEMENT = "ENGAGEMENT",
  FINDING = "FINDING",
  MISSION = "MISSION",
  MISSION_THREAD = "MISSION_THREAD",
  RUN_CASE = "RUN_CASE",
  STUDY = "STUDY",
}

export interface StudyCommentSelectDto {
  body: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  editedAt?: string | null;
  /** @format uuid */
  entityId: string;
  entityType: StudyCommentEntityType;
  /** @format uuid */
  id: string;
  /** @format uuid */
  studyId: string;
  /** @format date-time */
  updatedAt: string;
  /** @format uuid */
  userId: string;
}

export interface StudyCommentUpdateDto {
  body: string;
}

export interface StudyCommentsSelectDto {
  comments: StudyCommentSelectDto[];
  total: number;
}

export interface StudyCostEffectivenessAnalysisSelectDto {
  costEffectiveness: object;
  persistedResults: StudyCostEffectivenessResultSelectDto[];
  validationErrors: object[];
}

export interface StudyCostEffectivenessResultSelectDto {
  algorithmVersion: string;
  /** @format uuid */
  architectureAlternativeId: string;
  breakdown?: object | null;
  costPerEffect: number;
  /** @format uuid */
  effectId: string;
  /** @format uuid */
  id: string;
}

export interface StudyCostEffectivenessResultsSelectDto {
  costEffectivenessResults: StudyCostEffectivenessResultSelectDto[];
}

export interface StudyCreateDto {
  adversaryProfiles?: StudyAdversaryProfile[];
  classificationCeiling: StudyCreateDtoClassificationCeilingEnum;
  classificationLevel: StudyCreateDtoClassificationLevelEnum;
  contextNarrative?: string | null;
  description?: string | null;
  environment?: string | null;
  keyOperationalProblem?: string | null;
  name: string;
  scoringConfig?: StudyScoringConfigDto;
  threatEnvelope?: string | null;
  timeHorizon?: StudyTimeHorizon | null;
}

export enum StudyCreateDtoClassificationCeilingEnum {
  CUI = "CUI",
  SECRET = "SECRET",
  TOP_SECRET = "TOP_SECRET",
  UNCLASSIFIED = "UNCLASSIFIED",
}

export enum StudyCreateDtoClassificationLevelEnum {
  CUI = "CUI",
  SECRET = "SECRET",
  TOP_SECRET = "TOP_SECRET",
  UNCLASSIFIED = "UNCLASSIFIED",
}

export interface StudyExplainabilitySelectDto {
  explainability?: object;
  scoringOutput: StudyScoringOutputSelectDto;
  traces: StudyExplainabilityTraceSelectDto[];
}

export interface StudyExplainabilityTraceSelectDto {
  /** @format uuid */
  id: string;
  narrative: string;
  nodeCode?: string | null;
  nodeId?: string | null;
  nodeType: string;
  /** @format uuid */
  parentId?: string | null;
  /** @format uuid */
  scoringOutputId: string;
}

export interface StudyFindingCreateDto {
  body: string;
  position: number;
  severity: string;
  title: string;
}

export interface StudyFindingSelectDto {
  body: string;
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  id: string;
  position: number;
  severity: string;
  /** @format uuid */
  studyId: string;
  title: string;
  /** @format date-time */
  updatedAt: string;
}

export interface StudyFindingUpdateDto {
  body?: string;
  position?: number;
  severity?: string;
  title?: string;
}

export interface StudyFindingsSelectDto {
  findings: StudyFindingSelectDto[];
  total: number;
}

export interface StudyGapCreateDto {
  description: string;
  detectedBy: string;
  /** @format uuid */
  linkedMoeId?: string | null;
  position: number;
  severity: string;
  title: string;
}

export interface StudyGapSelectDto {
  /** @format date-time */
  createdAt: string;
  description: string;
  detectedBy: string;
  /** @format uuid */
  id: string;
  /** @format uuid */
  linkedMoeId?: string | null;
  position: number;
  severity: string;
  /** @format uuid */
  studyId: string;
  title: string;
  /** @format date-time */
  updatedAt: string;
}

export interface StudyGapUpdateDto {
  description?: string;
  detectedBy?: string;
  /** @format uuid */
  linkedMoeId?: string | null;
  position?: number;
  severity?: string;
  title?: string;
}

export interface StudyGapsSelectDto {
  gaps: StudyGapSelectDto[];
  total: number;
}

export enum StudyGate {
  G1 = "G1",
  G2 = "G2",
  G3 = "G3",
  G4 = "G4",
}

export interface StudyGateReadinessSelectDto {
  blocking: ValidationIssueDto[];
  gate: StudyGateReadinessSelectDtoGateEnum;
  issues: ValidationIssueDto[];
  ready: boolean;
  warnings: ValidationIssueDto[];
}

export enum StudyGateReadinessSelectDtoGateEnum {
  G1 = "G1",
  G2 = "G2",
  G3 = "G3",
  G4 = "G4",
}

export interface StudyInvestigativeQuestionCreateDto {
  answer?: string | null;
  investigativeQuestionTemplateCode?: string | null;
  questionText?: string;
}

export interface StudyInvestigativeQuestionSelectDto {
  answer?: string | null;
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  id: string;
  questionText: string;
  /** @format uuid */
  studyId: string;
  /** @format date-time */
  updatedAt: string;
}

export interface StudyInvestigativeQuestionUpdateDto {
  answer?: string | null;
  questionText?: string;
}

export interface StudyInvestigativeQuestionsSelectDto {
  investigativeQuestions: StudyInvestigativeQuestionSelectDto[];
}

export interface StudyListSelectDto {
  adversaryProfiles: StudyAdversaryProfile[];
  canDeleteStudy: boolean;
  canEditStudy: boolean;
  canManageOverrides: boolean;
  canManageStakeholders: boolean;
  canSignOffStudy: boolean;
  canUpdateWorkflow: boolean;
  classificationLevel: StudyListSelectDtoClassificationLevelEnum;
  /** @format date-time */
  createdAt: string;
  currentGate?: StudyListSelectDtoCurrentGateEnum;
  currentUserStudyRole?: StudyStakeholderRole;
  /** @format uuid */
  id: string;
  keyOperationalProblem?: string | null;
  name: string;
  /** @format uuid */
  ownerId: string;
  ownerName: string;
  status: StudyListSelectDtoStatusEnum;
  threadKillChains: KillChainCategory[];
  timeHorizon?: StudyTimeHorizon | null;
  /** @format date-time */
  updatedAt: string;
}

export enum StudyListSelectDtoClassificationLevelEnum {
  CUI = "CUI",
  SECRET = "SECRET",
  TOP_SECRET = "TOP_SECRET",
  UNCLASSIFIED = "UNCLASSIFIED",
}

export enum StudyListSelectDtoCurrentGateEnum {
  G1 = "G1",
  G2 = "G2",
  G3 = "G3",
  G4 = "G4",
}

export enum StudyListSelectDtoStatusEnum {
  ARCHIVED = "ARCHIVED",
  APPROVED = "APPROVED",
  DRAFT = "DRAFT",
  PROPOSED = "PROPOSED",
}

export interface StudyMissionCapabilityGapInputDto {
  /** @format uuid */
  id?: string;
  /** @min 0 */
  position: number;
  priority: StudyMissionCapabilityGapPriority;
  question: string;
  sourcePromptRef?: string | null;
  status: StudyMissionCapabilityGapStatus;
}

export enum StudyMissionCapabilityGapPriority {
  HIGH = "HIGH",
  LOW = "LOW",
  MEDIUM = "MEDIUM",
}

export interface StudyMissionCapabilityGapSelectDto {
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  id: string;
  /** @format uuid */
  missionId: string;
  /** @min 0 */
  position: number;
  priority: StudyMissionCapabilityGapPriority;
  question: string;
  sourcePromptRef?: string | null;
  status: StudyMissionCapabilityGapStatus;
  /** @format date-time */
  updatedAt: string;
}

export enum StudyMissionCapabilityGapStatus {
  ANSWERED = "ANSWERED",
  INVESTIGATING = "INVESTIGATING",
  OPEN = "OPEN",
}

export interface StudyMissionContextDto {
  areaOfOperations?: string | null;
  assumptionsConstraints?: string | null;
  authoritiesRoeEnvelope?: string | null;
  blueForceComposition?: string | null;
  commandersIntent?: string | null;
  desiredMissionOutcome?: string | null;
  timeWindow?: string | null;
}

export interface StudyMissionCreateDto {
  capabilityGaps?: StudyMissionCapabilityGapInputDto[];
  megVersion?: string | null;
  missionContext?: StudyMissionContextDto | null;
  missionTypeCategory?: KillChainCategory | null;
  name: string;
  narrative?: string | null;
  purposeStatement?: string | null;
}

export interface StudyMissionRedActivityBindingCreateDto {
  rationale?: string | null;
  redForceActivityCode: string;
}

export interface StudyMissionRedActivityBindingSelectDto {
  /** @format uuid */
  byUserId: string;
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  id: string;
  /** @format uuid */
  missionId: string;
  rationale?: string | null;
  redForceActivityCode: string;
  /** @format date-time */
  updatedAt: string;
}

export interface StudyMissionRedActivityBindingUpdateDto {
  rationale?: string | null;
  redForceActivityCode?: string;
}

export interface StudyMissionRedActivityBindingsSelectDto {
  redActivityBindings: StudyMissionRedActivityBindingSelectDto[];
}

export interface StudyMissionSelectDto {
  capabilityGaps?: StudyMissionCapabilityGapSelectDto[];
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  id: string;
  megVersion: string;
  missionContext?: StudyMissionContextDto | null;
  missionTypeCategory?: KillChainCategory | null;
  name: string;
  narrative?: string | null;
  purposeStatement?: string | null;
  status: StudyMissionStatus;
  statusReason?: string | null;
  /** @format uuid */
  studyId: string;
  /** @format date-time */
  updatedAt: string;
}

export enum StudyMissionStatus {
  ACTIVE = "ACTIVE",
  CLOSED = "CLOSED",
  DRAFT = "DRAFT",
  UNDER_REVIEW = "UNDER_REVIEW",
}

export interface StudyMissionStatusTransitionDto {
  acknowledgeCloseGate?: boolean;
  reason?: string | null;
  status: StudyMissionStatus;
}

export interface StudyMissionUpdateDto {
  capabilityGaps?: StudyMissionCapabilityGapInputDto[];
  megVersion?: string | null;
  missionContext?: StudyMissionContextDto | null;
  missionTypeCategory?: KillChainCategory | null;
  name?: string;
  narrative?: string | null;
  purposeStatement?: string | null;
}

export interface StudyMissionsSelectDto {
  missions: StudyMissionSelectDto[];
}

export interface StudyMoeCreateDto {
  aggregationMethod?: StudyMoeCreateDtoAggregationMethodEnum;
  blockingYellowBehavior?: StudyMoeCreateDtoBlockingYellowBehaviorEnum;
  description?: string;
  moeTemplateCode?: string | null;
  pendingMopBehavior?: StudyMoeCreateDtoPendingMopBehaviorEnum;
  scoringConfig?: Record<string, any>;
  /**
   * @min 0
   * @max 1
   */
  weight?: number | null;
  yellowDisposition?: StudyMoeCreateDtoYellowDispositionEnum;
}

export enum StudyMoeCreateDtoAggregationMethodEnum {
  HYBRID = "HYBRID",
  WEIGHTED_CONTRIBUTING = "WEIGHTED_CONTRIBUTING",
  WORST_CASE_BLOCKING = "WORST_CASE_BLOCKING",
}

export enum StudyMoeCreateDtoBlockingYellowBehaviorEnum {
  IGNORE = "IGNORE",
  PROPAGATE_YELLOW = "PROPAGATE_YELLOW",
}

export enum StudyMoeCreateDtoPendingMopBehaviorEnum {
  BLOCK_SCORING = "BLOCK_SCORING",
  EXCLUDE_FROM_AVERAGE = "EXCLUDE_FROM_AVERAGE",
  TREAT_AS_RED = "TREAT_AS_RED",
  TREAT_AS_YELLOW = "TREAT_AS_YELLOW",
}

export enum StudyMoeCreateDtoYellowDispositionEnum {
  ACCEPT = "ACCEPT",
  ACCEPT_WITH_OVERRIDE = "ACCEPT_WITH_OVERRIDE",
  REJECT = "REJECT",
}

export interface StudyMoeEntriesSelectDto {
  moeEntries: StudyMoeSelectDto[];
}

export interface StudyMoeSelectDto {
  aggregationMethod: StudyMoeSelectDtoAggregationMethodEnum;
  blockingYellowBehavior: StudyMoeSelectDtoBlockingYellowBehaviorEnum;
  /** @format date-time */
  createdAt: string;
  description: string;
  /** @format uuid */
  id: string;
  /** @format uuid */
  mosId: string;
  pendingMopBehavior: StudyMoeSelectDtoPendingMopBehaviorEnum;
  scoringConfig: Record<string, any>;
  /** @format date-time */
  updatedAt: string;
  /**
   * @min 0
   * @max 1
   */
  weight: number;
  /** True when the weight was filled in automatically by the backend. */
  weightIsAuto: boolean;
  yellowDisposition: StudyMoeSelectDtoYellowDispositionEnum;
}

export enum StudyMoeSelectDtoAggregationMethodEnum {
  HYBRID = "HYBRID",
  WEIGHTED_CONTRIBUTING = "WEIGHTED_CONTRIBUTING",
  WORST_CASE_BLOCKING = "WORST_CASE_BLOCKING",
}

export enum StudyMoeSelectDtoBlockingYellowBehaviorEnum {
  IGNORE = "IGNORE",
  PROPAGATE_YELLOW = "PROPAGATE_YELLOW",
}

export enum StudyMoeSelectDtoPendingMopBehaviorEnum {
  BLOCK_SCORING = "BLOCK_SCORING",
  EXCLUDE_FROM_AVERAGE = "EXCLUDE_FROM_AVERAGE",
  TREAT_AS_RED = "TREAT_AS_RED",
  TREAT_AS_YELLOW = "TREAT_AS_YELLOW",
}

export enum StudyMoeSelectDtoYellowDispositionEnum {
  ACCEPT = "ACCEPT",
  ACCEPT_WITH_OVERRIDE = "ACCEPT_WITH_OVERRIDE",
  REJECT = "REJECT",
}

export interface StudyMoeUpdateDto {
  aggregationMethod?: StudyMoeUpdateDtoAggregationMethodEnum;
  blockingYellowBehavior?: StudyMoeUpdateDtoBlockingYellowBehaviorEnum;
  description?: string;
  pendingMopBehavior?: StudyMoeUpdateDtoPendingMopBehaviorEnum;
  scoringConfig?: Record<string, any>;
  /**
   * @min 0
   * @max 1
   */
  weight?: number | null;
  yellowDisposition?: StudyMoeUpdateDtoYellowDispositionEnum;
}

export enum StudyMoeUpdateDtoAggregationMethodEnum {
  HYBRID = "HYBRID",
  WEIGHTED_CONTRIBUTING = "WEIGHTED_CONTRIBUTING",
  WORST_CASE_BLOCKING = "WORST_CASE_BLOCKING",
}

export enum StudyMoeUpdateDtoBlockingYellowBehaviorEnum {
  IGNORE = "IGNORE",
  PROPAGATE_YELLOW = "PROPAGATE_YELLOW",
}

export enum StudyMoeUpdateDtoPendingMopBehaviorEnum {
  BLOCK_SCORING = "BLOCK_SCORING",
  EXCLUDE_FROM_AVERAGE = "EXCLUDE_FROM_AVERAGE",
  TREAT_AS_RED = "TREAT_AS_RED",
  TREAT_AS_YELLOW = "TREAT_AS_YELLOW",
}

export enum StudyMoeUpdateDtoYellowDispositionEnum {
  ACCEPT = "ACCEPT",
  ACCEPT_WITH_OVERRIDE = "ACCEPT_WITH_OVERRIDE",
  REJECT = "REJECT",
}

export interface StudyMopCreateDto {
  category?: StudyMopCreateDtoCategoryEnum;
  description?: string;
  direction?: StudyMopCreateDtoDirectionEnum;
  mopTemplateCode?: string | null;
  name?: string;
  objective: string;
  requirementProvenanceConfidence?: StudyMopCreateDtoRequirementProvenanceConfidenceEnum;
  requirementProvenanceNotes?: string | null;
  /** @format date-time */
  requirementProvenanceSourceDate?: string | null;
  requirementProvenanceSourceId?: string | null;
  requirementProvenanceSourceType?: StudyMopCreateDtoRequirementProvenanceSourceTypeEnum;
  threshold: string;
  unit?: string;
}

export enum StudyMopCreateDtoCategoryEnum {
  PROCESS_RELIABILITY = "PROCESS_RELIABILITY",
  TECHNICAL_PHYSICAL = "TECHNICAL_PHYSICAL",
  TIME_LATENCY = "TIME_LATENCY",
}

export enum StudyMopCreateDtoDirectionEnum {
  HIGHER_IS_BETTER = "HIGHER_IS_BETTER",
  LOWER_IS_BETTER = "LOWER_IS_BETTER",
}

export enum StudyMopCreateDtoRequirementProvenanceConfidenceEnum {
  HIGH = "HIGH",
  LOW = "LOW",
  MEDIUM = "MEDIUM",
}

export enum StudyMopCreateDtoRequirementProvenanceSourceTypeEnum {
  CONOPS = "CONOPS",
  CONTRACTOR_SPEC = "CONTRACTOR_SPEC",
  DT_AND_E = "DT_AND_E",
  INTELLIGENCE = "INTELLIGENCE",
  JCIDS = "JCIDS",
  M_AND_S = "M_AND_S",
  OT_AND_E = "OT_AND_E",
  SME = "SME",
}

export interface StudyMopEntriesSelectDto {
  mopEntries: StudyMopSelectDto[];
}

export interface StudyMopSelectDto {
  category: StudyMopSelectDtoCategoryEnum;
  /** @format date-time */
  createdAt: string;
  description: string;
  direction: StudyMopSelectDtoDirectionEnum;
  /** @format uuid */
  id: string;
  /** @format uuid */
  missionId: string;
  name: string;
  objective: string;
  requirementProvenanceConfidence?: StudyMopSelectDtoRequirementProvenanceConfidenceEnum;
  requirementProvenanceNotes?: string | null;
  /** @format date-time */
  requirementProvenanceSourceDate?: string | null;
  requirementProvenanceSourceId?: string | null;
  requirementProvenanceSourceType?: StudyMopSelectDtoRequirementProvenanceSourceTypeEnum;
  threshold: string;
  unit: string;
  /** @format date-time */
  updatedAt: string;
}

export enum StudyMopSelectDtoCategoryEnum {
  PROCESS_RELIABILITY = "PROCESS_RELIABILITY",
  TECHNICAL_PHYSICAL = "TECHNICAL_PHYSICAL",
  TIME_LATENCY = "TIME_LATENCY",
}

export enum StudyMopSelectDtoDirectionEnum {
  HIGHER_IS_BETTER = "HIGHER_IS_BETTER",
  LOWER_IS_BETTER = "LOWER_IS_BETTER",
}

export enum StudyMopSelectDtoRequirementProvenanceConfidenceEnum {
  HIGH = "HIGH",
  LOW = "LOW",
  MEDIUM = "MEDIUM",
}

export enum StudyMopSelectDtoRequirementProvenanceSourceTypeEnum {
  CONOPS = "CONOPS",
  CONTRACTOR_SPEC = "CONTRACTOR_SPEC",
  DT_AND_E = "DT_AND_E",
  INTELLIGENCE = "INTELLIGENCE",
  JCIDS = "JCIDS",
  M_AND_S = "M_AND_S",
  OT_AND_E = "OT_AND_E",
  SME = "SME",
}

export interface StudyMopUpdateDto {
  category?: StudyMopUpdateDtoCategoryEnum;
  description?: string;
  direction?: StudyMopUpdateDtoDirectionEnum;
  name?: string;
  objective?: string;
  requirementProvenanceConfidence?: StudyMopUpdateDtoRequirementProvenanceConfidenceEnum;
  requirementProvenanceNotes?: string | null;
  /** @format date-time */
  requirementProvenanceSourceDate?: string | null;
  requirementProvenanceSourceId?: string | null;
  requirementProvenanceSourceType?: StudyMopUpdateDtoRequirementProvenanceSourceTypeEnum;
  threshold?: string;
  unit?: string;
}

export enum StudyMopUpdateDtoCategoryEnum {
  PROCESS_RELIABILITY = "PROCESS_RELIABILITY",
  TECHNICAL_PHYSICAL = "TECHNICAL_PHYSICAL",
  TIME_LATENCY = "TIME_LATENCY",
}

export enum StudyMopUpdateDtoDirectionEnum {
  HIGHER_IS_BETTER = "HIGHER_IS_BETTER",
  LOWER_IS_BETTER = "LOWER_IS_BETTER",
}

export enum StudyMopUpdateDtoRequirementProvenanceConfidenceEnum {
  HIGH = "HIGH",
  LOW = "LOW",
  MEDIUM = "MEDIUM",
}

export enum StudyMopUpdateDtoRequirementProvenanceSourceTypeEnum {
  CONOPS = "CONOPS",
  CONTRACTOR_SPEC = "CONTRACTOR_SPEC",
  DT_AND_E = "DT_AND_E",
  INTELLIGENCE = "INTELLIGENCE",
  JCIDS = "JCIDS",
  M_AND_S = "M_AND_S",
  OT_AND_E = "OT_AND_E",
  SME = "SME",
}

export interface StudyMosCreateDto {
  description?: string;
  mosTemplateCode?: string | null;
}

export interface StudyMosEntriesSelectDto {
  mosEntries: StudyMosSelectDto[];
}

export interface StudyMosSelectDto {
  /** @format date-time */
  createdAt: string;
  description: string;
  /** @format uuid */
  id: string;
  /** @format uuid */
  missionId: string;
  /** @format uuid */
  swimlaneId?: string | null;
  /** @format date-time */
  updatedAt: string;
}

export interface StudyMosUpdateDto {
  description?: string;
}

export interface StudyObservedMopSelectDto {
  confidence?: number | null;
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  id: string;
  manualSource?: string | null;
  /** @format date-time */
  manualSourceDate?: string | null;
  /** @format uuid */
  scoringOutputId: string;
  /** @format uuid */
  studyMopId: string;
  /** @format date-time */
  updatedAt: string;
  value: string;
  valueSource: MopValueSource;
}

export interface StudyOverrideCreateDto {
  overrideBand: StudyOverrideCreateDtoOverrideBandEnum;
  rationale: string;
  targetCode?: string | null;
  /** @format uuid */
  targetId?: string | null;
  targetType: StudyOverrideCreateDtoTargetTypeEnum;
}

export enum StudyOverrideCreateDtoOverrideBandEnum {
  GREEN = "GREEN",
  PENDING = "PENDING",
  RED = "RED",
  YELLOW = "YELLOW",
}

export enum StudyOverrideCreateDtoTargetTypeEnum {
  MISSION = "MISSION",
  MOE = "MOE",
  MOP = "MOP",
  MOS = "MOS",
  TASK = "TASK",
}

export interface StudyOverrideSelectDto {
  /** @format uuid */
  authorizedById: string;
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  id: string;
  overrideBand: StudyOverrideSelectDtoOverrideBandEnum;
  rationale: string;
  /** @format uuid */
  scoringOutputId: string;
  targetCode?: string | null;
  /** @format uuid */
  targetId?: string | null;
  targetType: StudyOverrideSelectDtoTargetTypeEnum;
  /** @format date-time */
  timestamp: string;
  /** @format date-time */
  updatedAt: string;
}

export enum StudyOverrideSelectDtoOverrideBandEnum {
  GREEN = "GREEN",
  PENDING = "PENDING",
  RED = "RED",
  YELLOW = "YELLOW",
}

export enum StudyOverrideSelectDtoTargetTypeEnum {
  MISSION = "MISSION",
  MOE = "MOE",
  MOP = "MOP",
  MOS = "MOS",
  TASK = "TASK",
}

export interface StudyOverridesSelectDto {
  overrides: StudyOverrideSelectDto[];
  total: number;
}

export interface StudyP4E2ERowSelectDto {
  /** @format uuid */
  architectureAlternativeId?: string | null;
  epoch?: Epoch | null;
  expectedThreatTargetSystemCode?: string | null;
  /** @format uuid */
  id: string;
  swimlanePhaseName: string;
  /** @format uuid */
  taskId: string;
  taskName: string;
  /** @format uuid */
  technologyId: string;
  technologyName: string;
  /** @format uuid */
  threadId: string;
  threadKillChainCategory: KillChainCategory;
  threadName: string;
  threadRole: StudyThreadRole;
}

export interface StudyP4E2ERowsSelectDto {
  rows: StudyP4E2ERowSelectDto[];
}

export interface StudyProgressPhaseDto {
  blocked: boolean;
  gate: WorkflowGate;
  hasStaleWarning: boolean;
}

export interface StudyProgressSelectDto {
  phases: StudyProgressPhaseDto[];
  studyId: string;
}

export interface StudyRecommendationCreateDto {
  body: string;
  position: number;
  priority: string;
  title: string;
}

export interface StudyRecommendationSelectDto {
  body: string;
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  id: string;
  position: number;
  priority: string;
  /** @format uuid */
  studyId: string;
  title: string;
  /** @format date-time */
  updatedAt: string;
}

export interface StudyRecommendationUpdateDto {
  body?: string;
  position?: number;
  priority?: string;
  title?: string;
}

export interface StudyRecommendationsSelectDto {
  recommendations: StudyRecommendationSelectDto[];
  total: number;
}

export interface StudyRunCaseCreateDto {
  epoch?: Epoch;
  /** @format uuid */
  missionId?: string | null;
  parameterOverrides?: object | null;
}

export interface StudyRunCaseDashboardAdvisoryGapDto {
  detail: string;
  id: string;
  kind: StudyRunCaseDashboardAdvisoryGapKind;
  severity: StudyRunCaseDashboardAdvisoryGapSeverity;
  sourceReferences: string[];
  summary: string;
}

export enum StudyRunCaseDashboardAdvisoryGapKind {
  LowCyberSnapshot = "low-cyber-snapshot",
  LowTrlSnapshot = "low-trl-snapshot",
  StageNoTasks = "stage-no-tasks",
  TaskNoMeasures = "task-no-measures",
  TaskNoTechnologies = "task-no-technologies",
  TaskSingleTechnology = "task-single-technology",
}

export enum StudyRunCaseDashboardAdvisoryGapSeverity {
  HIGH = "HIGH",
  LOW = "LOW",
  MEDIUM = "MEDIUM",
}

export interface StudyRunCaseDashboardGateCardDto {
  blockingCount: number;
  detail: string;
  gate: StudyGate;
  label: string;
  reason: string;
  status: StudyRunCaseDashboardGateStatus;
  warningCount: number;
}

export enum StudyRunCaseDashboardGateStatus {
  FAIL = "FAIL",
  PASS = "PASS",
  PENDING = "PENDING",
  SOFT = "SOFT",
}

export enum StudyRunCaseDashboardMatrixMeasureType {
  MOE = "MOE",
  MOP = "MOP",
  MOS = "MOS",
}

export interface StudyRunCaseDashboardMatrixRowDto {
  band?: ScoringBand | null;
  id: string;
  measureId: string;
  measureLabel: string;
  measureType: StudyRunCaseDashboardMatrixMeasureType;
  objective?: string | null;
  score?: number | null;
  stageId: string;
  stageName: string;
  status: StudyRunCaseDashboardMatrixStatus;
  tasks: StudyRunCaseDashboardMatrixTaskDto[];
  technologies: StudyRunCaseDashboardMatrixTechnologyDto[];
  threshold?: string | null;
}

export enum StudyRunCaseDashboardMatrixStatus {
  AT_RISK = "AT_RISK",
  COMPLETE = "COMPLETE",
  FAIL = "FAIL",
  GAP = "GAP",
  NOT_SCORED = "NOT_SCORED",
  PASS = "PASS",
}

export interface StudyRunCaseDashboardMatrixTaskDto {
  id: string;
  name: string;
}

export interface StudyRunCaseDashboardMatrixTechnologyDto {
  cyberResilienceSnapshot?: number | null;
  id: string;
  name: string;
  trlSnapshot?: number | null;
}

export interface StudyRunCaseDashboardMissionDto {
  activeThreadId?: string | null;
  missionId: string;
  missionName: string;
  performanceStages: StudyRunCaseDashboardPerformanceStageDto[];
  stageHeatmap: StudyRunCaseDashboardStageHeatmapRowDto[];
  summary: StudyRunCaseDashboardSummaryDto;
  threadVerdicts: StudyRunCaseDashboardThreadVerdictDto[];
  threads: StudyRunCaseDashboardThreadDetailDto[];
}

export interface StudyRunCaseDashboardPerformanceMetricDto {
  band?: ScoringBand | null;
  id: string;
  kind: StudyRunCaseDashboardPerformanceMetricDtoKindEnum;
  label: string;
  objective?: string | null;
  score?: number | null;
  source?: string | null;
  threshold?: string | null;
  unit?: string | null;
  value?: string | null;
}

export enum StudyRunCaseDashboardPerformanceMetricDtoKindEnum {
  MOE = "MOE",
  MOP = "MOP",
}

export interface StudyRunCaseDashboardPerformanceStageDto {
  metrics: StudyRunCaseDashboardPerformanceMetricDto[];
  stageId: string;
  stageName: string;
}

export interface StudyRunCaseDashboardSelectDto {
  activeMissionId?: string | null;
  activeThreadId?: string | null;
  gateCards: StudyRunCaseDashboardGateCardDto[];
  missions: StudyRunCaseDashboardMissionDto[];
  performanceStages: StudyRunCaseDashboardPerformanceStageDto[];
  runCase: StudyRunCaseSelectDto;
  scoringOutput?: StudyScoringOutputSelectDto | null;
  stageHeatmap: StudyRunCaseDashboardStageHeatmapRowDto[];
  summary: StudyRunCaseDashboardSummaryDto;
  threadVerdicts: StudyRunCaseDashboardThreadVerdictDto[];
  threads: StudyRunCaseDashboardThreadDetailDto[];
}

export interface StudyRunCaseDashboardStageHeatmapRowDto {
  compositeScore?: number | null;
  moeScore?: number | null;
  mopScore?: number | null;
  mosScore?: number | null;
  stageId: string;
  stageName: string;
  taskCount: number;
  verdictBand?: ScoringBand | null;
}

export interface StudyRunCaseDashboardSummaryDto {
  stagesGreen: number;
  stagesRed: number;
  stagesTotal: number;
  stagesYellow: number;
  threadBand?: ScoringBand | null;
  threadScore?: number | null;
}

export interface StudyRunCaseDashboardThreadDetailDto {
  advisoryGaps: StudyRunCaseDashboardAdvisoryGapDto[];
  matrixRows: StudyRunCaseDashboardMatrixRowDto[];
  performanceStages: StudyRunCaseDashboardPerformanceStageDto[];
  stageHeatmap: StudyRunCaseDashboardStageHeatmapRowDto[];
  summary: StudyRunCaseDashboardSummaryDto;
  threadId: string;
}

export interface StudyRunCaseDashboardThreadVerdictDto {
  active: boolean;
  band?: ScoringBand | null;
  killChainCategory: KillChainCategory;
  score?: number | null;
  threadId: string;
  threadName: string;
  threadRole: StudyThreadRole;
}

export interface StudyRunCaseSelectDto {
  /** @format date-time */
  createdAt: string;
  epoch: Epoch;
  /** @format uuid */
  id: string;
  /** @format uuid */
  missionId?: string | null;
  parameterOverrides?: object | null;
  status: ScoringRunStatus;
  /** @format uuid */
  studyId: string;
  /** @format date-time */
  updatedAt: string;
  version: number;
}

export interface StudyRunCaseUpdateDto {
  epoch?: Epoch;
  parameterOverrides?: object | null;
}

export interface StudyRunCasesSelectDto {
  runCases: StudyRunCaseSelectDto[];
}

export interface StudyRunExecutionSelectDto {
  explainabilityTraces: StudyExplainabilityTraceSelectDto[];
  observedMops: StudyObservedMopSelectDto[];
  runCase: StudyRunCaseSelectDto;
  scoringOutput: StudyScoringOutputSelectDto;
  validationResults: StudyValidationResultDto[];
}

export enum StudyScoringAggregationMethod {
  GATED_MULTIPLY = "GATED_MULTIPLY",
  WEAKEST_LINK = "WEAKEST_LINK",
  WEIGHTED_AVERAGE = "WEIGHTED_AVERAGE",
}

export interface StudyScoringConfigDto {
  aggregationMethod: StudyScoringAggregationMethod;
  /**
   * @min 0
   * @max 100
   */
  greenThreshold: number;
  /**
   * @min 0
   * @max 100
   */
  yellowThreshold: number;
}

export interface StudyScoringOutputSelectDto {
  algorithmVersion: string;
  contextBuilderVersion: string;
  /** @format date-time */
  createdAt: string;
  fullHierarchy: object;
  /** @format uuid */
  id: string;
  missionBand: ScoringBand;
  missionScore: number;
  /** @format uuid */
  runCaseId: string;
  /** @format date-time */
  scoredAt: string;
  stalenessReason?: StalenessReasonCode | null;
  stalenessStatus: StalenessStatus;
  /** @format date-time */
  updatedAt: string;
}

export interface StudyScoringOutputsSelectDto {
  scoringOutputs: StudyScoringOutputSelectDto[];
}

export interface StudySelectDto {
  adversaryProfiles: StudyAdversaryProfile[];
  algorithmVersion: string;
  canDeleteStudy: boolean;
  canEditStudy: boolean;
  canManageOverrides: boolean;
  canManageStakeholders: boolean;
  canSignOffStudy: boolean;
  canUpdateWorkflow: boolean;
  classificationCeiling: StudySelectDtoClassificationCeilingEnum;
  classificationLevel: StudySelectDtoClassificationLevelEnum;
  contextBuilderVersion: string;
  contextNarrative?: string | null;
  /** @format date-time */
  createdAt: string;
  currentGate?: StudySelectDtoCurrentGateEnum;
  currentUserStudyRole?: StudyStakeholderRole;
  description?: string | null;
  environment?: string | null;
  /** @format uuid */
  id: string;
  keyOperationalProblem?: string | null;
  name: string;
  /** @format uuid */
  ownerId: string;
  ownerName: string;
  referencingCampaigns?: StudyCampaignReferenceSelectDto[];
  schemaVersion: string;
  scoringConfig: StudyScoringConfigDto;
  signOffs?: StudySignoffSelectDto[];
  status: StudySelectDtoStatusEnum;
  threatEnvelope?: string | null;
  timeHorizon?: StudyTimeHorizon | null;
  /** @format date-time */
  updatedAt: string;
  validationVersion: string;
}

export enum StudySelectDtoClassificationCeilingEnum {
  CUI = "CUI",
  SECRET = "SECRET",
  TOP_SECRET = "TOP_SECRET",
  UNCLASSIFIED = "UNCLASSIFIED",
}

export enum StudySelectDtoClassificationLevelEnum {
  CUI = "CUI",
  SECRET = "SECRET",
  TOP_SECRET = "TOP_SECRET",
  UNCLASSIFIED = "UNCLASSIFIED",
}

export enum StudySelectDtoCurrentGateEnum {
  G1 = "G1",
  G2 = "G2",
  G3 = "G3",
  G4 = "G4",
}

export enum StudySelectDtoStatusEnum {
  ARCHIVED = "ARCHIVED",
  APPROVED = "APPROVED",
  DRAFT = "DRAFT",
  PROPOSED = "PROPOSED",
}

export interface StudySensitivityAnalysisSelectDto {
  persistedResults: StudySensitivityResultSelectDto[];
  sensitivityResult: object;
  validationErrors: object[];
}

export interface StudySensitivityResultSelectDto {
  algorithmVersion: string;
  /** @format uuid */
  id: string;
  oatCoefficients?: object | null;
  parameter: string;
  /** @format uuid */
  runCaseId: string;
  verdictTransitionPoint?: number | null;
}

export interface StudySensitivityResultsSelectDto {
  sensitivityResults: StudySensitivityResultSelectDto[];
}

export interface StudySensitivityRunDto {
  sweepConfigs?: StudySweepConfigDto[];
}

export interface StudySignoffActorSelectDto {
  /** @format string */
  avatarUrl?: string;
  /** @format uuid */
  id: string;
  profile?: UserProfileSelectDto;
}

export interface StudySignoffAttemptDto {
  rationale: string;
  signature?: string | null;
}

export interface StudySignoffAttemptSelectDto {
  readiness: StudyGateReadinessSelectDto;
  signoff: StudySignoffSelectDto;
}

export interface StudySignoffCreateDto {
  gate: StudySignoffCreateDtoGateEnum;
  rationale: string;
  signature?: string | null;
}

export enum StudySignoffCreateDtoGateEnum {
  G1 = "G1",
  G2 = "G2",
  G3 = "G3",
  G4 = "G4",
}

export interface StudySignoffSelectDto {
  authorizedBy: StudySignoffActorSelectDto;
  /** @format uuid */
  authorizedById: string;
  /** @format date-time */
  createdAt: string;
  gate: StudySignoffSelectDtoGateEnum;
  /** @format uuid */
  id: string;
  rationale: string;
  /** @format date-time */
  revokedAt?: string | null;
  revokedBy?: StudySignoffActorSelectDto | null;
  /** @format uuid */
  revokedById?: string | null;
  signature?: string | null;
  /** @format uuid */
  studyId: string;
  /** @format date-time */
  timestamp: string;
  /** @format date-time */
  updatedAt: string;
  user: StudySignoffActorSelectDto;
  /** @format uuid */
  userId: string;
}

export enum StudySignoffSelectDtoGateEnum {
  G1 = "G1",
  G2 = "G2",
  G3 = "G3",
  G4 = "G4",
}

export interface StudySignoffsSelectDto {
  signoffs: StudySignoffSelectDto[];
}

export interface StudySnapshotSelectDto {
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  id: string;
  payload: object;
  /** @format date-time */
  retainUntil?: string | null;
  /** @format date-time */
  snapshottedAt: string;
  /** @format uuid */
  snapshottedById: string;
  /** @format uuid */
  studyId: string;
  /** @format date-time */
  updatedAt: string;
  version: string;
}

export interface StudySnapshotSummaryDto {
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  id: string;
  /** @format date-time */
  retainUntil?: string | null;
  /** @format date-time */
  snapshottedAt: string;
  /** @format uuid */
  snapshottedById: string;
  /** @format uuid */
  studyId: string;
  /** @format date-time */
  updatedAt: string;
  version: string;
}

export interface StudySnapshotsSelectDto {
  snapshots: StudySnapshotSummaryDto[];
  total: number;
}

export interface StudyStakeholderCandidatesSelectDto {
  users: StudyStakeholderUserSelectDto[];
}

export interface StudyStakeholderCreateDto {
  organization?: string | null;
  responsibility?: string | null;
  role: StudyStakeholderRole;
  /** @format uuid */
  userId: string;
}

export enum StudyStakeholderRole {
  DECISION_MAKER = "DECISION_MAKER",
  MISSION_ENGINEER = "MISSION_ENGINEER",
  OWNER = "OWNER",
  REVIEWER = "REVIEWER",
  SPONSOR = "SPONSOR",
}

export interface StudyStakeholderSelectDto {
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  id: string;
  organization?: string | null;
  responsibility?: string | null;
  role: StudyStakeholderRole;
  /** @format uuid */
  studyId: string;
  /** @format date-time */
  updatedAt: string;
  user: StudyStakeholderUserSelectDto;
  /** @format uuid */
  userId: string;
}

export interface StudyStakeholderUpdateDto {
  organization?: string | null;
  responsibility?: string | null;
  role?: StudyStakeholderRole;
}

export interface StudyStakeholderUserSelectDto {
  /** @format string */
  avatarUrl?: string;
  /** @format email */
  email: string;
  /** @format uuid */
  id: string;
  profile?: UserProfileSelectDto;
}

export interface StudyStakeholdersSelectDto {
  stakeholders: StudyStakeholderSelectDto[];
}

export enum StudyStatus {
  ARCHIVED = "ARCHIVED",
  APPROVED = "APPROVED",
  DRAFT = "DRAFT",
  PROPOSED = "PROPOSED",
}

export interface StudySweepConfigDto {
  range: StudySweepRangeDto;
  sweepAllAlternatives: boolean;
  sweepVariable: StudySweepConfigDtoSweepVariableEnum;
}

export enum StudySweepConfigDtoSweepVariableEnum {
  ThreatDifficulty = "threatDifficulty",
  EnvironmentalFriction = "environmentalFriction",
  C2LatencyFactor = "c2LatencyFactor",
  CyberPressure = "cyberPressure",
}

export interface StudySweepRangeDto {
  max: number;
  min: number;
  step: number;
}

export interface StudySwimlaneCreateDto {
  entryCriteria?: string;
  exitCriteria?: string;
  /** @format uuid */
  killChainPhaseId?: string | null;
  operationalPurpose?: string;
  phaseName: string;
  position: number;
}

export interface StudySwimlaneSelectDto {
  /** @format date-time */
  createdAt: string;
  entryCriteria: string;
  exitCriteria: string;
  /** @format uuid */
  id: string;
  /** @format uuid */
  killChainPhaseId?: string | null;
  measuresStatus: SwimlaneMeasuresStatus;
  moeCount: number;
  mosCount: number;
  operationalPurpose: string;
  phaseName: string;
  position: number;
  /** @format uuid */
  threadId: string;
  /** @format date-time */
  updatedAt: string;
}

export interface StudySwimlaneUpdateDto {
  entryCriteria?: string;
  exitCriteria?: string;
  /** @format uuid */
  killChainPhaseId?: string | null;
  operationalPurpose?: string;
  phaseName?: string;
  position?: number;
}

export interface StudySwimlanesSelectDto {
  swimlanes: StudySwimlaneSelectDto[];
}

export interface StudyTargetEffectOverrideClearDto {
  /** @format uuid */
  architectureAlternativeId?: string | null;
  threatTargetSystemCode: string;
}

export interface StudyTargetEffectOverrideSelectDto {
  /** @format uuid */
  architectureAlternativeId?: string | null;
  authorUser: StudySignoffActorSelectDto;
  /** @format uuid */
  authorUserId: string;
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  id: string;
  rationale: string;
  status: EffectOnTargetStatus;
  /** @format uuid */
  studyId: string;
  threatTargetSystemCode: string;
  /** @format date-time */
  updatedAt: string;
}

export interface StudyTargetEffectOverrideUpsertDto {
  /** @format uuid */
  architectureAlternativeId?: string | null;
  rationale: string;
  status: EffectOnTargetStatus;
  threatTargetSystemCode: string;
}

export interface StudyTargetEffectOverridesSelectDto {
  targetEffectOverrides: StudyTargetEffectOverrideSelectDto[];
}

export interface StudyTaskCreateDto {
  classification?: ClassificationLevel | null;
  description?: string;
  effort?: StudyTaskEffort | null;
  /** @format uuid */
  expectedEffectId?: string | null;
  expectedThreatTargetSystemCode?: string | null;
  moeIds?: string[];
  mopAggregation: MopAggregation;
  mopIds?: string[];
  mosIds?: string[];
  owner?: string | null;
  phaseTimingConstraint?: StudyTaskPhaseTimingConstraintDto | null;
  position: number;
  scoringRole: ScoringRole;
  taskName: string;
}

export enum StudyTaskEffort {
  XL = "XL",
  L = "L",
  M = "M",
  S = "S",
}

export interface StudyTaskMoeSelectDto {
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  id: string;
  /** @format uuid */
  studyMoeId: string;
  /** @format uuid */
  studyTaskId: string;
  /** @format date-time */
  updatedAt: string;
}

export interface StudyTaskMoesSelectDto {
  taskMoes: StudyTaskMoeSelectDto[];
}

export interface StudyTaskMopSelectDto {
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  id: string;
  /** @format uuid */
  studyMopId: string;
  /** @format uuid */
  studyTaskId: string;
  /** @format date-time */
  updatedAt: string;
}

export interface StudyTaskMopsSelectDto {
  taskMops: StudyTaskMopSelectDto[];
}

export interface StudyTaskMosSelectDto {
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  id: string;
  /** @format uuid */
  studyMosId: string;
  /** @format uuid */
  studyTaskId: string;
  /** @format date-time */
  updatedAt: string;
}

export interface StudyTaskMosesSelectDto {
  taskMoses: StudyTaskMosSelectDto[];
}

export interface StudyTaskPhaseTimingConstraintDto {
  endOffsetSeconds?: number;
  /** @format uuid */
  phaseId?: string;
  startOffsetSeconds?: number;
}

export interface StudyTaskReadinessListSelectDto {
  taskReadiness: StudyTaskReadinessSelectDto[];
}

export interface StudyTaskReadinessSelectDto {
  /** @format uuid */
  id: string;
  moeCount: number;
  mopAggregation: MopAggregation;
  mopCount: number;
  mosCount: number;
  scoringRole: ScoringRole;
  /** @format uuid */
  swimlaneId: string;
  technologyCount: number;
}

export interface StudyTaskSelectDto {
  classification?: ClassificationLevel | null;
  /** @format date-time */
  createdAt: string;
  description: string;
  effort?: StudyTaskEffort | null;
  /** @format uuid */
  expectedEffectId?: string | null;
  expectedThreatTargetSystemCode?: string | null;
  /** @format uuid */
  id: string;
  mopAggregation: MopAggregation;
  owner?: string | null;
  phaseTimingConstraint?: StudyTaskPhaseTimingConstraintDto | null;
  position: number;
  scoringRole: ScoringRole;
  /** @format uuid */
  swimlaneId: string;
  taskName: string;
  /** @format date-time */
  updatedAt: string;
}

export interface StudyTaskTargetEngagementCreateDto {
  alternatePaths?: object[] | null;
  contestConfig: object;
  /** @format uuid */
  effectId: string;
  engagementType?: EngagementType | null;
  governingMOP?: string | null;
  pkEstimate?: number | null;
  status: EngagementStatus;
  threatTargetComponentCode?: string | null;
  threatTargetSystemCode: string;
}

export interface StudyTaskTargetEngagementSelectDto {
  alternatePaths?: object[] | null;
  contestConfig: object;
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  effectId: string;
  engagementType?: EngagementType | null;
  governingMOP?: string | null;
  /** @format uuid */
  id: string;
  pkEstimate?: number | null;
  status: EngagementStatus;
  /** @format uuid */
  studyTaskTechnologyId: string;
  /** @format uuid */
  taskId: string;
  threatTargetComponentCode?: string | null;
  threatTargetSystemCode: string;
  /** @format date-time */
  updatedAt: string;
}

export interface StudyTaskTargetEngagementUpdateDto {
  alternatePaths?: object[] | null;
  contestConfig?: object;
  /** @format uuid */
  effectId?: string;
  engagementType?: EngagementType | null;
  governingMOP?: string | null;
  pkEstimate?: number | null;
  status?: EngagementStatus;
  threatTargetComponentCode?: string | null;
  threatTargetSystemCode?: string;
}

export interface StudyTaskTargetEngagementsSelectDto {
  engagements: StudyTaskTargetEngagementSelectDto[];
}

export interface StudyTaskTechnologiesSelectDto {
  taskTechnologies: StudyTaskTechnologySelectDto[];
}

export interface StudyTaskTechnologyCreateDto {
  /** @format uuid */
  architectureAlternativeId?: string | null;
  epoch?: Epoch | null;
  function: string;
  /**
   * @min 1
   * @max 5
   */
  missionRelevanceSnapshot?: number | null;
  /**
   * @min 1
   * @max 5
   */
  openArchitectureSnapshot?: number | null;
  /** @format uuid */
  technologyId: string;
}

export interface StudyTaskTechnologySelectDto {
  /** @format uuid */
  architectureAlternativeId?: string | null;
  /** @format date-time */
  createdAt: string;
  cyberResilienceSnapshot?: number | null;
  epoch?: Epoch | null;
  function: string;
  /** @format uuid */
  id: string;
  killChainTagsSnapshot: string[];
  missionRelevanceSnapshot?: number | null;
  openArchitectureSnapshot?: number | null;
  /** @format uuid */
  taskId: string;
  /** @format string */
  technologyCategoryName?: string;
  /** @format string */
  technologyCompanyName?: string;
  /** @format uuid */
  technologyId: string;
  /** @format string */
  technologyName?: string;
  trlSnapshot?: number | null;
  /** @format date-time */
  updatedAt: string;
}

export interface StudyTaskTechnologyUpdateDto {
  function?: string;
  /**
   * @min 1
   * @max 5
   */
  missionRelevanceSnapshot?: number | null;
  /**
   * @min 1
   * @max 5
   */
  openArchitectureSnapshot?: number | null;
}

export interface StudyTaskUpdateDto {
  classification?: ClassificationLevel | null;
  description?: string;
  effort?: StudyTaskEffort | null;
  /** @format uuid */
  expectedEffectId?: string | null;
  expectedThreatTargetSystemCode?: string | null;
  moeIds?: string[];
  mopAggregation?: MopAggregation;
  mopIds?: string[];
  mosIds?: string[];
  owner?: string | null;
  phaseTimingConstraint?: StudyTaskPhaseTimingConstraintDto | null;
  position?: number;
  scoringRole?: ScoringRole;
  /** @format uuid */
  swimlaneId?: string;
  taskName?: string;
}

export interface StudyTasksSelectDto {
  tasks: StudyTaskSelectDto[];
}

export interface StudyTechAssignmentSelectDto {
  /** @format uuid */
  architectureAlternativeId: string;
  /** @format date-time */
  createdAt: string;
  epoch: Epoch;
  /** @format uuid */
  id: string;
  /** @format uuid */
  studyTaskId: string;
  /** @format uuid */
  technologyId: string;
  /** @format date-time */
  updatedAt: string;
}

export interface StudyTechAssignmentsSelectDto {
  techAssignments: StudyTechAssignmentSelectDto[];
}

export interface StudyThreadCreateDto {
  killChainCategory: StudyThreadCreateDtoKillChainCategoryEnum;
  name: string;
  narrative: string;
  position: number;
  primaryEpoch?: Epoch | null;
  role?: StudyThreadRole;
}

export enum StudyThreadCreateDtoKillChainCategoryEnum {
  C2 = "C2",
  COUNTER_UAS = "COUNTER_UAS",
  CUSTOM = "CUSTOM",
  CYBER = "CYBER",
  D3A = "D3A",
  F2T2EA = "F2T2EA",
  ISR = "ISR",
  LOGISTICS = "LOGISTICS",
}

export enum StudyThreadRole {
  PRIMARY = "PRIMARY",
  SHAPING = "SHAPING",
  SUPPORTING = "SUPPORTING",
}

export interface StudyThreadSelectDto {
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  id: string;
  killChainCategory: StudyThreadSelectDtoKillChainCategoryEnum;
  /** @format uuid */
  missionId: string;
  name: string;
  narrative: string;
  position: number;
  primaryEpoch?: Epoch | null;
  role: StudyThreadRole;
  /** @format date-time */
  updatedAt: string;
}

export enum StudyThreadSelectDtoKillChainCategoryEnum {
  C2 = "C2",
  COUNTER_UAS = "COUNTER_UAS",
  CUSTOM = "CUSTOM",
  CYBER = "CYBER",
  D3A = "D3A",
  F2T2EA = "F2T2EA",
  ISR = "ISR",
  LOGISTICS = "LOGISTICS",
}

export interface StudyThreadServiceCreateDto {
  /** @format uuid */
  serviceId: string;
}

export interface StudyThreadServiceSelectDto {
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  id: string;
  /** @format uuid */
  serviceId: string;
  /** @format uuid */
  studyThreadId: string;
  /** @format date-time */
  updatedAt: string;
}

export interface StudyThreadServicesSelectDto {
  services: StudyThreadServiceSelectDto[];
}

export interface StudyThreadThreatTargetCreateDto {
  /** @format uuid */
  studyThreatTargetId: string;
}

export interface StudyThreadThreatTargetSelectDto {
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  id: string;
  /** @format uuid */
  studyThreadId: string;
  /** @format uuid */
  studyThreatTargetId: string;
  /** @format date-time */
  updatedAt: string;
}

export interface StudyThreadThreatTargetsSelectDto {
  threatTargets: StudyThreadThreatTargetSelectDto[];
}

export interface StudyThreadUpdateDto {
  killChainCategory?: StudyThreadUpdateDtoKillChainCategoryEnum;
  name?: string;
  narrative?: string;
  position?: number;
  primaryEpoch?: Epoch | null;
  role?: StudyThreadRole;
}

export enum StudyThreadUpdateDtoKillChainCategoryEnum {
  C2 = "C2",
  COUNTER_UAS = "COUNTER_UAS",
  CUSTOM = "CUSTOM",
  CYBER = "CYBER",
  D3A = "D3A",
  F2T2EA = "F2T2EA",
  ISR = "ISR",
  LOGISTICS = "LOGISTICS",
}

export interface StudyThreadsSelectDto {
  threads: StudyThreadSelectDto[];
}

export interface StudyThreatTargetCreateDto {
  alias?: string | null;
  location?: string | null;
  priority: string;
  threatTargetSystemCode: string;
}

export interface StudyThreatTargetSelectDto {
  alias?: string | null;
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  id: string;
  location?: string | null;
  /** @format uuid */
  missionId: string;
  priority: string;
  threadIds: string[];
  threatTargetSystemCode: string;
  /** @format date-time */
  updatedAt: string;
}

export interface StudyThreatTargetUpdateDto {
  alias?: string | null;
  location?: string | null;
  priority?: string;
  threatTargetSystemCode?: string;
}

export interface StudyThreatTargetsSelectDto {
  threatTargets: StudyThreatTargetSelectDto[];
}

export enum StudyTimeHorizon {
  FAR_TERM_FY36_PLUS = "FAR_TERM_FY36_PLUS",
  FYDP_FY28_30 = "FYDP_FY28_30",
  MID_TERM_FY31_35 = "MID_TERM_FY31_35",
  NEAR_TERM_FY26_27 = "NEAR_TERM_FY26_27",
}

export interface StudyTraceabilitySelectDto {
  traceability: object;
}

export interface StudyTransferOwnershipDto {
  /** @format uuid */
  newOwnerId: string;
}

export interface StudyUpdateDto {
  adversaryProfiles?: StudyAdversaryProfile[];
  classificationLevel?: StudyUpdateDtoClassificationLevelEnum;
  contextNarrative?: string | null;
  description?: string | null;
  environment?: string | null;
  keyOperationalProblem?: string | null;
  name?: string;
  scoringConfig?: StudyScoringConfigDto;
  threatEnvelope?: string | null;
  timeHorizon?: StudyTimeHorizon | null;
}

export enum StudyUpdateDtoClassificationLevelEnum {
  CUI = "CUI",
  SECRET = "SECRET",
  TOP_SECRET = "TOP_SECRET",
  UNCLASSIFIED = "UNCLASSIFIED",
}

export interface StudyValidationResultDto {
  blocking: boolean;
  category: string;
  entityId: string;
  entityType: string;
  megReference: string | null;
  message: string;
  ruleId: string;
  severity: string;
}

export interface StudyValidationResultsSelectDto {
  validationResults: StudyValidationResultDto[];
}

export interface SubsystemCreateDto {
  /** @format uuid */
  categoryId: string;
  components: ComponentCreateDto[];
  /**
   * @format string
   * @maxLength 2000
   */
  description?: string;
  /**
   * @minLength 2
   * @maxLength 60
   */
  name: string;
  origin?: string;
  /** @format uuid */
  subcategoryId: string;
  /** @format uuid */
  technologyId: string;
  /** @format string */
  type: TechnologyType;
}

export interface SubsystemSelectDto {
  category: CategoryNestedSelectDto;
  components: ComponentSelectDto[];
  /** @format date-time */
  createdAt: string;
  /**
   * @format string
   * @maxLength 2000
   */
  description?: string;
  /** @format uuid */
  id: string;
  /**
   * @minLength 2
   * @maxLength 60
   */
  name: string;
  origin?: string;
  subcategory: CategoryNestedSelectDto;
  /** @format string */
  type: TechnologyType;
}

export interface SubsystemUpdateDto {
  /** @format uuid */
  categoryId?: string;
  components: ComponentUpdateDto[];
  /**
   * @format string
   * @maxLength 2000
   */
  description?: string;
  /**
   * @minLength 2
   * @maxLength 60
   */
  name?: string;
  origin?: string;
  /** @format uuid */
  subcategoryId?: string;
  /** @format uuid */
  technologyId?: string;
  /** @format string */
  type?: TechnologyType;
}

export interface SurveyCreateDto {
  assessmentSubtype?: AssessmentSubtype;
  assessmentType: AssessmentType;
  /** @format uuid */
  missionAssessmentId?: string;
  /** @format uuid */
  technologyId: string;
  uses?: SurveyUseCreateDto[];
}

export interface SurveyListSelectDto {
  answers: AnswerNestedSelectDto[];
  assessmentSubtype: AssessmentSubtype;
  assessmentType: AssessmentType;
  /** @format uuid */
  createdAssessmentId?: string;
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  id: string;
  /** @format uuid */
  missionAssessmentId?: string;
  productionRate?: SurveyProductionRateDto | null;
  progress: number;
  snapshot: SurveySnapshotSelectDto;
  status: SurveyStatus;
  surveyUseDomains: SurveyUseDomainNestedSelectDto[];
  technology: TechnologyNestedSelectDto;
}

export interface SurveyProductionRateAssumptionDto {
  inPlace: boolean;
  qualifier?: string;
}

export interface SurveyProductionRateAssumptionsDto {
  criticalMaterials: SurveyProductionRateAssumptionDto;
  facilityTooling: SurveyProductionRateAssumptionDto;
  funding: SurveyProductionRateAssumptionDto;
  regulatory: SurveyProductionRateAssumptionDto;
  supplyChain: SurveyProductionRateAssumptionDto;
  workforce: SurveyProductionRateAssumptionDto;
}

export interface SurveyProductionRateDto {
  assumptions: SurveyProductionRateAssumptionsDto;
  fullRateProduction: SurveyProductionRateFullRateDto;
  lowRateProduction: SurveyProductionRateLowRateDto;
  surgeProduction: SurveyProductionRateSurgeDto;
}

export interface SurveyProductionRateFullRateDto {
  evidence: string;
  leadTimeWeeks: number;
  rateUnitsPerMonth: number;
}

export interface SurveyProductionRateLowRateDto {
  durationMonths: number;
  evidence: string;
  rateUnitsPerMonth: number;
}

export enum SurveyProductionRatePrimaryConstraint {
  Facility = "facility",
  Funding = "funding",
  Materials = "materials",
  SubTier = "sub_tier",
  Tooling = "tooling",
  Workforce = "workforce",
}

export interface SurveyProductionRateSurgeDto {
  evidence: string;
  peakRateUnitsPerMonth: number;
  primaryConstraint: SurveyProductionRatePrimaryConstraint;
  rampTimeWeeks: number;
}

export interface SurveySelectDto {
  answers: AnswerNestedSelectDto[];
  assessmentSubtype: AssessmentSubtype;
  assessmentType: AssessmentType;
  /** @format uuid */
  createdAssessmentId?: string;
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  id: string;
  /** @format uuid */
  missionAssessmentId?: string;
  productionRate?: SurveyProductionRateDto | null;
  progress: number;
  questions: QuestionSelectDto[];
  snapshot: SurveySnapshotSelectDto;
  status: SurveyStatus;
  surveyUseDomains: SurveyUseDomainNestedSelectDto[];
  technology: TechnologyNestedSelectDto;
}

export enum SurveySnapshotChapterIdentifier {
  MAIN_QUESTIONS = "MAIN_QUESTIONS",
  BASELINE_QUESTIONS = "BASELINE_QUESTIONS",
  USE_QUESTIONS = "USE_QUESTIONS",
}

export interface SurveySnapshotChapterSelectDto {
  description?: string;
  /** @format uuid */
  id: string;
  identifier?: SurveySnapshotChapterIdentifier;
  name: string;
  sections: SurveySnapshotSectionSelectDto[];
}

export interface SurveySnapshotSectionSelectDto {
  description?: string;
  /** @format uuid */
  id: string;
  name: string;
  questions: string[];
}

export interface SurveySnapshotSelectDto {
  chapters: SurveySnapshotChapterSelectDto[];
}

export enum SurveyStatus {
  COMPLETE = "COMPLETE",
  DRAFT = "DRAFT",
}

export interface SurveyUseCreateDto {
  /** @format uuid */
  domainId: string;
  /** @format uuid */
  useId: string;
}

export interface SurveyUseDomainDomainDto {
  /** @format uuid */
  id: string;
  name: string;
}

export interface SurveyUseDomainNestedSelectDto {
  domain: SurveyUseDomainDomainDto;
  /** @format uuid */
  domainId: string;
  /** @format uuid */
  id: string;
  use: SurveyUseDomainUseDto;
  /** @format uuid */
  useId: string;
}

export interface SurveyUseDomainUseDto {
  /** @format uuid */
  id: string;
  name: string;
}

export interface SurveysSelectDto {
  surveys: SurveyListSelectDto[];
}

export enum SwimlaneMeasuresStatus {
  COMPLETE = "COMPLETE",
  EMPTY = "EMPTY",
  PARTIAL = "PARTIAL",
}

export interface TRLAssessmentHistoryItem {
  /**
   * Assessment ID (null for TRL1 synthetic entry)
   * @format uuid
   */
  assessmentId?: string;
  /**
   * Assessment date and time in ISO format
   * @format date-time
   */
  date: string;
  /** TRL assessment score */
  score: number;
}

export interface TagSelectDto {
  /** @format uuid */
  id: string;
  name: string;
}

export interface TagsSelectDto {
  tags: TagSelectDto[];
}

export interface TargetSystemSelectDto {
  /** @format uuid */
  id: string;
  name: string;
}

export interface TargetSystemsSelectDto {
  targetSystems: TargetSystemSelectDto[];
}

export interface TechnologiesListSelectDto {
  technologies: TechnologyListSelectDto[];
}

export interface TechnologiesSelectDto {
  technologies: TechnologySelectDto[];
}

export interface TechnologyContributorCreateDto {
  /** @format date */
  contributionsEndDate?: string | null;
  /** @format date */
  contributionsStartDate?: string | null;
  /** @format uuid */
  userId: string;
}

export interface TechnologyContributorSelectDto {
  /** @format date */
  contributionsEndDate?: string | null;
  /** @format date */
  contributionsStartDate?: string | null;
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  id: string;
  /** @format uuid */
  technologyId: string;
  user: TechnologyContributorUserDto;
  /** @format uuid */
  userId: string;
}

export interface TechnologyContributorUpdateDto {
  /** @format date */
  contributionsEndDate?: string | null;
  /** @format date */
  contributionsStartDate?: string | null;
  /** @format uuid */
  userId?: string;
}

export interface TechnologyContributorUserDto {
  avatarUrl?: string;
  email: string;
  /** @format uuid */
  id: string;
  profile?: TechnologyContributorUserProfileDto;
}

export interface TechnologyContributorUserProfileDto {
  /** @format string */
  country?: string;
  /** @format string */
  firstName: string;
  /** @format string */
  fullName: string;
  /** @format uuid */
  id: string;
  /** @format string */
  lastName: string;
  /**
   * @format string
   * @minLength 2
   * @maxLength 60
   */
  title: string;
}

export interface TechnologyContributorsSelectDto {
  contributors: TechnologyContributorSelectDto[];
}

export interface TechnologyCreateDto {
  attachments?: InlineAttachmentCreateDto[];
  /** @format uuid */
  categoryId: string;
  /** @maxLength 2000 */
  description?: string;
  metadata?: TechnologyMetadata;
  /**
   * @minLength 2
   * @maxLength 60
   */
  name: string;
  /** @format uuid */
  primaryDomainId: string;
  /** @format uuid */
  primarySubdomainId?: string;
  /** @format string */
  primaryUseDescription?: string;
  /** @format string */
  primaryUseId: string;
  subcategoryId: string;
  timeline?: TechnologyTimeline;
  /** @format string */
  type: TechnologyType;
}

export interface TechnologyCreateResponseDto {
  pendingUploads?: PendingUploadDto[];
  technology: TechnologySelectDto;
}

export interface TechnologyListSelectDto {
  /** @format uuid */
  id: string;
  /** @format string */
  name: string;
}

export interface TechnologyMetadata {
  /** @deprecated */
  referenceUrls?: ReferenceUrlDto[];
  researchKeywords?: string[];
}

export interface TechnologyNestedSelectDto {
  category?: CategoryNestedSelectDto;
  company?: CompanyTechnologyNestedSelectDto;
  createdAt: string;
  /** @format uuid */
  id: string;
  /**
   * @minLength 2
   * @maxLength 60
   */
  name: string;
  subcategory?: CategoryNestedSelectDto;
}

export interface TechnologySelectDto {
  category: CategoryNestedSelectDto;
  company?: CompanyTechnologyNestedSelectDto;
  createdAt: string;
  /** @maxLength 2000 */
  description?: string;
  /** @format uuid */
  id: string;
  metadata?: TechnologyMetadata;
  missionAssessmentRequests: MissionAssessmentRequestSelectDto[];
  /**
   * @minLength 2
   * @maxLength 60
   */
  name: string;
  subcategoryId: string;
  subsystems?: SubsystemSelectDto[];
  timeline?: TechnologyTimeline;
  /** @format string */
  type: TechnologyType;
  uses: TechnologyUseSelectDto[];
}

export interface TechnologySimilarTechnologiesUpsertDto {
  /** Target assessment id. Defaults to primary TRL. */
  assessmentId?: string;
  provenance?: FieldProvenanceInputDto;
  similarTechnologiesSummary: SimilarTechnologySummaryDto;
}

export interface TechnologyTimeline {
  /** @format string */
  description?: string;
  /**
   * ISO date string (YYYY-MM-DD)
   * @format date
   */
  startDate?: string;
  /**
   * @deprecated
   * @format number
   */
  startMonth?: number;
  /**
   * @deprecated
   * @format number
   */
  startYear?: number;
  /** @format boolean */
  validated?: boolean;
}

export enum TechnologyTrlAnalysisChatKind {
  SIMILAR_TECHNOLOGIES = "SIMILAR_TECHNOLOGIES",
  TRL_SUMMARY = "TRL_SUMMARY",
}

export interface TechnologyTrlAnalysisChatQueryDto {
  /** Target assessment id. Defaults to primary TRL. */
  assessmentId?: string;
  kind: TechnologyTrlAnalysisChatKind;
  messages: ChatMessageDto[];
  model?: LlmModel;
}

export interface TechnologyTrlAnalysisNestedSelectDto {
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  id: string;
  /** AI provenance per field (ADR-0007), keyed by field name. Absent fields are human-authored. */
  provenance?: Record<string, FieldProvenanceDto>;
  similarTechnologiesSummary: SimilarTechnologySummaryDto;
  trlAnalysisSummary: TrlAnalysisSummaryDto;
}

export interface TechnologyTrlAnalysisSelectDto {
  assessment: AssessmentNestedSelectDto;
  /** @format date-time */
  createdAt: string;
  /** @format uuid */
  id: string;
  /** AI provenance per field (ADR-0007), keyed by field name. Absent fields are human-authored. */
  provenance?: Record<string, FieldProvenanceDto>;
  similarTechnologiesSummary: SimilarTechnologySummaryDto;
  technology: TechnologyNestedSelectDto;
  trlAnalysisSummary: TrlAnalysisSummaryDto;
  /** @format date-time */
  updatedAt: string;
}

export interface TechnologyTrlAnalysisSummaryUpsertDto {
  /** Target assessment id. Defaults to primary TRL. */
  assessmentId?: string;
  provenance?: FieldProvenanceInputDto;
  trlAnalysisSummary: TrlAnalysisSummaryDto;
}

export enum TechnologyTrlProjectionAnalysisStatus {
  Empty = "empty",
  Fresh = "fresh",
  Stale = "stale",
  Unavailable = "unavailable",
}

export enum TechnologyTrlProjectionConfidenceLabel {
  High = "high",
  Low = "low",
  Medium = "medium",
}

export interface TechnologyTrlProjectionLlmQueryDto {
  /** Target assessment id. Defaults to the featured TRL assessment. */
  assessmentId?: string;
  model?: LlmModel;
  /** @maxLength 2000 */
  prompt?: string;
}

export interface TechnologyTrlProjectionSelectDto {
  /** @format date-time */
  analysisGeneratedAt?: string;
  analysisStatus: TechnologyTrlProjectionAnalysisStatus;
  /** @format uuid */
  assessmentId?: string;
  /** @format date-time */
  baseDate?: string;
  baseTrl?: number;
  canRegenerateAnalysis: boolean;
  confidenceAnalysis?: string;
  confidenceScore?: number;
  maxMonths: number;
  missingInputs: string[];
  points: TrlProjectionPointDto[];
  projectionConfidenceLabel: TechnologyTrlProjectionConfidenceLabel;
  targets: TrlProjectionTargetDto[];
}

export enum TechnologyType {
  HARDWARE = "HARDWARE",
  HYBRID = "HYBRID",
  SOFTWARE = "SOFTWARE",
}

export interface TechnologyUpdateDto {
  attachments?: InlineAttachmentCreateDto[];
  /** @format uuid */
  categoryId?: string;
  /** @maxLength 2000 */
  description?: string;
  metadata?: TechnologyMetadata;
  /**
   * @minLength 2
   * @maxLength 60
   */
  name?: string;
  /** @format uuid */
  primaryDomainId?: string;
  /** @format uuid */
  primarySubdomainId?: string;
  /** @format string */
  primaryUseDescription?: string;
  /** @format string */
  primaryUseId?: string;
  productIds?: string[];
  subcategoryId?: string;
  timeline?: TechnologyTimeline;
  /** @format string */
  type?: TechnologyType;
}

export interface TechnologyUseCreateDto {
  /** @format string */
  description?: string;
  domains: DomainCreateDto[];
  isPrimaryUse: boolean;
  /** @format uuid */
  technologyId: string;
  /** @format uuid */
  useId: string;
}

export interface TechnologyUseDeleteDto {
  /** @format uuid */
  technologyId: string;
}

export interface TechnologyUsePatchDto {
  /** @format string */
  description?: string;
  domains?: DomainCreateDto[];
  isPrimaryUse?: boolean;
  /** @format uuid */
  technologyId?: string;
  /** @format uuid */
  useId?: string;
}

export interface TechnologyUseSelectDto {
  /** @format date-time */
  createdAt: string;
  /** @format string */
  description?: string;
  domains: DomainNestedSelectDto[];
  /** @format uuid */
  id: string;
  /** @format string */
  name: string;
  position: number;
  /** @format uuid */
  technologyId: string;
  /** @format uuid */
  useId: string;
}

export interface TechnologyUseWithAssessmentsDto {
  /** @format date-time */
  createdAt: string;
  domains: DomainWithAssessmentDto[];
  /** @format uuid */
  id: string;
  /** @format string */
  name: string;
  /** @format uuid */
  technologyId: string;
}

export interface TechnologyUsesWithAssessmentsDto {
  uses: TechnologyUseWithAssessmentsDto[];
}

export interface TrlAnalysisSummaryDto {
  confidence: number;
  scoreAnalysis: string;
}

export interface TrlFilterQuestionDto {
  answerOptions: AnswerResponseProgress[];
  /** @format uuid */
  id: string;
  position: number;
  prompt: string;
}

export interface TrlFilterQuestionsSelectDto {
  questions: TrlFilterQuestionDto[];
}

export interface TrlProjectionPointDto {
  p10: number;
  p50: number;
  p90: number;
  month: number;
}

export interface TrlProjectionTargetDto {
  p10Months: number;
  p50Months: number;
  p90Months: number;
  deterministicDrivers: string[];
  dominantDriversNarrative?: string;
  label: string;
  targetTrl: number;
}

export interface TrlTimelineByUseDomainItem {
  /** @format uuid */
  domainId: string;
  domainName: string;
  timeline: TRLAssessmentHistoryItem[];
  /** @format uuid */
  useId: string;
  useName: string;
}

export interface UpdateChallengeDto {
  challengePhases?: ChallengePhaseDto[];
  /** @maxLength 2000 */
  description?: string;
  /**
   * @minLength 2
   * @maxLength 60
   */
  name?: string;
}

export interface UseSelectDto {
  archived: boolean;
  /** @format date-time */
  archivedAt?: string;
  /** @format string */
  description?: string;
  /** @format uuid */
  id: string;
  /** @format string */
  name: string;
}

export interface UserCompanyNestedSelectDto {
  /** @format uuid */
  id: string;
  role: UserCompanyNestedSelectDtoRoleEnum;
}

export enum UserCompanyNestedSelectDtoRoleEnum {
  Admin = "Admin",
  Collaborator = "Collaborator",
}

export interface UserCompanyPatchDto {
  role: UserCompanyPatchDtoRoleEnum;
}

export enum UserCompanyPatchDtoRoleEnum {
  Admin = "Admin",
  Collaborator = "Collaborator",
}

export enum UserCompanyRole {
  Admin = "Admin",
  Collaborator = "Collaborator",
}

export interface UserCompanySelectDto {
  /** @format string */
  city?: string;
  cmmcLevel?: CmmcLevel;
  /** @format string */
  country?: string;
  /**
   * @format string
   * @maxLength 2000
   */
  description?: string;
  featureFlags: CompanyFeatureFlag[];
  /** @format uuid */
  id: string;
  invites: InviteNestedSelectDto[];
  /** @format boolean */
  isParentOrganization: boolean;
  /** @format string */
  logoUrl?: string;
  /**
   * @format string
   * @minLength 2
   * @maxLength 60
   */
  name: string;
  /** @format uuid */
  parentOrganizationId?: object;
  previousGovernmentWorkCountries?: string[];
  previousGovernmentWorkServices?: ServiceSubSelectDto[];
  researchOrganizationData?: ResearchOrganizationDataDto;
  revenue?: CompanyRevenueDto;
  /** @format string */
  samsUeiNumber?: string;
  slug?: string | null;
  /** @format string */
  state?: string;
  type: CompanyType;
  urls?: CompanyUrlsDto;
  /** @format integer */
  yearFounded?: number;
}

export enum UserFeatureFlag {
  CYBER_ASSESSMENTS_TOOL = "CYBER_ASSESSMENTS_TOOL",
  INSIGHTS_TOOL = "INSIGHTS_TOOL",
  MEIA_STUDIO_V1 = "MEIA_STUDIO_V1",
  MEIA_STUDIO_V2 = "MEIA_STUDIO_V2",
  ORG_SWITCHER = "ORG_SWITCHER",
  RESEARCH_TOOL = "RESEARCH_TOOL",
  THREADS_TOOL = "THREADS_TOOL",
  TRL_PREDICTION = "TRL_PREDICTION",
}

export interface UserNestedSelectDto {
  /** @format string */
  avatarUrl?: string;
  /** @format email */
  email: string;
  /** @format uuid */
  id: string;
}

export interface UserNestedSelectFromCompanyDto {
  /** @format string */
  avatarUrl?: string;
  /** @format email */
  email: string;
  /** @format uuid */
  id: string;
  profile?: UserProfileSelectDto;
  userCompany?: UserCompanyNestedSelectDto;
}

export interface UserProfileCreateDto {
  /** @format uuid */
  categoryId?: string;
  /** @format string */
  country?: string;
  /** @format string */
  countryCode?: string;
  /** @format string */
  firstName: string;
  hasAcceptedTerms: boolean;
  /** @format uuid */
  jobRoleId?: string;
  /** @format string */
  lastName: string;
  phoneNumber?: string;
  /**
   * User's referrer code
   * @format uuid
   */
  referrerCode?: string;
  researchKeywordIds?: string[];
  /** User role */
  role: UserProfileRole;
  /** @format uuid */
  subcategoryId?: string | null;
  /**
   * @format string
   * @minLength 2
   * @maxLength 60
   */
  title: string;
}

export interface UserProfilePatchDto {
  /** @format uuid */
  categoryId?: string;
  /** @format string */
  country?: string;
  /** @format string */
  countryCode?: string;
  /** @format string */
  firstName?: string;
  hasAcceptedTerms?: boolean;
  /** @format uuid */
  jobRoleId?: string;
  /** @format string */
  lastName?: string;
  phoneNumber?: string;
  /**
   * User's referrer code
   * @format uuid
   */
  referrerCode?: string;
  researchKeywordIds?: string[];
  /** @format uuid */
  subcategoryId?: string | null;
  /**
   * @format string
   * @minLength 2
   * @maxLength 60
   */
  title?: string;
}

export enum UserProfileRole {
  ADMIN = "ADMIN",
  EXPERT = "EXPERT",
  INTELLIGENCE = "INTELLIGENCE",
  INNOVATOR = "INNOVATOR",
}

export interface UserProfileSelectDto {
  category?: CategoryNestedSelectDto;
  /** @format uuid */
  categoryId?: string;
  /** @format string */
  country?: string;
  /** @format string */
  countryCode?: string;
  /** @format string */
  firstName: string;
  /** @format string */
  fullName: string;
  hasAcceptedTerms: boolean;
  /** @format uuid */
  id: string;
  jobRole?: JobRoleSelectDto;
  /** @format uuid */
  jobRoleId?: string;
  /** @format string */
  lastName: string;
  phoneNumber?: string;
  /**
   * User's referral code
   * @format uuid
   */
  referralCode: string;
  /**
   * User's referrer code
   * @format uuid
   */
  referrerCode?: string;
  researchKeywords?: ResearchKeywordSelectDto[];
  role: UserProfileRole;
  subcategory?: CategoryNestedSelectDto;
  /** @format uuid */
  subcategoryId?: string | null;
  /**
   * @format string
   * @minLength 2
   * @maxLength 60
   */
  title: string;
}

export interface UserSelectDto {
  /** @format date-time */
  accessExpiredAt?: string | null;
  approved: boolean;
  /** @format string */
  avatarUrl?: string;
  companies?: UserCompanySelectDto[];
  /** @format date-time */
  createdAt: string;
  /** @format email */
  email: string;
  emailVerified: boolean;
  expertProfile?: ExpertProfileSelectDto;
  featureFlags?: UserFeatureFlag[];
  hasAccessExpired: boolean;
  hasValidAccess: boolean;
  /** @format uuid */
  id: string;
  impersonation?: ImpersonationSelectDto;
  invites?: InviteSelectDto[];
  profile?: UserProfileSelectDto;
  reasonBlocked?: string;
  selectedCompanyId?: string;
  selectedCompanyPersona?: IntelligencePersona;
  selectedCompanyRole?: UserCompanyRole;
  status: UserStatus;
  tags?: string[];
}

export enum UserStatus {
  PENDING = "PENDING",
  APPROVED = "APPROVED",
  BLOCKED = "BLOCKED",
}

export interface UsersNestedSelectFromCompanyDto {
  users: UserNestedSelectFromCompanyDto[];
}

export interface UsesSelectDto {
  uses: UseSelectDto[];
}

export interface ValidationIssueDto {
  blocking: boolean;
  category: string;
  entityId: string;
  entityType: string;
  megReference: object | null;
  message: string;
  ruleId: string;
  severity: string;
}

export enum VerificationConfidence {
  HIGH = "HIGH",
  MEDIUM = "MEDIUM",
  LOW = "LOW",
}

export enum WorkflowGate {
  P0 = "P0",
  P1 = "P1",
  P2 = "P2",
  P3 = "P3",
  P4 = "P4",
}

export interface WorkflowGateAuditSelectDto {
  gate: WorkflowGate;
  ready: boolean;
  rules: WorkflowGateRuleAuditDto[];
}

export interface WorkflowGateReadinessSelectDto {
  blocking: ValidationIssueDto[];
  gate: WorkflowGate;
  issues: ValidationIssueDto[];
  ready: boolean;
  warnings: ValidationIssueDto[];
}

export interface WorkflowGateRuleAuditDto {
  blocking: boolean;
  category: string;
  description: string;
  entityType: string;
  failureEntityId?: string | null;
  failureMessage?: string | null;
  ruleId: string;
  severity: string;
  status: WorkflowGateRuleAuditDtoStatusEnum;
}

export enum WorkflowGateRuleAuditDtoStatusEnum {
  Pass = "pass",
  Fail = "fail",
}
